/**
 * src/data/glossaryContent.js — nội dung đầy đủ của từng trang từ điển.
 *
 * Tách khỏi glossary.js vì hai file có nhịp thay đổi khác nhau: khung 80 mục
 * gần như cố định, còn nội dung được viết dần từng đợt. Trang nào có nội dung
 * ở đây thì tự động chuyển sang trạng thái đã xuất bản và lên sitemap.
 *
 * ─────────────────────────────────────────────────────────────────────────
 * QUY TẮC VIẾT — giữ nguyên cho mọi trang
 *
 * 1. Câu đầu tiên phải trả lời thẳng câu hỏi. Người đọc gõ "SAFE là gì" cần
 *    biết ngay, không cần đoạn dẫn nhập.
 * 2. Ví dụ bằng số VNĐ, không phải đô la. Founder Việt Nam ước lượng bằng tiền
 *    Việt; quy đổi trong đầu làm mất mạch đọc.
 * 3. Mục "sai lầm thường gặp" là phần người đọc nhớ lâu nhất — không được bỏ.
 * 4. Không dùng thuật ngữ chưa giải thích. Cần thì dẫn sang trang từ điển khác.
 * 5. Mỗi trang dẫn tới ít nhất một công cụ. Trang không dẫn đi đâu chỉ là bài
 *    viết, không phải sản phẩm.
 * ─────────────────────────────────────────────────────────────────────────
 */

import { VIET_LAI } from './glossaryVietLai.js';
import { NOI_DUNG_MOI } from './glossaryMoi.js';

export const NOI_DUNG = {
  'runway-la-gi': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Runway là số tháng doanh nghiệp còn hoạt động được với lượng tiền đang có, nếu mọi thứ giữ nguyên như hiện tại. Lấy tiền mặt chia cho số tiền thực sự mất đi mỗi tháng.',
          'Đây là con số đầu tiên gần như mọi nhà đầu tư hỏi, và cũng là con số quyết định bạn đàm phán ở thế mạnh hay thế yếu. Người còn mười hai tháng và người còn ba tháng ngồi vào cùng một bàn với hai vị thế hoàn toàn khác nhau.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Giả sử tài khoản còn 560 triệu. Mỗi tháng chi hết 168 triệu và thu về 31 triệu. Số tiền thực sự mất đi là 168 − 31 = 137 triệu.',
          'Runway = 560 ÷ 137 ≈ 4,1 tháng.',
          'Điểm dễ nhầm nằm ở chỗ này: nhiều người lấy 560 chia cho 168 và ra 3,3 tháng, hoặc quên trừ doanh thu và tưởng mình có ít thời gian hơn thực tế. Con số đúng phải trừ doanh thu, vì đó là tiền đang chảy vào bù lại.',
        ],
      },
      {
        h: 'Bao nhiêu tháng thì nên bắt đầu gọi vốn',
        p: [
          'Một vòng angel hoặc pre-seed ở Việt Nam thường mất ba tới sáu tháng tính từ lúc bắt đầu gặp nhà đầu tư tới lúc tiền về tài khoản. Vì vậy nên bắt đầu khi còn ít nhất chín tới mười hai tháng.',
          'Dưới sáu tháng, bạn sẽ phải nhận điều khoản bên kia đưa ra. Nhà đầu tư có kinh nghiệm nhận ra tình trạng đó rất nhanh. Họ chỉ cần hỏi tiền mặt còn bao nhiêu và chi mỗi tháng bao nhiêu.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Lấy một tháng làm chuẩn. Một khoản chi bất thường như đóng bảo hiểm cả năm hay mua thiết bị làm lệch hẳn con số. Trung bình ba tháng ổn định hơn nhiều.',
          'Quên các khoản sắp tới. Lương tháng mười ba, thuế phải nộp, hợp đồng thuê văn phòng sắp gia hạn đều là tiền sẽ ra khỏi tài khoản nhưng chưa xuất hiện trong chi phí tháng vừa rồi.',
          'Giả định doanh thu sẽ tăng đúng kế hoạch. Runway nên tính theo tình hình hiện tại, còn phần tăng trưởng để riêng ở kịch bản lạc quan.',
        ],
      },
    ],
    faq: [
      {
        q: 'Runway và burn rate khác nhau thế nào?',
        a: 'Burn rate là số tiền mất đi mỗi tháng. Runway là số tháng còn lại, tính bằng tiền mặt chia cho burn rate. Một cái là tốc độ, một cái là quãng đường còn lại.',
      },
      {
        q: 'Đã có lãi thì runway bằng bao nhiêu?',
        a: 'Khi doanh thu bù được chi phí thì runway không giới hạn theo mức hiện tại. Nhưng vẫn nên chạy kịch bản thận trọng, chỉ cần chi phí tăng hai mươi phần trăm là quay lại trạng thái đốt tiền.',
      },
      {
        q: 'Nên tính runway theo tháng gần nhất hay trung bình?',
        a: 'Trung bình ba tháng cho con số ổn định hơn. Nếu vừa có thay đổi lớn về nhân sự hoặc chi phí thì tháng gần nhất phản ánh đúng hiện trạng hơn.',
      },
    ],
  },

  'safe-la-gi': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'SAFE là thoả thuận cho phép nhà đầu tư đưa tiền vào ngay bây giờ và nhận cổ phần ở vòng gọi vốn sau. Nó không phải khoản vay: không lãi suất, không ngày đáo hạn, và nhà đầu tư không đòi lại tiền được.',
          'Điểm hấp dẫn là hai bên không phải thoả thuận định giá ngay, thứ rất khó làm khi công ty còn quá sớm để định giá có ý nghĩa.',
        ],
      },
      {
        h: 'Hai điều khoản quyết định mọi thứ',
        p: [
          'Cap định giá là mức trần dùng để quy đổi. Bạn ký SAFE 500 triệu với cap 8 tỷ, nghĩa là dù vòng sau công ty được định giá bao nhiêu, nhà đầu tư này vẫn được tính như thể công ty trị giá 8 tỷ.',
          'Discount là mức chiết khấu so với giá vòng sau, thường 15–25%. Vòng sau bán một cổ phần giá 20.000 đồng, người có SAFE discount 20% mua ở giá 16.000 đồng.',
          'Có cả hai thì nhà đầu tư chọn phương án nào cho họ nhiều cổ phần hơn, không cộng dồn cả hai.',
        ],
      },
      {
        h: 'Vậy 500 triệu cap 8 tỷ là bán bao nhiêu phần trăm',
        p: [
          'Rất nhiều người trả lời 6,25%, lấy 500 triệu chia 8 tỷ. Con số đó chỉ đúng trong trường hợp đơn giản nhất.',
          'Nếu là SAFE post-money, bản chuẩn từ năm 2018, thì nhà đầu tư giữ đúng 6,25% công ty sau khi mọi SAFE đã chuyển đổi, nhưng trước khi tiền vòng mới vào. Sau khi vòng mới lấy đi 20% nữa, phần của họ còn khoảng 5%.',
          'Nếu có thêm SAFE khác, hoặc quỹ cổ phiếu thưởng mở rộng ở vòng đó, con số lại khác nữa. Đây là lý do nên tính bằng công cụ thay vì nhẩm.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Ký nhiều SAFE mà không cộng lại. Mỗi bản ký riêng lẻ đều trông nhỏ, nhưng bốn bản mỗi bản 5% là 20% công ty đã hứa trước khi vòng đầu tiên diễn ra, và toàn bộ phần đó do người sáng lập gánh.',
          'Nhầm giữa bản pre-money và post-money. Hai bản tính pha loãng theo cách khác nhau. Bản post-money có chữ "post-money" ngay trong tiêu đề văn bản; nếu không thấy, khả năng cao bạn đang cầm bản cũ.',
          'Coi cap là định giá. Cap không phải giá trị công ty, nó chỉ là mức trần dùng để quy đổi sau này. Nói với người khác rằng công ty được định giá 8 tỷ vì ký SAFE cap 8 tỷ là nói sai.',
        ],
      },
    ],
    faq: [
      {
        q: 'SAFE khác trái phiếu chuyển đổi ở chỗ nào?',
        a: 'Trái phiếu chuyển đổi là khoản vay, có lãi suất và ngày đáo hạn, tới hạn mà chưa có vòng mới thì về nguyên tắc phải trả tiền. SAFE không có hai thứ đó, nên nhẹ nhàng hơn cho doanh nghiệp giai đoạn sớm.',
      },
      {
        q: 'SAFE có hợp pháp ở Việt Nam không?',
        a: 'SAFE là mẫu hợp đồng của Mỹ, không có khuôn khổ riêng trong pháp luật Việt Nam. Trên thực tế nhiều thương vụ vẫn dùng, thường qua pháp nhân nước ngoài hoặc điều chỉnh thành thoả thuận đặt cọc mua cổ phần. Đây là chỗ bắt buộc phải hỏi luật sư.',
      },
      {
        q: 'Khi nào SAFE chuyển thành cổ phần?',
        a: 'Ở vòng gọi vốn có định giá tiếp theo. Nếu không bao giờ có vòng đó, SAFE thường vẫn nằm im. Đây là rủi ro nhà đầu tư chấp nhận khi ký.',
      },
    ],
  },

  'pha-loang-co-phan': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Pha loãng là việc tỷ lệ sở hữu của bạn giảm xuống khi công ty phát hành thêm cổ phần cho người mới. Số cổ phần bạn cầm không đổi, nhưng nó chiếm phần nhỏ hơn trong một chiếc bánh đã to ra.',
          'Đây không phải điều xấu. Sở hữu 60% của một công ty trị giá 100 tỷ tốt hơn nhiều so với 100% của một công ty trị giá 5 tỷ. Vấn đề chỉ nảy sinh khi pha loãng nhiều mà giá trị không tăng tương xứng.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Hai người sáng lập chia nhau 1.000.000 cổ phần, mỗi người 50%. Vòng pre-seed gọi 6 tỷ trên định giá pre-money 24 tỷ, tức định giá post-money 30 tỷ. Nhà đầu tư nhận 6/30 = 20% công ty.',
          'Hai người sáng lập giờ mỗi người còn 40%. Số cổ phần vẫn là 500.000 mỗi người, nhưng tổng số cổ phần đã tăng lên.',
          'Nếu vòng đó còn lập quỹ cổ phiếu thưởng 10% lấy từ phần pre-money, mỗi người chỉ còn 35%. Ba mươi điểm phần trăm đã mất chỉ trong một vòng trông có vẻ bình thường.',
        ],
      },
      {
        h: 'Ba nguồn pha loãng hay bị bỏ sót',
        p: [
          'Quỹ cổ phiếu thưởng cho nhân sự. Nếu lấy từ phần pre-money thì chỉ cổ đông cũ gánh, nhà đầu tư mới không mất gì. Đây là điều khoản đàm phán được, nhưng ít người mới biết để đàm phán.',
          'SAFE cũ chuyển đổi. Khoản 500 triệu ký từ một năm trước bỗng thành mấy phần trăm công ty đúng vào vòng này.',
          'Quyền mua thêm của nhà đầu tư cũ. Họ có quyền bỏ thêm tiền để giữ nguyên tỷ lệ, và phần đó cũng lấy từ chỗ của bạn.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Chỉ nhìn một vòng. Mỗi vòng riêng lẻ đều hợp lý, nhưng ba vòng liên tiếp có thể đưa nhóm sáng lập từ 100% xuống dưới 40%. Phải nhìn cả chuỗi mới thấy.',
          'Cố giữ tỷ lệ bằng cách gọi thật ít. Gọi quá ít khiến không đủ tiền đạt cột mốc, và vòng sau phải gọi ở định giá không cao hơn bao nhiêu, pha loãng cuối cùng còn nhiều hơn.',
          'Nghĩ rằng giữ trên 51% là giữ được quyền kiểm soát. Quyền kiểm soát thực tế nằm ở điều lệ và điều khoản trong hợp đồng đầu tư nhiều hơn ở con số phần trăm.',
        ],
      },
    ],
    faq: [
      {
        q: 'Sau ba vòng nên còn bao nhiêu phần trăm?',
        a: 'Thông lệ là giữ 70–85% sau vòng đầu và trên 50% sau Series A. Dưới 40% khi mới qua vài vòng là cấu trúc khó gọi tiếp.',
      },
      {
        q: 'Có cách nào tránh pha loãng không?',
        a: 'Chỉ có cách không gọi vốn. Còn khi đã gọi thì mục tiêu không phải tránh pha loãng mà là đảm bảo mỗi lần pha loãng đổi lại được giá trị tương xứng.',
      },
      {
        q: 'Nhà đầu tư cũ có bị pha loãng không?',
        a: 'Có, trừ khi họ dùng quyền mua thêm để giữ tỷ lệ. Ở vòng sau, cả người sáng lập lẫn nhà đầu tư vòng trước đều bị pha loãng bởi người mới.',
      },
    ],
  },

  'esop-la-gi': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'ESOP là phần cổ phần công ty dành sẵn để thưởng cho nhân sự. Nó chưa thuộc về ai cụ thể, được giữ lại như một quỹ, rồi cấp dần cho người được tuyển.',
          'Quy mô thông lệ ở giai đoạn đầu là 10–15% công ty.',
        ],
      },
      {
        h: 'Vì sao nhà đầu tư luôn yêu cầu lập',
        p: [
          'Startup giai đoạn sớm không trả nổi mức lương thị trường cho người giỏi. Cổ phần là thứ bù vào khoảng chênh đó. Không có quỹ nào dành sẵn thì mỗi lần tuyển một người quan trọng lại phải mở một cuộc đàm phán mới với toàn bộ cổ đông.',
          'Nhà đầu tư yêu cầu lập trước khi họ vào, vì nếu lập sau thì chính họ cũng bị pha loãng theo.',
        ],
      },
      {
        h: 'Điều khoản tốn tiền nhất mà ít ai để ý',
        p: [
          'Câu hỏi quyết định là quỹ này lấy từ đâu. Nếu tính vào phần pre-money thì chỉ người sáng lập và cổ đông cũ gánh. Nhà đầu tư mới không mất gì. Nếu tính sau vòng thì mọi người cùng gánh.',
          'Lấy ví dụ: gọi 6 tỷ trên định giá pre-money 24 tỷ, kèm ESOP 10%. Lấy từ phần pre-money thì nhóm sáng lập còn 70%. Lấy sau vòng thì nhóm sáng lập giữ được nhiều hơn, còn nhà đầu tư mới nhận dưới 20%.',
          'Đây là điều khoản đàm phán được. Rất nhiều người gọi vốn lần đầu không biết là mình có thể hỏi.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Lập quỹ quá lớn để cho chắc. Quy mô nên bám theo kế hoạch tuyển mười hai tới mười tám tháng tới, không phải đặt sẵn cho nhiều năm. Phần dư ra là phần bạn đã pha loãng mà chưa đổi lấy gì.',
          'Không có lịch vesting cho cổ phần cấp cho nhân sự. Người nghỉ sau ba tháng vẫn giữ nguyên là lỗi giống hệt trường hợp người sáng lập không vesting.',
          'Không ghi vào bảng cổ phần. Quỹ chưa cấp cho ai vẫn phải xuất hiện trong bảng, nếu không mọi phép tính tỷ lệ đều sai.',
        ],
      },
    ],
    faq: [
      {
        q: 'ESOP ở Việt Nam thực hiện thế nào?',
        a: 'Với công ty cổ phần, thông thường là phát hành cổ phần theo chương trình lựa chọn cho người lao động. Thủ tục cần bàn với luật sư vì liên quan tới điều lệ và nghị quyết đại hội đồng cổ đông.',
      },
      {
        q: 'Lập quỹ bao nhiêu phần trăm là hợp lý?',
        a: 'Mười tới mười lăm phần trăm ở vòng đầu là mức thông lệ. Trên hai mươi phần trăm thường là tính dư so với nhu cầu tuyển thực tế.',
      },
      {
        q: 'Cổ phần chưa cấp cho ai thì tính vào tỷ lệ của ai?',
        a: 'Không của ai cả, nhưng vẫn nằm trong tổng số cổ phần khi tính tỷ lệ. Đó là lý do lập quỹ làm giảm phần trăm của mọi người ngay lập tức, dù chưa ai nhận.',
      },
    ],
  },

  'cac-la-gi': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'CAC là chi phí để có được một khách hàng mới. Lấy toàn bộ tiền chi cho bán hàng và marketing trong một kỳ, chia cho số khách hàng mới có được trong kỳ đó.',
          'Con số này chỉ có ý nghĩa khi đặt cạnh giá trị mỗi khách mang lại. Một mình nó không nói lên điều gì.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Tháng vừa rồi bạn chi 60 triệu cho quảng cáo và lương đội bán hàng, có thêm 20 khách hàng mới. CAC = 60 ÷ 20 = 3 triệu một khách.',
          'Mỗi khách trả 2 triệu một tháng, biên lợi nhuận gộp 75%, tức mỗi tháng họ đóng góp 1,5 triệu. Bạn cần hai tháng để thu hồi chi phí có được họ.',
        ],
      },
      {
        h: 'Chi phí nào được tính vào',
        p: [
          'Tính vào: quảng cáo, lương và hoa hồng đội bán hàng, chi phí sự kiện, công cụ marketing, chi phí nội dung.',
          'Không tính vào: lương đội kỹ thuật, chi phí máy chủ, chi phí chăm sóc khách hàng hiện hữu. Những khoản này phục vụ khách đã có, không phải để có thêm khách mới.',
          'Ranh giới hay gây tranh cãi là lương người vừa bán hàng vừa chăm sóc. Cách xử lý phổ biến là chia theo tỷ lệ thời gian, và ghi rõ cách chia để người đọc kiểm chứng.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Tính với mẫu quá nhỏ. Mười khách hàng mới một tháng thì CAC dao động rất mạnh giữa các tháng. Dưới mười khách, hãy coi con số này là ước lượng thô.',
          'Chỉ tính chi phí quảng cáo. Bỏ lương đội bán hàng ra ngoài khiến CAC trông đẹp hơn thực tế nhiều lần, và nhà đầu tư sẽ hỏi ngay.',
          'So sánh CAC giữa các kênh mà không tính khác biệt chất lượng. Khách từ kênh rẻ có thể rời bỏ nhanh hơn, khiến kênh đắt hoá ra lại hiệu quả hơn.',
        ],
      },
    ],
    faq: [
      {
        q: 'CAC bao nhiêu là tốt?',
        a: 'Không có mức tốt tuyệt đối. Điều quan trọng là tỷ lệ giữa giá trị vòng đời khách hàng và CAC, chuẩn thị trường là từ ba lần trở lên.',
      },
      {
        q: 'Chưa chi đồng nào cho marketing thì CAC bằng 0?',
        a: 'Về mặt số học thì đúng, nhưng con số đó không dùng được để lập kế hoạch. Khi bắt đầu chi tiền để tăng trưởng, CAC thật sẽ xuất hiện và thường cao hơn nhiều so với giai đoạn khách tự tìm đến.',
      },
      {
        q: 'Thời gian hoàn vốn quan trọng thế nào?',
        a: 'Rất quan trọng ở giai đoạn đầu vì runway ngắn. Trên mười tám tháng nghĩa là mỗi khách mới làm cạn tiền mặt trước khi sinh lời, một rủi ro dòng tiền thật.',
      },
    ],
  },

  'chia-co-phan-dong-sang-lap': {
    lienQuan: ['co-phan-doi-cong-suc'],
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Chia cổ phần đồng sáng lập là quyết định phân chia quyền sở hữu giữa những người cùng lập công ty. Đây là quyết định khó đảo ngược nhất trong năm đầu tiên, và cũng là nguyên nhân tan rã phổ biến nhất của nhóm sáng lập.',
        ],
      },
      {
        h: 'Sáu yếu tố nên cân nhắc',
        p: [
          'Mức độ toàn thời gian. Người nghỉ hẳn việc cũ đang đánh cược nhiều hơn hẳn người làm buổi tối. Đây là yếu tố nặng nhất.',
          'Chuyên môn trong ngành. Người có tám năm kinh nghiệm đúng lĩnh vực rút ngắn được rất nhiều thời gian thử sai.',
          'Trách nhiệm đang gánh. Ai là người ra quyết định cuối cùng và chịu trách nhiệm khi hỏng việc.',
          'Rủi ro và thu nhập đã đánh đổi. Người bỏ mức lương cao để tham gia đang trả một cái giá thật.',
          'Vốn đã bỏ vào. Tiền mặt đưa vào công ty nên được ghi nhận, nhưng thường không nên là yếu tố lớn nhất.',
          'Ý tưởng ban đầu. Đáng ghi nhận, nhưng ít hơn nhiều so với mức người nghĩ ra ý tưởng thường mong đợi.',
        ],
      },
      {
        h: 'Chia đều có sai không',
        p: [
          'Không sai, nếu đóng góp thực sự tương đương và có thoả thuận vesting đi kèm. Nhiều công ty thành công chia đều từ đầu.',
          'Vấn đề nằm ở chia đều mà không vesting. Khi một người rời đi sau vài tháng, họ vẫn giữ nguyên phần của mình, và công ty gần như không gọi được vốn nữa. Đây là mô hình đổ vỡ phổ biến nhất của nhóm sáng lập lần đầu.',
          'Chia đều cũng khó khi có người toàn thời gian và người bán thời gian. Lúc ký thì ai cũng vui vẻ; sau mười hai tháng, người làm mọi việc sẽ bắt đầu tính toán.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Hoãn cuộc nói chuyện. Càng để lâu càng khó, vì tới lúc đó mỗi người đã có kỳ vọng riêng trong đầu mà không nói ra.',
          'Chia theo cảm tính rồi không ghi lại lý do. Sáu tháng sau khi có bất đồng, không ai nhớ vì sao lại là con số đó.',
          'Cho người nghĩ ra ý tưởng phần lớn nhất. Phần lớn giá trị được tạo ra trong lúc thực thi, không phải lúc nghĩ ra.',
          'Quên người sẽ tham gia sau. Nếu biết sắp có một người quan trọng vào, hãy để dành phần cho họ ngay từ đầu.',
        ],
      },
    ],
    faq: [
      {
        q: 'Nên chia cổ phần vào lúc nào?',
        a: 'Càng sớm càng tốt, ngay khi nhóm đã xác định sẽ làm cùng nhau. Kèm vesting để cơ chế tự điều chỉnh nếu có người rời đi.',
      },
      {
        q: 'Người vào sau nên nhận bao nhiêu?',
        a: 'Tuỳ mức độ đóng góp và thời điểm. Người vào khi sản phẩm đã chạy và có doanh thu nhận ít hơn hẳn người có mặt từ ngày đầu, vì rủi ro họ nhận đã thấp hơn.',
      },
      {
        q: 'Có nên chia lại nếu thấy tỷ lệ ban đầu không hợp lý?',
        a: 'Có, và nên làm sớm khi giá trị công ty còn thấp. Càng để lâu thì việc chia lại càng khó về cả tâm lý lẫn thủ tục pháp lý.',
      },
    ],
  },

  'quy-mo-thi-truong': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'TAM là toàn bộ thị trường nếu bạn phục vụ được tất cả mọi người. SAM là phần bạn thực sự tiếp cận được với sản phẩm và kênh hiện tại. SOM là phần bạn giành được trong vài năm tới.',
          'Cả ba phải dựng từ cùng một bộ giả định. Lấy mỗi con số từ một nguồn khác nhau là cách chắc chắn nhất để chúng mâu thuẫn.',
        ],
      },
      {
        h: 'Dựng từ dưới lên, bằng số cụ thể',
        p: [
          'Bạn làm phần mềm quản lý kho cho chuỗi bán lẻ. Cả nước có khoảng 400.000 hộ kinh doanh bán lẻ. Gói của bạn 2 triệu một tháng, tức 24 triệu một năm.',
          'TAM = 400.000 × 24 triệu = 9.600 tỷ.',
          'Nhưng bạn chỉ bán được cho chuỗi từ năm cửa hàng trở lên, đã dùng máy tính, ở khu vực thành thị, khoảng 80.000 đơn vị. SAM = 80.000 × 24 triệu = 1.920 tỷ.',
          'Đặt mục tiêu chiếm 8% phần tiếp cận được sau năm năm. SOM = 153,6 tỷ, tương đương 6.400 khách hàng.',
        ],
      },
      {
        h: 'Điều nhà đầu tư thực sự đọc',
        p: [
          'Không phải con số TAM. Cái họ đọc là bạn suy ra nó bằng cách nào, và mỗi giả định lấy từ đâu.',
          'Con số "thị trường mười tỷ đô" lấy từ một báo cáo ngành gần như luôn bị bỏ qua, vì nó không nói gì về doanh nghiệp của bạn. Một con số nhỏ hơn nhiều nhưng dựng từ giả định của chính bạn đáng tin hơn hẳn.',
          'Ghi nguồn cho từng giả định. Nguồn có thể là số liệu thống kê công bố, khảo sát bạn tự làm, hoặc chính dữ liệu bán hàng của bạn, miễn là nói được nó từ đâu ra.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Đặt tỷ lệ chiếm lĩnh quá cao. Sau ba năm mà trên 10% thị trường là mức rất ít doanh nghiệp đạt được. Con số 30% xuất hiện trong deck thường khiến người đọc ngừng tin phần còn lại.',
          'Để SAM gần bằng TAM. Thường nghĩa là chưa thu hẹp theo phân khúc thực tế, và nhà đầu tư sẽ hỏi vì sao bạn tiếp cận được gần như tất cả.',
          'Quên kiểm tra thị trường có đủ lớn cho vốn mạo hiểm không. Quỹ cần đường đi tới quy mô gấp nhiều lần số tiền bỏ ra. Thị trường nhỏ không có nghĩa doanh nghiệp không tốt, chỉ là vốn mạo hiểm có thể không phải nguồn phù hợp.',
        ],
      },
    ],
    faq: [
      {
        q: 'Chiếm bao nhiêu phần trăm thị trường là hợp lý?',
        a: 'Sau ba năm, trên 10% là mức rất ít doanh nghiệp đạt được; sau năm năm là trên 20%. Đặt cao hơn thì cần lý do cụ thể, chẳng hạn thị trường có hiệu ứng mạng.',
      },
      {
        q: 'Thị trường nhỏ thì có gọi được vốn không?',
        a: 'Quỹ mạo hiểm cần đường đi tới quy mô lớn hơn nhiều lần vốn bỏ ra. Thị trường nhỏ vẫn có thể nuôi một doanh nghiệp tốt, nhưng nên tìm nguồn vốn khác thay vì mất thời gian gõ cửa các quỹ.',
      },
      {
        q: 'Có nên dùng số liệu thị trường nước ngoài không?',
        a: 'Chỉ để tham chiếu, không để làm cơ sở. Quy mô, mức chi trả và hành vi khách hàng ở Việt Nam khác rất xa, và người đọc có kinh nghiệm nhận ra ngay khi con số được bê nguyên từ báo cáo Mỹ.',
      },
    ],
  },

  'valuation-cap': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Cap là mức định giá trần dùng để quy đổi SAFE thành cổ phần. Ký SAFE với cap 8 tỷ nghĩa là dù vòng sau công ty được định giá bao nhiêu, nhà đầu tư này vẫn được tính như thể công ty trị giá 8 tỷ.',
          'Nó tồn tại để bảo vệ người vào sớm. Không có cap, người bỏ tiền lúc công ty còn chưa có gì sẽ mua ở đúng giá của người vào sau khi mọi thứ đã rõ ràng, vô lý với rủi ro họ nhận.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Bạn nhận 500 triệu qua SAFE với cap 8 tỷ. Một năm sau, vòng pre-seed định giá công ty 24 tỷ pre-money.',
          'Không có cap, 500 triệu ở mức 24 tỷ chỉ mua được khoảng 2%. Có cap 8 tỷ, khoản đó được tính ở mức 8 tỷ, tức khoảng 6,25%, gấp ba lần.',
          'Phần chênh lệch đó không từ trên trời rơi xuống. Nó lấy từ phần của người sáng lập.',
        ],
      },
      {
        h: 'Cap không phải định giá',
        p: [
          'Đây là hiểu nhầm phổ biến nhất. Ký SAFE cap 8 tỷ không có nghĩa công ty đang được định giá 8 tỷ. Cap chỉ là mức trần dùng để tính toán sau này, và ở thời điểm ký thì chưa ai định giá gì cả.',
          'Nói với người khác rằng "công ty tôi định giá 8 tỷ vì vừa ký SAFE cap 8 tỷ" là nói sai, và người có kinh nghiệm sẽ nhận ra ngay.',
          'Trên thực tế, cap thường thấp hơn mức định giá mà vòng chính thức sau đó đạt được, nếu không thì cap chẳng có tác dụng gì.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Đặt cap quá thấp để chốt nhanh. Cap thấp giúp gọi được tiền sớm, nhưng khi vòng sau định giá cao, phần nhà đầu tư sớm nhận được sẽ lớn hơn nhiều so với dự kiến, và toàn bộ do người sáng lập gánh.',
          'Ký nhiều SAFE với các mức cap khác nhau mà không tính tổng. Bốn khoản, mỗi khoản trông nhỏ, cộng lại có thể là hai mươi phần trăm công ty đã hứa trước vòng đầu tiên.',
          'Không phân biệt cap của bản pre-money và post-money. Cùng một con số 8 tỷ nhưng hai bản cho ra tỷ lệ khác nhau.',
        ],
      },
    ],
    faq: [
      {
        q: 'Cap bao nhiêu là hợp lý?',
        a: 'Thường thấp hơn mức bạn kỳ vọng cho vòng chính thức tiếp theo. Nếu nghĩ vòng pre-seed sẽ ở mức 20–25 tỷ, cap trong khoảng 8–15 tỷ là vùng hay gặp. Con số cụ thể phụ thuộc mức độ hoàn thiện của hồ sơ tại thời điểm ký.',
      },
      {
        q: 'SAFE không có cap thì sao?',
        a: 'Nhà đầu tư sẽ chuyển đổi đúng bằng giá vòng sau, tức không được ưu đãi gì cho việc vào sớm. Rất ít người chấp nhận, trừ khi có discount bù lại hoặc quan hệ đặc biệt.',
      },
      {
        q: 'Có cả cap và discount thì tính thế nào?',
        a: 'Nhà đầu tư chọn phương án cho họ nhiều cổ phần hơn, không cộng dồn cả hai. Cap thường thắng khi vòng sau định giá cao; discount thắng khi định giá vòng sau thấp hơn cap.',
      },
    ],
  },

  'discount-safe': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Discount là mức chiết khấu nhà đầu tư SAFE được hưởng so với giá cổ phần của vòng gọi vốn sau. Mức thông lệ là 15 tới 25 phần trăm.',
          'Cũng như cap, nó tồn tại để bù cho rủi ro của người vào sớm, chỉ khác ở cơ chế.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Vòng pre-seed bán cổ phần ở giá 20.000 đồng một cổ phần. Nhà đầu tư có SAFE discount 20% mua ở giá 16.000 đồng.',
          'Khoản 500 triệu vì thế mua được 31.250 cổ phần thay vì 25.000 cổ phần. Chênh lệch 6.250 cổ phần là phần thưởng cho việc vào sớm.',
        ],
      },
      {
        h: 'Discount hay cap, cái nào có lợi hơn',
        p: [
          'Tuỳ vòng sau định giá bao nhiêu. Định giá càng cao thì cap càng có lợi cho nhà đầu tư; định giá thấp thì discount có lợi hơn.',
          'Ví dụ với SAFE 500 triệu, cap 8 tỷ, discount 20%: nếu vòng sau định giá 24 tỷ thì cap cho khoảng 6,25%, discount chỉ cho khoảng 2,6%, cap thắng. Nếu vòng sau chỉ định giá 9 tỷ thì hai phương án gần bằng nhau.',
          'Nhà đầu tư luôn được chọn phương án tốt hơn cho họ. Điều đó có nghĩa với người sáng lập: cứ tính theo phương án tệ hơn cho mình khi lập kế hoạch.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Tưởng có cả hai thì nhà đầu tư được cộng dồn. Không. Họ chọn một, và bản hợp đồng chuẩn ghi rõ điều đó.',
          'Đồng ý discount quá cao để bù cho việc không có cap. Trên 30% là mức bất thường và sẽ khiến nhà đầu tư vòng sau đặt câu hỏi.',
          'Quên rằng discount chỉ có ý nghĩa khi thực sự có vòng gọi vốn tiếp theo. Không có vòng nào thì cả cap lẫn discount đều không kích hoạt.',
        ],
      },
    ],
    faq: [
      {
        q: 'Discount bao nhiêu là chuẩn?',
        a: 'Từ 15 đến 25 phần trăm là vùng thông lệ. Dưới 15% thì nhà đầu tư thấy không đủ bù rủi ro; trên 30% là dấu hiệu bất thường.',
      },
      {
        q: 'Chỉ có discount, không có cap thì founder có lợi hơn không?',
        a: 'Thường là có, nếu bạn tin vòng sau sẽ định giá cao. Discount giới hạn phần nhà đầu tư nhận ở một tỷ lệ cố định so với giá vòng sau, còn cap thì không giới hạn khi định giá tăng mạnh.',
      },
      {
        q: 'Discount tính trên định giá hay trên giá cổ phần?',
        a: 'Trên giá mỗi cổ phần của vòng sau. Kết quả tương đương với chiết khấu trên định giá, nhưng cách diễn đạt chuẩn trong hợp đồng là theo giá cổ phần.',
      },
    ],
  },

  'safe-post-money': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'SAFE post-money là bản chuẩn được dùng phổ biến từ năm 2018. Điểm khác biệt: nhà đầu tư biết chắc mình sẽ sở hữu bao nhiêu phần trăm, và các SAFE không pha loãng lẫn nhau.',
          'Tỷ lệ tính bằng số tiền chia cho cap, áp trên công ty sau khi mọi SAFE đã chuyển đổi nhưng trước khi tiền vòng mới vào.',
        ],
      },
      {
        h: 'Vì sao điều đó quan trọng với người sáng lập',
        p: [
          'Khi các SAFE không pha loãng lẫn nhau, toàn bộ phần pha loãng đó do cổ đông hiện hữu gánh, tức là bạn.',
          'Ký một SAFE 500 triệu cap 10 tỷ là hứa 5% công ty. Ký thêm một bản nữa cùng điều kiện là hứa thêm 5% nữa, và người ký đầu tiên vẫn giữ nguyên 5%. Phần mất đi hoàn toàn là của bạn.',
          'Với bản pre-money cũ thì khác: người ký trước cũng bị pha loãng bởi người ký sau, nên gánh nặng được chia sẻ.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Hai người sáng lập giữ 1.000.000 cổ phần. Bạn ký hai SAFE, mỗi bản 500 triệu cap 10 tỷ, tức mỗi bản 5%.',
          'Khi chuyển đổi, hai nhà đầu tư giữ đúng 5% và 5%, người sáng lập còn 90%. Sau đó vòng mới lấy 20% nữa, người sáng lập còn 72%, hai nhà đầu tư SAFE mỗi người còn 4%.',
          'Nếu ký bốn bản như vậy, người sáng lập chỉ còn 80% trước cả khi vòng đầu tiên diễn ra.',
        ],
      },
      {
        h: 'Cách nhận biết bạn đang cầm bản nào',
        p: [
          'Bản post-money ghi rõ chữ "post-money" trong tiêu đề văn bản, thường là "Post-Money Valuation Cap". Bản cũ chỉ ghi "Valuation Cap".',
          'Nếu không thấy chữ post-money ở đâu, khả năng cao bạn đang dùng bản 2013. Hai bản tính pha loãng khác nhau, nên đây là điều bắt buộc phải xác định trước khi tính bất cứ thứ gì.',
        ],
      },
    ],
    faq: [
      {
        q: 'Bản post-money có bất lợi hơn cho người sáng lập không?',
        a: 'Về mặt pha loãng thì có, vì bạn gánh toàn bộ. Nhưng nó minh bạch hơn nhiều: cả hai bên biết chính xác con số ngay khi ký, thay vì phải chờ tới lúc chuyển đổi mới biết.',
      },
      {
        q: 'Đã ký bản pre-money rồi có đổi sang post-money được không?',
        a: 'Chỉ khi hai bên đồng ý ký lại. Trên thực tế hiếm khi làm, vì nhà đầu tư ít có lý do đồng ý thay đổi một hợp đồng đã có hiệu lực.',
      },
      {
        q: 'Trộn cả hai loại SAFE thì tính thế nào?',
        a: 'Được, nhưng phức tạp và rất dễ nhầm. Công cụ SAFE xử lý được trường hợp này và sẽ nêu cờ cảnh báo để bạn rà lại từng hợp đồng.',
      },
    ],
  },

  'safe-pre-money': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'SAFE pre-money là bản gốc ra đời năm 2013, nay ít dùng hơn. Điểm khác biệt cốt lõi: các SAFE pha loãng lẫn nhau khi cùng chuyển đổi.',
          'Giá quy đổi tính bằng cap chia cho vốn hoá trước vòng, trong đó vốn hoá trước vòng không bao gồm các SAFE khác đang chờ chuyển đổi.',
        ],
      },
      {
        h: 'Khác biệt thực tế so với bản post-money',
        p: [
          'Với bản post-money, ký thêm một SAFE nữa không làm giảm phần của người ký trước, chỉ người sáng lập mất thêm.',
          'Với bản pre-money, ký thêm SAFE làm giảm phần của tất cả những người đã ký trước đó. Gánh nặng được chia sẻ, nhưng đổi lại không ai biết chắc mình sẽ có bao nhiêu phần trăm cho tới lúc chuyển đổi.',
          'Đó chính là lý do bản post-money ra đời và thay thế nó: sự không chắc chắn khiến cả hai bên khó lập kế hoạch.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Công ty có 1.000.000 cổ phần. Bạn ký SAFE 1 tỷ với cap 10 tỷ theo bản pre-money.',
          'Giá quy đổi bằng 10 tỷ chia 1.000.000 cổ phần, tức 10.000 đồng một cổ phần. Khoản 1 tỷ mua được 100.000 cổ phần.',
          'Nếu chỉ có một SAFE, nhà đầu tư giữ khoảng 9,1%. Nếu ký thêm một bản y hệt, số cổ phần của mỗi người vẫn là 100.000 nhưng tỷ lệ mỗi người giảm xuống khoảng 8,3%.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Dùng bản 2013 mà tính theo cách của bản 2018. Lấy số tiền chia cho cap rồi tưởng đó là tỷ lệ sở hữu, công thức đó chỉ đúng với bản post-money.',
          'Không đọc kỹ định nghĩa vốn hoá trước vòng trong hợp đồng. Có bản tính cả quỹ cổ phiếu thưởng mở rộng, có bản không, và khác biệt đó ảnh hưởng trực tiếp tới con số cuối.',
          'Nhận bản mẫu từ một nhà đầu tư mà không kiểm tra là bản nào. Cả hai bản đều mang tên SAFE và trông rất giống nhau ở lần đọc đầu.',
        ],
      },
    ],
    faq: [
      {
        q: 'Nếu ai đó đưa tôi bản pre-money thì có nên ký không?',
        a: 'Không hẳn là xấu, nhưng bạn cần biết mình đang ký gì. Với người sáng lập, bản pre-money thực ra đỡ pha loãng hơn khi có nhiều SAFE. Điều quan trọng là tính đúng trước khi ký.',
      },
      {
        q: 'Làm sao biết vốn hoá trước vòng được định nghĩa thế nào?',
        a: 'Đọc phần định nghĩa trong chính hợp đồng, thường ở trang cuối. Nếu không rõ, đây là chỗ đáng hỏi luật sư trước khi ký.',
      },
      {
        q: 'Bản nào phổ biến hơn ở Việt Nam?',
        a: 'Bản post-money phổ biến hơn vì nó là bản chuẩn hiện hành và dễ giải thích cho cả hai bên. Nhưng vẫn gặp bản cũ, đặc biệt khi mẫu hợp đồng được sao chép lại từ tài liệu nhiều năm trước.',
      },
    ],
  },

  'trai-phieu-chuyen-doi': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Trái phiếu chuyển đổi là khoản vay có thể chuyển thành cổ phần ở vòng gọi vốn sau. Khác SAFE ở hai điểm: nó có lãi suất và có ngày đáo hạn.',
          'Về bản chất pháp lý đây là khoản nợ. Tới hạn mà chưa có vòng gọi vốn nào, về nguyên tắc doanh nghiệp phải trả tiền.',
        ],
      },
      {
        h: 'Ba điều khoản cần đọc kỹ',
        p: [
          'Lãi suất, thường 5 tới 8 phần trăm một năm. Lãi này không trả bằng tiền mà cộng dồn vào khoản vay, nên số cổ phần chuyển đổi cuối cùng lớn hơn số tiền ban đầu.',
          'Ngày đáo hạn, thường 18 tới 24 tháng. Đây là điểm rủi ro thật: nếu chưa gọi được vòng nào, hai bên phải đàm phán gia hạn, và bạn ở thế yếu.',
          'Cap và discount, hoạt động giống hệt như trong SAFE.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Bạn vay 1 tỷ, lãi 6% một năm, cap 10 tỷ, đáo hạn sau 24 tháng.',
          'Sau 18 tháng, vòng pre-seed diễn ra. Khoản nợ lúc này là 1 tỷ cộng lãi 18 tháng, khoảng 1,09 tỷ. Số tiền chuyển đổi là 1,09 tỷ chứ không phải 1 tỷ.',
          'Chênh lệch 90 triệu nghe nhỏ, nhưng ở mức cap 10 tỷ nó tương đương gần một phần trăm công ty.',
        ],
      },
      {
        h: 'Nên chọn cái nào',
        p: [
          'Với doanh nghiệp giai đoạn rất sớm, SAFE nhẹ nhàng hơn: không nợ trên sổ sách, không có ngày phải trả tiền, giấy tờ đơn giản hơn.',
          'Trái phiếu chuyển đổi có lợi thế là quen thuộc hơn với nhà đầu tư và luật sư Việt Nam, vì nó là một khoản vay theo nghĩa thông thường. Với nhà đầu tư cá nhân trong nước, đôi khi đây là hình thức duy nhất họ thấy thoải mái.',
        ],
      },
    ],
    faq: [
      {
        q: 'Tới hạn mà chưa gọi được vòng nào thì sao?',
        a: 'Hai bên đàm phán: gia hạn, chuyển đổi ở một mức định giá thoả thuận, hoặc trả tiền. Thực tế phần lớn là gia hạn, nhưng đó là cuộc đàm phán bạn ở thế yếu, nên đừng để tới sát ngày.',
      },
      {
        q: 'Lãi suất có phải trả bằng tiền không?',
        a: 'Thông thường không. Lãi cộng dồn vào khoản gốc và cùng chuyển thành cổ phần. Nhưng phải đọc kỹ hợp đồng vì có bản quy định khác.',
      },
      {
        q: 'Ghi nhận trên sổ sách thế nào?',
        a: 'Là khoản nợ phải trả cho tới khi chuyển đổi. Điều này ảnh hưởng tới báo cáo tài chính và cần trao đổi với kế toán ngay từ khi ký.',
      },
    ],
  },

  'term-sheet': {
    lienQuan: ['dieu-khoan-no-shop', 'cam-doan-bao-dam', 'quyen-thong-tin'],
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Term sheet là văn bản tóm tắt các điều khoản chính của thương vụ đầu tư, thường dài hai tới bốn trang. Phần lớn nội dung chưa ràng buộc pháp lý. Nó là bản thoả thuận nguyên tắc trước khi luật sư soạn hợp đồng đầy đủ.',
          'Nhận được term sheet là dấu mốc lớn, nhưng chưa phải tiền về tài khoản.',
        ],
      },
      {
        h: 'Những điều khoản đáng đọc kỹ nhất',
        p: [
          'Định giá và số tiền đầu tư. Đây là phần ai cũng đọc, nhưng thường không phải phần quan trọng nhất.',
          'Quyền ưu tiên thanh toán. Quy định nhà đầu tư được nhận tiền trước khi chia cho cổ đông phổ thông khi công ty bán đi. Mức một lần không tham gia chia tiếp là thông lệ; các biến thể khác có thể lấy đi phần lớn giá trị của bạn trong một thương vụ bán vừa phải.',
          'Quỹ cổ phiếu thưởng và cách tính. Lấy từ phần pre-money hay sau vòng, khác biệt này thường lớn hơn khác biệt vài tỷ trong định giá.',
          'Quyền phủ quyết và ghế hội đồng quản trị. Quyết định ai thực sự kiểm soát công ty, độc lập với tỷ lệ phần trăm.',
        ],
      },
      {
        h: 'Phần nào ràng buộc',
        p: [
          'Thường chỉ có ba phần ràng buộc: điều khoản bảo mật, điều khoản độc quyền đàm phán, và ai chịu chi phí pháp lý.',
          'Điều khoản độc quyền đàm phán đáng chú ý nhất. Nó cấm bạn nói chuyện với nhà đầu tư khác trong một khoảng thời gian, thường 30 tới 60 ngày. Nếu thương vụ đổ vỡ sau đó, bạn đã mất hai tháng và các cuộc trò chuyện song song.',
          'Trước khi ký, nên rút ngắn thời gian độc quyền xuống mức tối thiểu hợp lý.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Chỉ đàm phán định giá. Một term sheet định giá cao kèm điều khoản bất lợi có thể tệ hơn nhiều so với định giá thấp hơn với điều khoản sạch.',
          'Ký ngay vì sợ mất cơ hội. Xin thêm vài ngày để luật sư đọc là chuyện bình thường, và nhà đầu tư nghiêm túc không phản đối.',
          'Không hỏi khi không hiểu. Mỗi điều khoản đều có lý do tồn tại; hỏi thẳng nhà đầu tư vì sao họ cần nó thường cho ra câu trả lời hữu ích.',
        ],
      },
    ],
    faq: [
      {
        q: 'Từ term sheet tới lúc nhận tiền mất bao lâu?',
        a: 'Thường bốn tới tám tuần, gồm thẩm định pháp lý và soạn hợp đồng. Hồ sơ pháp lý càng gọn thì càng nhanh. Đây là lúc công sức chuẩn bị trước đó được đền đáp.',
      },
      {
        q: 'Có thể nhận nhiều term sheet cùng lúc không?',
        a: 'Được, và đó là vị thế tốt nhất bạn có thể ở. Nhưng khi đã ký một bản có điều khoản độc quyền đàm phán thì phải dừng nói chuyện với những nơi khác.',
      },
      {
        q: 'Có cần luật sư đọc term sheet không?',
        a: 'Nên có, kể cả khi văn bản ngắn. Chi phí cho một buổi rà soát nhỏ hơn nhiều so với hậu quả của một điều khoản bạn không hiểu hết.',
      },
    ],
  },

  'bridge-round': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Vòng cầu nối là khoản vốn nhỏ huy động để duy trì hoạt động cho tới vòng gọi vốn chính thức tiếp theo. Thường dùng SAFE hoặc trái phiếu chuyển đổi để làm nhanh, và thường từ chính các nhà đầu tư hiện hữu.',
          'Quy mô điển hình là đủ nuôi thêm sáu tới mười hai tháng.',
        ],
      },
      {
        h: 'Khi nào cần tới',
        p: [
          'Khi runway sắp hết mà chưa đạt cột mốc đủ để gọi vòng chính thức ở mức định giá mong muốn. Vay thêm thời gian để đạt cột mốc đó rồi mới gọi vòng lớn.',
          'Hoặc khi vòng chính thức đang đàm phán nhưng chưa đóng kịp, và tiền mặt không đợi được.',
          'Cả hai trường hợp đều là dấu hiệu kế hoạch đã trượt. Điều đó bình thường, nhưng cần nhìn thẳng.',
        ],
      },
      {
        h: 'Cái giá phải trả',
        p: [
          'Vòng cầu nối gần như luôn có điều khoản kém thuận lợi hơn, vì bạn đang ở thế cần tiền. Cap thấp hơn, discount cao hơn, hoặc cả hai.',
          'Nó cũng là tín hiệu cho nhà đầu tư vòng sau. Họ sẽ hỏi vì sao cần cầu nối, và câu trả lời "chúng tôi chậm hơn kế hoạch" phải đi kèm lý do cụ thể cùng bằng chứng đã điều chỉnh.',
          'Đổi lại, nó tốt hơn nhiều so với việc gọi vòng chính thức khi đang cạn tiền, lúc đó bạn mất cả định giá lẫn điều khoản.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Để tới khi còn hai tháng mới bắt đầu tìm. Vòng cầu nối vẫn cần bốn tới tám tuần, nên phải khởi động khi còn ít nhất bốn tháng.',
          'Gọi quá ít, chỉ đủ vài tháng. Rồi lại phải gọi cầu nối lần hai, và lần này thì rất khó.',
          'Không nói rõ cột mốc mà khoản tiền này mua được. Nhà đầu tư hiện hữu bỏ thêm tiền cần biết lần này sẽ khác lần trước ở chỗ nào.',
        ],
      },
    ],
    faq: [
      {
        q: 'Nhà đầu tư hiện hữu có bắt buộc tham gia không?',
        a: 'Không, trừ khi hợp đồng có cam kết riêng. Nhưng việc họ tham gia hay không là tín hiệu mạnh với nhà đầu tư mới. Người trong cuộc không bỏ thêm tiền là câu hỏi khó trả lời.',
      },
      {
        q: 'Vòng cầu nối có làm giảm định giá vòng sau không?',
        a: 'Không trực tiếp, nhưng nó pha loãng thêm và cho thấy kế hoạch đã trượt. Cách giảm thiểu là dùng khoản đó để đạt một cột mốc rõ ràng, rồi kể lại câu chuyện đó ở vòng sau.',
      },
      {
        q: 'Nên gọi bao nhiêu cho vòng cầu nối?',
        a: 'Đủ để đạt cột mốc tiếp theo cộng thêm thời gian chạy vòng chính thức, thường là sáu tới mười hai tháng runway. Tính bằng công cụ gọi bao nhiêu thay vì ước lượng.',
      },
    ],
  },

  'nha-dau-tu-dan-dat': {
    lienQuan: ['dong-dau-tu'],
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Nhà đầu tư dẫn dắt là bên đứng ra định giá, đàm phán điều khoản và thường bỏ phần lớn số tiền của vòng. Những người còn lại tham gia theo điều khoản đã được thống nhất.',
          'Tìm được người dẫn dắt thường là phần khó nhất của cả vòng gọi vốn.',
        ],
      },
      {
        h: 'Vì sao vòng nào cũng cần một người dẫn',
        p: [
          'Ai đó phải quyết định công ty đáng giá bao nhiêu và điều khoản ra sao. Không có người dẫn, mỗi nhà đầu tư đều chờ người khác đi trước, và vòng gọi vốn đứng im dù nhiều người quan tâm.',
          'Người dẫn dắt cũng làm phần thẩm định nặng nhất. Những người tham gia sau dựa vào công sức đó, nên họ quyết định nhanh hơn nhiều.',
          'Đây là lý do nên tập trung công sức vào việc thuyết phục một bên thay vì rải đều cho hai mươi bên.',
        ],
      },
      {
        h: 'Ai có thể là người dẫn',
        p: [
          'Với vòng angel và pre-seed, người dẫn có thể là một nhà đầu tư cá nhân có uy tín, một quỹ nhỏ, hoặc một vườn ươm.',
          'Không nhất thiết phải là bên bỏ nhiều tiền nhất, nhưng thường là vậy. Điều quan trọng hơn là họ sẵn sàng đặt ra điều khoản và những người khác tin vào phán đoán đó.',
          'Một số quỹ nói rõ trong khẩu vị đầu tư rằng họ có dẫn dắt hay không. Đây là thông tin đáng kiểm tra trước khi tiếp cận.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Gom nhiều cam kết nhỏ mà không có người dẫn. Bạn có thể có tổng cộng đủ tiền nhưng vẫn không đóng được vòng, vì không ai đặt ra điều khoản.',
          'Tự đặt định giá rồi đi tìm người chấp nhận. Cách này đôi khi thành công ở vòng rất sớm với SAFE, nhưng với vòng có định giá thì hiếm.',
          'Nói với người dẫn tiềm năng rằng đã có nhiều người quan tâm trong khi chưa có gì chắc chắn. Họ sẽ hỏi tên, và câu trả lời mơ hồ làm hỏng niềm tin.',
        ],
      },
    ],
    faq: [
      {
        q: 'Không tìm được người dẫn thì làm sao?',
        a: 'Với vòng rất sớm, có thể dùng SAFE và gom từng khoản nhỏ mà không cần định giá, đó chính là lý do SAFE ra đời. Với vòng có định giá thì gần như bắt buộc phải có người dẫn.',
      },
      {
        q: 'Người dẫn thường lấy bao nhiêu phần trăm của vòng?',
        a: 'Thường từ một nửa tới toàn bộ. Ở vòng nhỏ, một bên có thể bỏ toàn bộ số tiền; ở vòng lớn hơn thì thường dẫn 50–70% và mời thêm người khác.',
      },
      {
        q: 'Người dẫn có yêu cầu ghế hội đồng quản trị không?',
        a: 'Ở vòng pre-seed thì thường không. Từ vòng seed trở đi thì khá phổ biến, và đó là điều khoản cần bàn kỹ vì nó ảnh hưởng tới cách công ty ra quyết định.',
      },
    ],
  },

  'loai-hinh-doanh-nghiep-startup': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Startup định gọi vốn ở Việt Nam thực tế chỉ có ba lựa chọn đáng cân nhắc: công ty cổ phần, công ty trách nhiệm hữu hạn, và hộ kinh doanh. Với mục tiêu nhận vốn đầu tư, công ty cổ phần là loại hình linh hoạt nhất.',
          'Hộ kinh doanh không phát hành được cổ phần, nên không nhận vốn đầu tư theo cách thông thường.',
        ],
      },
      {
        h: 'Khác biệt quan trọng với việc gọi vốn',
        p: [
          'Công ty cổ phần phát hành cổ phần được, lập quỹ cổ phiếu thưởng cho nhân sự được, và chuyển nhượng cổ phần đơn giản hơn. Đây là loại hình mà nhà đầu tư và luật sư quen thuộc nhất khi làm thương vụ.',
          'Công ty trách nhiệm hữu hạn vẫn nhận vốn được thông qua việc kết nạp thành viên góp vốn, nhưng thủ tục nặng hơn và số thành viên bị giới hạn. Lập cơ chế thưởng cổ phần cho nhân sự cũng rắc rối hơn nhiều.',
          'Hộ kinh doanh phù hợp khi mới thử nghiệm và chưa có ý định gọi vốn. Khi cần nhận đầu tư thì phải chuyển đổi, và việc đó mất thời gian, thường rơi đúng lúc đang đàm phán với nhà đầu tư.',
        ],
      },
      {
        h: 'Chuyển đổi sau có được không',
        p: [
          'Được, nhưng tốn thời gian và công sức. Chuyển từ trách nhiệm hữu hạn sang cổ phần là thủ tục phổ biến, nhiều đơn vị làm được, nhưng vẫn cần vài tuần và phải sửa lại điều lệ.',
          'Vấn đề không nằm ở chỗ khó hay dễ, mà ở thời điểm. Nhà đầu tư đã đồng ý về nguyên tắc mà công ty còn đang làm thủ tục chuyển đổi là tình huống khiến mọi thứ chậm lại, và động lực của thương vụ có thể nguội đi.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Chọn loại hình theo lời khuyên của dịch vụ thành lập nhanh. Họ tối ưu cho việc đăng ký nhanh và rẻ, không tối ưu cho việc gọi vốn hai năm sau.',
          'Đăng ký ngành nghề quá hẹp. Sản phẩm thay đổi là chuyện thường ở giai đoạn đầu; ngành nghề đăng ký nên đủ rộng để không phải sửa đăng ký kinh doanh mỗi lần đổi hướng.',
          'Để một người đứng tên toàn bộ cho gọn. Việc này tạo ra rủi ro rất lớn cho những người còn lại, và sửa về sau khó hơn nhiều so với làm đúng từ đầu.',
        ],
      },
    ],
    faq: [
      {
        q: 'Công ty cổ phần cần tối thiểu bao nhiêu cổ đông?',
        a: 'Theo Luật Doanh nghiệp, công ty cổ phần cần tối thiểu ba cổ đông và không giới hạn tối đa. Nhóm hai người sáng lập thường mời thêm một người thân hoặc cố vấn đứng tên một phần nhỏ. Nên hỏi luật sư về cách làm phù hợp với tình huống cụ thể.',
      },
      {
        q: 'Vốn điều lệ nên đăng ký bao nhiêu?',
        a: 'Với phần lớn ngành nghề, pháp luật không đặt mức tối thiểu. Con số quá lớn tạo nghĩa vụ góp vốn thật trong thời hạn quy định; quá nhỏ thì trông thiếu nghiêm túc. Đây là câu hỏi nên hỏi kế toán và luật sư cùng lúc.',
      },
      {
        q: 'Lập pháp nhân ở Singapore có tốt hơn không?',
        a: 'Nhiều startup Việt Nam làm vậy để dùng SAFE và đón vốn nước ngoài dễ hơn. Nhưng nó kéo theo chi phí duy trì, nghĩa vụ thuế ở hai nơi và cấu trúc sở hữu phức tạp. Đây là quyết định lớn, cần tư vấn chuyên môn chứ không nên theo phong trào.',
      },
    ],
  },

  'cong-ty-co-phan-goi-von': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Công ty cổ phần là loại hình được chọn nhiều nhất cho startup định gọi vốn, vì ba lý do: phát hành cổ phần linh hoạt, lập được quỹ cổ phiếu thưởng cho nhân sự, và chuyển nhượng cổ phần đơn giản.',
        ],
      },
      {
        h: 'Ba lợi thế cụ thể',
        p: [
          'Phát hành cổ phần cho nhà đầu tư mới là cơ chế có sẵn trong loại hình này. Với công ty trách nhiệm hữu hạn, việc tương đương là kết nạp thành viên góp vốn, nặng thủ tục hơn và bị giới hạn số lượng.',
          'Quỹ cổ phiếu thưởng cho nhân sự thực hiện được thông qua chương trình phát hành cổ phần cho người lao động. Đây là công cụ gần như bắt buộc khi cạnh tranh tuyển người mà chưa trả nổi lương thị trường.',
          'Chuyển nhượng cổ phần giữa các bên đơn giản hơn, quan trọng khi có người rời đi hoặc khi nhà đầu tư muốn bán lại phần của mình.',
        ],
      },
      {
        h: 'Nhưng điều lệ mẫu thường không đủ',
        p: [
          'Điều lệ lấy từ dịch vụ thành lập nhanh thường là bản mẫu tối giản, đủ để đăng ký kinh doanh nhưng thiếu những điều khoản nhà đầu tư cần.',
          'Những thứ hay thiếu: quyền ưu tiên mua khi có cổ đông bán ra, hạn chế chuyển nhượng cổ phần của người sáng lập, thẩm quyền cụ thể của hội đồng quản trị, và cơ chế xử lý khi cổ đông rời đi.',
          'Rà lại điều lệ trước vòng gọi vốn đầu tiên thường chỉ mất một buổi làm việc với luật sư, rẻ hơn nhiều so với sửa giữa lúc đang đàm phán.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Nghĩ rằng chọn đúng loại hình là xong phần pháp lý. Loại hình chỉ là bước đầu; điều lệ, thoả thuận cổ đông và vesting mới là phần quyết định.',
          'Không cập nhật sổ đăng ký cổ đông. Đây là tài liệu thẩm định luôn hỏi tới, và việc dựng lại từ trí nhớ sau vài năm rất khó.',
          'Bỏ qua nghĩa vụ về thời hạn góp đủ vốn điều lệ đã đăng ký. Đây là thứ cơ quan quản lý có thể kiểm tra và cũng là thứ thẩm định sẽ soi.',
        ],
      },
    ],
    faq: [
      {
        q: 'Đang là công ty trách nhiệm hữu hạn thì có cần chuyển ngay không?',
        a: 'Không nhất thiết ngay, nhưng nên làm trước khi bắt đầu nói chuyện nghiêm túc với nhà đầu tư. Chuyển đổi khi thương vụ đang chạy sẽ làm chậm mọi thứ.',
      },
      {
        q: 'Cổ đông sáng lập có bị hạn chế chuyển nhượng không?',
        a: 'Luật Doanh nghiệp có quy định về hạn chế chuyển nhượng cổ phần của cổ đông sáng lập trong thời gian đầu. Chi tiết và ngoại lệ nên hỏi luật sư, vì nó ảnh hưởng trực tiếp tới cách cấu trúc thương vụ.',
      },
      {
        q: 'Có cần con dấu và các thủ tục gì sau khi thành lập?',
        a: 'Sau đăng ký còn một loạt việc: khắc dấu, mở tài khoản ngân hàng, đăng ký thuế, kê khai lao động và bảo hiểm. Dịch vụ thành lập thường làm trọn gói, nhưng bạn nên biết danh sách để kiểm tra lại.',
      },
    ],
  },

  'thoa-thuan-dong-sang-lap': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Thoả thuận đồng sáng lập là văn bản ghi rõ ai sở hữu bao nhiêu, ai làm gì, quyết định ra sao, và điều gì xảy ra khi có người rời đi.',
          'Nó không thay thế điều lệ công ty. Điều lệ là văn bản pháp lý bắt buộc; thoả thuận này là cam kết giữa những người sáng lập với nhau, thường chi tiết hơn nhiều.',
        ],
      },
      {
        h: 'Bốn nội dung không được thiếu',
        p: [
          'Phân chia cổ phần và lịch vesting. Bao nhiêu phần trăm mỗi người, nhận dần trong bao lâu, mốc chờ ban đầu là bao nhiêu tháng.',
          'Vai trò và thẩm quyền. Ai quyết định cuối cùng về sản phẩm, về tuyển người, về chi tiêu trên một mức nào đó. Không cần phức tạp, nhưng phải rõ.',
          'Điều gì xảy ra khi có người rời đi. Phần chưa vesting xử lý thế nào, người ở lại có quyền mua lại phần đã vesting không, giá tính ra sao.',
          'Cách giải quyết bất đồng. Nghe xa vời lúc mọi người còn hoà thuận, nhưng đó chính là lúc duy nhất thoả thuận được điều này một cách công bằng.',
        ],
      },
      {
        h: 'Vì sao phải làm sớm',
        p: [
          'Lúc chưa ai có gì để mất, cuộc nói chuyện này dễ hơn rất nhiều. Sau mười tám tháng, khi công ty đã có giá trị và mỗi người đã có kỳ vọng riêng trong đầu, nó trở thành cuộc đàm phán giữa những người vốn là bạn.',
          'Nhiều nhóm hoãn vì ngại. Nhưng chính việc ngại nói chuyện về tiền và quyền lực là dấu hiệu nhóm chưa sẵn sàng làm việc cùng nhau lâu dài.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Chỉ thoả thuận miệng. Sáu tháng sau, mỗi người nhớ một kiểu, và không ai cố tình nhớ sai cả.',
          'Sao chép bản mẫu nước ngoài mà không điều chỉnh. Nhiều điều khoản trong bản mẫu Mỹ tham chiếu tới cơ chế pháp lý không tồn tại ở Việt Nam.',
          'Ký thoả thuận nhưng không cập nhật vào sổ đăng ký cổ đông và điều lệ. Hai văn bản nói khác nhau là tình huống rất khó xử khi có tranh chấp.',
        ],
      },
    ],
    faq: [
      {
        q: 'Thoả thuận này có giá trị pháp lý không?',
        a: 'Là hợp đồng dân sự giữa các bên nên có giá trị ràng buộc, nhưng phần liên quan tới cổ phần cần được phản ánh trong điều lệ và sổ đăng ký cổ đông thì mới thi hành thuận lợi. Đây là chỗ cần luật sư soạn hoặc rà lại.',
      },
      {
        q: 'Nhóm chỉ có hai người thì có cần không?',
        a: 'Càng cần. Hai người thì không có bên thứ ba để phân xử khi bất đồng, nên văn bản là thứ duy nhất hai bên cùng dựa vào.',
      },
      {
        q: 'Có nên thuê luật sư soạn không?',
        a: 'Nên. Đây là loại văn bản có hậu quả lâu dài, và chi phí soạn một lần nhỏ hơn nhiều so với chi phí xử lý tranh chấp về sau.',
      },
    ],
  },

  'chuyen-giao-so-huu-tri-tue': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Chuyển giao sở hữu trí tuệ về công ty là việc đảm bảo mã nguồn, thiết kế, thương hiệu và tài liệu do các cá nhân tạo ra thuộc quyền sở hữu của công ty, không phải của cá nhân đó.',
          'Đây là mục thẩm định pháp lý gần như luôn kiểm tra, và cũng là mục hay thiếu nhất ở startup giai đoạn đầu.',
        ],
      },
      {
        h: 'Vì sao nhà đầu tư quan tâm tới mức đó',
        p: [
          'Nếu sản phẩm vẫn thuộc quyền sở hữu của một cá nhân, thì công ty không thực sự sở hữu thứ nhà đầu tư đang mua.',
          'Tình huống xấu nhất: người viết phần lớn mã nguồn rời đi sau bất đồng, và về mặt pháp lý họ vẫn có quyền với phần mình tạo ra. Công ty rơi vào thế không thể tiếp tục kinh doanh bình thường.',
          'Vấn đề không phải là bạn nghi ngờ ai. Nó là rủi ro cấu trúc, và nhà đầu tư đã thấy nó xảy ra đủ nhiều để yêu cầu xử lý trước.',
        ],
      },
      {
        h: 'Ba nhóm người cần xử lý',
        p: [
          'Người sáng lập. Thường tạo ra phần lớn tài sản trí tuệ trong giai đoạn đầu, đôi khi trước cả khi công ty được thành lập. Phần tạo ra trước ngày thành lập cần thoả thuận chuyển giao riêng.',
          'Nhân sự có hợp đồng lao động. Pháp luật sở hữu trí tuệ có quy định về tác phẩm tạo ra trong quá trình thực hiện nhiệm vụ được giao, nhưng ghi rõ trong hợp đồng vẫn tốt hơn là dựa vào quy định chung.',
          'Cộng tác viên và bên thuê ngoài. Đây là nhóm hay bị bỏ sót nhất. Không có điều khoản chuyển giao rõ ràng thì quyền sở hữu có thể vẫn thuộc về họ.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Nghĩ rằng trả tiền là đương nhiên sở hữu. Với hợp đồng dịch vụ, việc trả tiền không tự động chuyển quyền sở hữu trí tuệ nếu hợp đồng không nói rõ.',
          'Bỏ qua phần tạo ra trước khi thành lập công ty. Bản demo viết trong ba tháng trước ngày đăng ký kinh doanh vẫn cần được chuyển giao chính thức.',
          'Quên tên miền và tài khoản. Tên miền đứng tên cá nhân, tài khoản quảng cáo và kho ứng dụng đăng ký bằng email cá nhân đều là những thứ thẩm định sẽ hỏi.',
        ],
      },
    ],
    faq: [
      {
        q: 'Làm việc này tốn bao nhiêu?',
        a: 'Thường là một bộ văn bản mẫu do luật sư soạn rồi dùng lại cho từng người, nên chi phí không lớn. Cái tốn là thời gian liên hệ lại với những người đã rời đi từ lâu, càng để lâu càng khó.',
      },
      {
        q: 'Người đã nghỉ việc từ hai năm trước thì sao?',
        a: 'Vẫn nên liên hệ để ký bổ sung. Phần lớn mọi người sẵn sàng ký khi được giải thích. Nếu không liên hệ được, cần ghi nhận rủi ro đó và trao đổi với luật sư về cách xử lý.',
      },
      {
        q: 'Có cần đăng ký bản quyền phần mềm không?',
        a: 'Không bắt buộc để có quyền, nhưng đăng ký giúp chứng minh khi có tranh chấp. Với startup giai đoạn đầu, việc quan trọng hơn là có đủ văn bản chuyển giao từ từng cá nhân.',
      },
    ],
  },

  'dieu-le-cong-ty': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Điều lệ là văn bản quy định cách công ty vận hành: ai có quyền quyết định gì, họp hành và biểu quyết ra sao, cổ phần chuyển nhượng thế nào.',
          'Đây là văn bản bắt buộc khi thành lập. Vấn đề là bản mẫu đi kèm dịch vụ thành lập nhanh thường chỉ đủ để đăng ký, không đủ để gọi vốn.',
        ],
      },
      {
        h: 'Những điều khoản bản mẫu hay thiếu',
        p: [
          'Quyền ưu tiên mua khi có cổ đông muốn bán ra ngoài. Không có điều khoản này, một cổ đông có thể bán phần của mình cho người mà những người còn lại không muốn làm việc cùng.',
          'Hạn chế chuyển nhượng cổ phần của người sáng lập. Nhà đầu tư gần như luôn yêu cầu, vì họ đầu tư vào con người.',
          'Thẩm quyền cụ thể của hội đồng quản trị và giám đốc. Quyết định nào cần thông qua hội đồng, mức chi tiêu nào giám đốc tự quyết được.',
          'Cơ chế xử lý khi có bế tắc trong biểu quyết, đặc biệt quan trọng với công ty chỉ có vài cổ đông.',
        ],
      },
      {
        h: 'Khi nào nên rà lại',
        p: [
          'Trước vòng gọi vốn đầu tiên. Sửa điều lệ khi đang đàm phán là việc làm chậm thương vụ và khiến bạn ở thế bị động.',
          'Việc rà lại thường mất một buổi làm việc với luật sư. So với công sức đã bỏ ra để chuẩn bị hồ sơ, đây là khoản đầu tư nhỏ.',
          'Lưu ý là sửa điều lệ cần nghị quyết của đại hội đồng cổ đông và thủ tục thay đổi đăng ký, nên không phải việc làm trong một ngày.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Không đọc bản điều lệ đang có hiệu lực. Nhiều người sáng lập chưa từng đọc hết điều lệ công ty mình.',
          'Để điều lệ mâu thuẫn với thoả thuận đồng sáng lập. Khi có tranh chấp, hai văn bản nói khác nhau tạo ra tình huống rất khó xử.',
          'Sao chép điều lệ của một công ty khác. Điều lệ phù hợp với cơ cấu sở hữu và cách vận hành cụ thể, không phải văn bản dùng chung được.',
        ],
      },
    ],
    faq: [
      {
        q: 'Điều lệ và thoả thuận cổ đông khác nhau thế nào?',
        a: 'Điều lệ là văn bản pháp lý bắt buộc, nộp cho cơ quan đăng ký kinh doanh và công khai. Thoả thuận cổ đông là hợp đồng riêng giữa các cổ đông, chi tiết hơn và không công khai. Hai văn bản phải nhất quán với nhau.',
      },
      {
        q: 'Sửa điều lệ có khó không?',
        a: 'Cần nghị quyết đại hội đồng cổ đông theo tỷ lệ biểu quyết quy định, sau đó làm thủ tục thay đổi đăng ký. Không quá phức tạp nhưng mất thời gian, nên làm trước khi cần.',
      },
      {
        q: 'Nhà đầu tư có yêu cầu sửa điều lệ không?',
        a: 'Thường có, để phản ánh các quyền họ được cấp trong hợp đồng đầu tư. Điều lệ càng gọn sẵn thì việc này càng nhanh.',
      },
    ],
  },

  'dang-ky-nhan-hieu': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Ở Việt Nam, quyền đối với nhãn hiệu phát sinh trên cơ sở đăng ký, theo nguyên tắc ai nộp đơn trước được ưu tiên trước. Dùng tên lâu năm mà không đăng ký không tự động cho bạn quyền với tên đó.',
          'Cơ quan tiếp nhận là Cục Sở hữu trí tuệ.',
        ],
      },
      {
        h: 'Vì sao nên nộp sớm',
        p: [
          'Thời gian xử lý đơn tính bằng năm, không phải tháng. Nộp hôm nay thì phải chờ khá lâu mới có kết quả, nên nộp muộn nghĩa là chịu rủi ro suốt thời gian chờ.',
          'Rủi ro thật nằm ở chỗ này: nhiều doanh nghiệp phát hiện tên mình đã bị người khác đăng ký đúng vào lúc bắt đầu được biết tới. Khi đó lựa chọn còn lại đều đắt, đàm phán mua lại, hoặc đổi tên và làm lại toàn bộ nhận diện.',
          'Chi phí nộp đơn nhỏ so với hậu quả. Đây là một trong những việc pháp lý có tỷ lệ lợi ích trên chi phí cao nhất ở giai đoạn đầu.',
        ],
      },
      {
        h: 'Nộp cho cái gì và nhóm nào',
        p: [
          'Nhãn hiệu có thể là tên thương hiệu, logo, hoặc kết hợp cả hai. Nhiều doanh nghiệp nộp cả phần chữ và phần hình để bảo hộ rộng hơn.',
          'Đơn phải chỉ rõ nhóm sản phẩm dịch vụ theo bảng phân loại quốc tế. Chọn nhóm sai thì bảo hộ không phủ được hoạt động thực tế của bạn.',
          'Nên tra cứu trước xem nhãn hiệu tương tự đã có ai đăng ký chưa. Việc này giúp tránh nộp đơn chắc chắn bị từ chối.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Đợi tới khi có doanh thu mới nộp. Đó thường cũng là lúc tên bắt đầu có giá trị và người khác để ý tới.',
          'Chỉ đăng ký tên miền rồi tưởng đã bảo hộ được thương hiệu. Tên miền và nhãn hiệu là hai thứ hoàn toàn khác nhau.',
          'Đăng ký đứng tên cá nhân người sáng lập thay vì công ty. Cùng loại vấn đề với sở hữu trí tuệ chưa chuyển giao, thẩm định sẽ phát hiện.',
        ],
      },
    ],
    faq: [
      {
        q: 'Chi phí đăng ký khoảng bao nhiêu?',
        a: 'Gồm lệ phí nhà nước và phí dịch vụ nếu thuê đại diện sở hữu công nghiệp. Tổng chi phí thường ở mức vài triệu tới trên chục triệu tuỳ số nhóm đăng ký. Nên hỏi báo giá cụ thể vì mức phí có thay đổi theo thời gian.',
      },
      {
        q: 'Chưa có kết quả thì có được dùng tên không?',
        a: 'Vẫn dùng được trong khi chờ. Nhưng bạn chưa có quyền để ngăn người khác dùng tên tương tự cho tới khi được cấp văn bằng.',
      },
      {
        q: 'Có cần đăng ký ở nước ngoài không?',
        a: 'Chỉ khi thực sự có kế hoạch kinh doanh ở đó. Với startup giai đoạn đầu tập trung thị trường trong nước, đăng ký tại Việt Nam trước là đủ.',
      },
    ],
  },

  'nghi-dinh-38-2018': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Nghị định 38/2018 quy định chi tiết về đầu tư cho doanh nghiệp nhỏ và vừa khởi nghiệp sáng tạo. Đây là khuôn khổ pháp lý cho việc lập và vận hành quỹ đầu tư khởi nghiệp sáng tạo tại Việt Nam.',
          'Với người gọi vốn, ý nghĩa thực tế là: một số quỹ trong nước đầu tư theo khuôn khổ này, và điều đó ảnh hưởng tới cách thương vụ được cấu trúc.',
        ],
      },
      {
        h: 'Vì sao người gọi vốn nên biết',
        p: [
          'Quỹ hoạt động theo nghị định này đầu tư bằng đồng Việt Nam vào doanh nghiệp Việt Nam, thủ tục trong nước, không cần đi qua pháp nhân nước ngoài.',
          'Điều đó đơn giản hoá rất nhiều thứ so với việc nhận vốn ngoại: không phải lập công ty ở Singapore, không phải xử lý chuyển tiền xuyên biên giới, thuế và kế toán nằm gọn trong một hệ thống.',
          'Đổi lại, khuôn khổ này có những giới hạn riêng về số lượng nhà đầu tư góp vốn và phạm vi hoạt động của quỹ. Chi tiết nên hỏi luật sư hoặc chính quỹ đó.',
        ],
      },
      {
        h: 'Điều này ảnh hưởng gì tới hồ sơ của bạn',
        p: [
          'Quỹ đầu tư theo khuôn khổ trong nước gần như luôn yêu cầu bạn có pháp nhân Việt Nam. Nếu đang tính lập công ty ở nước ngoài, cần cân nhắc điều này.',
          'Hồ sơ pháp lý và sổ sách kế toán theo chuẩn Việt Nam trở nên quan trọng hơn, vì thẩm định sẽ dựa trên đó.',
          'Các công cụ như SAFE, vốn là mẫu hợp đồng của Mỹ, có thể không phù hợp. Thương vụ thường được cấu trúc thành mua cổ phần trực tiếp.',
        ],
      },
      {
        h: 'Lưu ý về tính cập nhật',
        p: [
          'Quy định pháp luật thay đổi theo thời gian, và có thể đã có văn bản sửa đổi hoặc thay thế kể từ khi trang này được viết.',
          'Trước khi ra quyết định dựa trên nội dung ở đây, hãy kiểm tra văn bản đang có hiệu lực và trao đổi với luật sư.',
        ],
      },
    ],
    faq: [
      {
        q: 'Quỹ nào ở Việt Nam đầu tư theo khuôn khổ này?',
        a: 'Một số quỹ trong nước nêu rõ điều này trên trang chính thức của họ. Đây là thông tin đáng hỏi thẳng trong buổi gặp đầu tiên, vì nó ảnh hưởng tới cách thương vụ được làm.',
      },
      {
        q: 'Nhận vốn theo khuôn khổ trong nước có bất lợi gì không?',
        a: 'Không hẳn bất lợi, chỉ là khác. Thủ tục đơn giản hơn nhưng công cụ đầu tư ít linh hoạt hơn so với thông lệ quốc tế. Tuỳ kế hoạch dài hạn của bạn mà hướng nào phù hợp hơn.',
      },
      {
        q: 'Có thể nhận cả vốn trong nước lẫn nước ngoài không?',
        a: 'Được, nhưng cấu trúc sở hữu sẽ phức tạp hơn và cần tư vấn kỹ. Đây là loại quyết định nên bàn với luật sư trước khi ký bất cứ gì.',
      },
    ],
  },

  'nghi-dinh-13-2023': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Nghị định 13/2023 quy định về bảo vệ dữ liệu cá nhân, có hiệu lực từ tháng 7 năm 2023. Nếu sản phẩm của bạn thu thập thông tin người dùng, nghị định này áp dụng cho bạn.',
          'Đây là mục ngày càng được hỏi trong thẩm định, đặc biệt với sản phẩm hướng tới người tiêu dùng.',
        ],
      },
      {
        h: 'Ba nghĩa vụ cơ bản',
        p: [
          'Lấy sự đồng ý của người dùng trước khi thu thập và xử lý dữ liệu cá nhân. Sự đồng ý phải rõ ràng, người dùng biết mình đồng ý cho việc gì.',
          'Cho phép người dùng thực hiện quyền của họ: được biết, được truy cập, được chỉnh sửa, được xoá, và được rút lại sự đồng ý.',
          'Lập hồ sơ đánh giá tác động xử lý dữ liệu cá nhân và thực hiện các nghĩa vụ thông báo theo quy định. Phần thủ tục này nên hỏi luật sư vì có yêu cầu cụ thể về nội dung và thời hạn.',
        ],
      },
      {
        h: 'Việc tối thiểu nên làm sớm',
        p: [
          'Viết chính sách quyền riêng tư mô tả đúng những gì bạn thực sự làm. Chính sách sao chép từ website khác mà không khớp với hoạt động thật còn tệ hơn không có, vì nó tạo ra cam kết sai.',
          'Rà lại xem thực tế đang thu thập những gì. Nhiều đội ngũ ngạc nhiên khi liệt kê ra: công cụ đo lường, nhật ký máy chủ, biểu mẫu đăng ký, tệp cookie của bên thứ ba.',
          'Xây cơ chế cho phép người dùng yêu cầu xoá dữ liệu. Không cần phức tạp, nhưng phải thực sự hoạt động.',
        ],
      },
      {
        h: 'Lưu ý về tính cập nhật',
        p: [
          'Quy định về dữ liệu cá nhân đang trong giai đoạn hoàn thiện và có thể đã có văn bản mới kể từ khi trang này được viết.',
          'Nội dung ở đây chỉ nhằm giúp bạn biết vấn đề tồn tại và cần xử lý. Trước khi triển khai, hãy kiểm tra văn bản đang có hiệu lực và tham vấn luật sư.',
        ],
      },
    ],
    faq: [
      {
        q: 'Sản phẩm bán cho doanh nghiệp có phải tuân thủ không?',
        a: 'Có, nếu bạn xử lý dữ liệu cá nhân của người dùng cuối hoặc nhân sự khách hàng. Việc khách hàng là doanh nghiệp không loại trừ nghĩa vụ này.',
      },
      {
        q: 'Chưa có người dùng thì có cần làm gì không?',
        a: 'Chưa cần đầy đủ, nhưng nên thiết kế sản phẩm với ý thức về việc này từ đầu. Sửa cấu trúc dữ liệu sau khi đã có hàng nghìn người dùng khó hơn nhiều.',
      },
      {
        q: 'Nhà đầu tư có hỏi mục này không?',
        a: 'Ngày càng nhiều, nhất là với sản phẩm hướng tới người tiêu dùng. Có sẵn chính sách và cơ chế thực thi là điểm cộng trong thẩm định.',
      },
    ],
  },

  'burn-rate': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Burn rate là số tiền doanh nghiệp mất đi mỗi tháng. Có hai cách tính: đốt gộp là tổng chi, đốt ròng là tổng chi trừ doanh thu.',
          'Khi nói chuyện với nhà đầu tư, con số họ quan tâm gần như luôn là đốt ròng, đó mới là tiền thực sự rời khỏi tài khoản.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Tháng vừa rồi bạn chi 168 triệu cho lương, văn phòng, máy chủ và marketing. Doanh thu thu về 31 triệu.',
          'Đốt gộp là 168 triệu. Đốt ròng là 168 − 31 = 137 triệu.',
          'Nếu tài khoản còn 560 triệu, runway tính theo đốt ròng là khoảng 4,1 tháng. Tính nhầm theo đốt gộp sẽ ra 3,3 tháng. Bạn tưởng mình có ít thời gian hơn thực tế.',
        ],
      },
      {
        h: 'Nên tính theo tháng nào',
        p: [
          'Trung bình ba tháng gần nhất ổn định hơn lấy một tháng, vì không bị một khoản chi bất thường làm lệch. Đóng bảo hiểm cả năm hay mua thiết bị có thể làm một tháng trông tệ hơn thực tế nhiều.',
          'Nếu vừa có thay đổi lớn, tuyển thêm ba người, hoặc chuyển văn phòng, thì tháng gần nhất phản ánh đúng hiện trạng hơn. Trong trường hợp đó nên nói rõ vì sao chọn cách tính đó.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Quên các khoản định kỳ chưa tới hạn. Lương tháng mười ba, thuế phải nộp, hợp đồng thuê sắp gia hạn đều là tiền sẽ ra nhưng chưa xuất hiện trong chi phí tháng vừa rồi.',
          'Không tính lương của chính người sáng lập. Nhiều nhóm chưa nhận lương và bỏ khoản đó ra ngoài, khiến burn rate trông thấp giả tạo. Nhà đầu tư sẽ tự cộng vào, vì sau khi nhận vốn thì khoản đó là thật.',
          'Giả định doanh thu tăng đúng kế hoạch khi tính đốt ròng. Burn rate nên phản ánh hiện tại; phần tăng trưởng để riêng ở kịch bản.',
        ],
      },
    ],
    faq: [
      {
        q: 'Burn rate bao nhiêu là hợp lý?',
        a: 'Không có mức tuyệt đối. Điều quan trọng là mỗi đồng đốt ra mua được cột mốc gì. Đốt 100 triệu một tháng để xây sản phẩm chưa có ai dùng khác hẳn đốt cùng số đó khi doanh thu đang tăng đều.',
      },
      {
        q: 'Sau khi nhận vốn thì burn rate tăng bao nhiêu?',
        a: 'Thường tăng đáng kể, vì tiền gọi về chính là để tuyển người và đẩy bán hàng. Khi tính số tiền cần gọi, phải tính theo mức đốt tương lai chứ không phải mức hiện tại.',
      },
      {
        q: 'Đã có lãi thì burn rate bằng bao nhiêu?',
        a: 'Đốt ròng âm, tức tiền đang vào chứ không ra. Nhưng vẫn nên theo dõi đốt gộp, vì nó cho biết cấu trúc chi phí và mức độ nhạy cảm khi doanh thu chững lại.',
      },
    ],
  },

  'ltv-la-gi': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'LTV là tổng lãi gộp một khách hàng mang lại trong suốt thời gian họ còn dùng sản phẩm. Cách tính phổ biến nhất: lấy lãi gộp mỗi tháng nhân với số tháng khách hàng ở lại.',
          'Đây là con số bị lạm dụng nhiều nhất trong deck của startup giai đoạn đầu.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Mỗi khách trả 2 triệu một tháng. Biên lợi nhuận gộp 75%, tức mỗi tháng họ đóng góp 1,5 triệu.',
          'Tỷ lệ rời bỏ 4% một tháng, ngụ ý khách ở lại trung bình 1 ÷ 0,04 = 25 tháng.',
          'LTV = 1,5 triệu × 25 = 37,5 triệu.',
          'Lưu ý phải dùng lãi gộp chứ không phải doanh thu. Lấy 2 triệu × 25 = 50 triệu là con số sai, vì nó bỏ qua chi phí phục vụ khách.',
        ],
      },
      {
        h: 'Vì sao con số này thường không đáng tin ở giai đoạn đầu',
        p: [
          'Toàn bộ phép tính dựa vào tỷ lệ rời bỏ. Mà tỷ lệ rời bỏ tính từ hai tháng dữ liệu thì không phải số đo được. Nó là ước đoán.',
          'Vấn đề nằm ở chỗ con số kết quả trông giống hệt nhau. LTV tính từ hai tháng và LTV tính từ hai năm cùng hiện lên màn hình là "37,5 triệu". Người đọc không có cách nào phân biệt.',
          'Nhà đầu tư có kinh nghiệm sẽ hỏi ngay: cohort bao nhiêu tháng. Câu trả lời sai chỗ đó làm hỏng phần còn lại của buổi họp, kể cả khi mọi thứ khác đều tốt.',
          'Cách an toàn hơn: nói thẳng "chúng tôi giả định tỷ lệ rời bỏ 4%, dựa trên ba tháng dữ liệu" thay vì đưa ra một con số LTV như thể đã đo được.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Dùng doanh thu thay vì lãi gộp. Sai lệch có thể tới vài lần nếu biên lợi nhuận thấp.',
          'Không đặt trần cho vòng đời. Tỷ lệ rời bỏ 1% một tháng ngụ ý khách ở lại 100 tháng, hơn tám năm. Thông lệ là chặn ở 36 tháng, vì dự báo xa hơn ba năm không kiểm chứng được.',
          'Đưa LTV vào deck khi mới có vài tháng dữ liệu. Rủi ro lớn hơn lợi ích rất nhiều.',
        ],
      },
    ],
    faq: [
      {
        q: 'Cần bao nhiêu tháng dữ liệu mới nên đưa ra LTV?',
        a: 'Tối thiểu ba kỳ, và càng nhiều càng tốt. Dưới ba kỳ thì hãy trình bày như một giả định, không phải một số đo.',
      },
      {
        q: 'Sản phẩm bán một lần thì tính LTV thế nào?',
        a: 'Dựa trên tần suất mua lại thay vì thời gian thuê bao. Nếu khách trung bình mua hai lần trong đời thì LTV là lãi gộp của hai đơn hàng.',
      },
      {
        q: 'LTV bao nhiêu là tốt?',
        a: 'Một mình nó không nói gì. Nó chỉ có nghĩa khi đặt cạnh chi phí có được khách hàng, tỷ lệ giữa hai con số mới là thứ đáng nhìn.',
      },
    ],
  },

  'ty-le-ltv-cac': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Tỷ lệ LTV trên CAC cho biết mỗi đồng bỏ ra để có một khách hàng mang về bao nhiêu đồng lãi gộp trong suốt vòng đời của họ.',
          'Chuẩn thị trường là từ ba lần trở lên. Dưới một lần nghĩa là bán càng nhiều càng lỗ.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'LTV 37,5 triệu, CAC 3 triệu. Tỷ lệ là 12,5 lần.',
          'Con số này nghe rất đẹp, và đó chính là lúc nên nghi ngờ. Nếu nó dựa trên ba tháng dữ liệu thì gần như chắc chắn tỷ lệ rời bỏ đang được giả định quá lạc quan.',
          'Với CAC 20 triệu, tỷ lệ còn 1,9 lần, dưới chuẩn. Nghĩa là phần lớn tiền gọi được sẽ đi vào việc mua khách chứ không xây được gì bền.',
        ],
      },
      {
        h: 'Ba vùng đáng chú ý',
        p: [
          'Dưới 1 lần: mỗi khách mới làm bạn lỗ thêm. Phải sửa giá, biên lợi nhuận hoặc chi phí bán hàng trước khi đẩy tăng trưởng.',
          'Từ 1 đến 3 lần: có lãi trên mỗi khách nhưng biên mỏng. Mô hình chạy được nhưng cần quy mô rất lớn để bù chi phí cố định.',
          'Trên 10 lần với dữ liệu vài tháng: đáng nghi hơn là đáng mừng. Nhà đầu tư sẽ nghi ngờ trước khi ấn tượng, và họ sẽ hỏi cohort bao nhiêu tháng.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Tối ưu tỷ lệ bằng cách giảm chi marketing. Tỷ lệ đẹp lên nhưng tăng trưởng dừng lại, không phải điều nhà đầu tư muốn thấy.',
          'Bỏ lương đội bán hàng ra khỏi CAC. Tỷ lệ trông tốt hơn nhiều lần, và người đọc có kinh nghiệm phát hiện ngay.',
          'Chỉ nhìn tỷ lệ mà bỏ qua thời gian hoàn vốn. Tỷ lệ 5 lần nhưng hoàn vốn sau hai năm vẫn là vấn đề dòng tiền nghiêm trọng khi runway ngắn.',
        ],
      },
    ],
    faq: [
      {
        q: 'Vì sao chuẩn lại là ba lần?',
        a: 'Vì LTV chỉ tính lãi gộp, chưa trừ chi phí cố định như lương kỹ thuật, quản lý, văn phòng. Phần chênh ba lần là để bù những khoản đó và còn lại lợi nhuận.',
      },
      {
        q: 'Chưa có dữ liệu thì nói gì với nhà đầu tư?',
        a: 'Trình bày như giả định và nói rõ nó dựa trên đâu: giá đang bán, biên lợi nhuận thực tế, và tỷ lệ rời bỏ ước tính. Trung thực về mức độ chắc chắn tốt hơn nhiều so với một con số đẹp không đứng vững.',
      },
      {
        q: 'Tỷ lệ thấp thì có gọi được vốn không?',
        a: 'Được, nếu bạn giải thích được vì sao nó sẽ cải thiện và có kế hoạch cụ thể. Điều nhà đầu tư ngại là bạn không biết tỷ lệ của mình đang bao nhiêu.',
      },
    ],
  },

  'churn-rate': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Tỷ lệ rời bỏ là phần trăm khách hàng ngừng sử dụng sản phẩm trong một kỳ. Với sản phẩm thuê bao, thường tính theo tháng.',
          'Đây là con số quyết định giá trị vòng đời khách hàng, và cũng là con số dễ giả định sai nhất ở giai đoạn đầu.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Đầu tháng có 100 khách trả tiền, cuối tháng có 4 khách ngừng. Tỷ lệ rời bỏ là 4%.',
          'Từ đó suy ra vòng đời trung bình 1 ÷ 0,04 = 25 tháng.',
          'Với 100 khách thì mỗi khách rời đi làm tỷ lệ nhảy 1 điểm phần trăm. Đây là lý do con số này rất nhiễu khi số khách còn ít.',
        ],
      },
      {
        h: 'Hai mức bất thường cần cảnh giác',
        p: [
          'Dưới 0,5% một tháng ngụ ý khách ở lại hơn mười sáu năm. Ở giai đoạn đầu, con số này gần như luôn quá lạc quan, thường là do chưa đủ thời gian để thấy khách rời, không phải vì khách không rời.',
          'Trên 10% một tháng nghĩa là mất gần hết khách trong vòng một năm. Ở mức này, mọi đồng chi cho bán hàng đều chảy vào cái xô thủng. Phải xử lý việc giữ chân trước khi đẩy tăng trưởng. Nhà đầu tư cũng sẽ nói đúng câu đó.',
          'Giả định bằng 0 là dấu hiệu chưa đủ dữ liệu, không phải dấu hiệu sản phẩm hoàn hảo.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Tính trên tổng số khách thay vì trên nhóm cùng kỳ. Doanh nghiệp đang tăng trưởng nhanh có nhiều khách mới, khiến tỷ lệ rời bỏ trông thấp giả tạo.',
          'Không phân biệt rời bỏ theo số khách và theo doanh thu. Mất mười khách nhỏ khác hẳn mất một khách lớn, dù số lượng giống nhau.',
          'Coi khách hết hạn dùng thử là khách rời bỏ. Hai nhóm này nên tách riêng, nếu không con số mất ý nghĩa.',
        ],
      },
    ],
    faq: [
      {
        q: 'Tỷ lệ rời bỏ bao nhiêu là chấp nhận được?',
        a: 'Tuỳ mô hình và loại khách. Sản phẩm bán cho doanh nghiệp thường có tỷ lệ thấp hơn nhiều so với sản phẩm cho người tiêu dùng. Điều quan trọng là biết con số của mình và theo dõi xu hướng.',
      },
      {
        q: 'Cần bao nhiêu khách mới tính được có ý nghĩa?',
        a: 'Càng nhiều càng tốt. Dưới một trăm khách thì con số dao động rất mạnh giữa các tháng, nên hãy coi nó là ước lượng và nói rõ điều đó.',
      },
      {
        q: 'Rời bỏ âm nghĩa là gì?',
        a: 'Khi doanh thu tăng thêm từ khách hiện hữu lớn hơn doanh thu mất đi do khách rời. Đây là dấu hiệu rất tốt, nhưng hiếm gặp ở giai đoạn đầu.',
      },
    ],
  },

  'mrr-arr': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'MRR là doanh thu định kỳ hàng tháng, tổng số tiền khách hàng trả đều đặn mỗi tháng. ARR là con số đó nhân mười hai.',
          'Chỉ tính phần thực sự lặp lại. Một khoản triển khai thu một lần không phải MRR, dù nó nằm trong doanh thu tháng đó.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Bạn có 27 khách hàng, mỗi khách trả 2 triệu một tháng. MRR = 54 triệu. ARR = 648 triệu.',
          'Nếu trong tháng có thêm một khoản phí triển khai 30 triệu thu một lần, doanh thu tháng đó là 84 triệu nhưng MRR vẫn là 54 triệu.',
          'Trộn hai loại vào nhau là cách nhanh nhất làm mất niềm tin của người đọc có kinh nghiệm.',
        ],
      },
      {
        h: 'Bốn thành phần nên tách riêng',
        p: [
          'MRR mới từ khách hàng mới ký trong kỳ.',
          'MRR mở rộng từ khách hiện hữu nâng gói hoặc mua thêm.',
          'MRR co lại từ khách hạ gói.',
          'MRR mất đi từ khách ngừng hẳn.',
          'Bốn con số này cho biết tăng trưởng đến từ đâu. Hai doanh nghiệp cùng tăng MRR 20% một tháng có thể ở hai tình trạng hoàn toàn khác nhau, một bên nhờ khách cũ dùng nhiều hơn, một bên phải liên tục mua khách mới để bù cho khách rời đi.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Tính ARR bằng cách nhân doanh thu tháng tốt nhất với mười hai. Phải dùng MRR của tháng gần nhất, và chỉ phần thực sự định kỳ.',
          'Gộp cả doanh thu dịch vụ vào MRR. Doanh thu triển khai, tư vấn, đào tạo là doanh thu một lần và nên báo cáo riêng.',
          'Không ghi rõ ngày chốt số. MRR của ngày mùng một và ngày ba mươi mốt có thể khác nhau đáng kể khi đang tăng trưởng nhanh.',
        ],
      },
    ],
    faq: [
      {
        q: 'Khách trả theo năm thì tính MRR thế nào?',
        a: 'Chia đều cho mười hai tháng. Khách trả 24 triệu một năm đóng góp 2 triệu vào MRR mỗi tháng, dù tiền về một lần.',
      },
      {
        q: 'Chưa có doanh thu định kỳ thì báo cáo gì?',
        a: 'Báo cáo doanh thu thực tế và nói rõ nó là loại gì. Đừng cố biến doanh thu một lần thành ARR. Người đọc sẽ nhận ra và điều đó khiến mọi con số khác bị nghi ngờ.',
      },
      {
        q: 'ARR có phải doanh thu thật không?',
        a: 'Không hẳn. ARR là dự phóng dựa trên giả định khách hàng hiện tại tiếp tục trả trong mười hai tháng tới. Doanh thu kế toán và ARR là hai thứ khác nhau.',
      },
    ],
  },

  'kinh-te-don-vi': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Kinh tế đơn vị là bài toán lời lỗ trên một khách hàng, tách khỏi chi phí cố định của cả doanh nghiệp.',
          'Câu hỏi nó trả lời rất đơn giản: mỗi khách hàng mang lại nhiều hơn hay ít hơn số tiền bỏ ra để có được họ.',
        ],
      },
      {
        h: 'Vì sao nhà đầu tư quan tâm',
        p: [
          'Nếu kinh tế đơn vị âm, tăng trưởng làm mọi thứ tệ đi chứ không tốt lên. Bán càng nhiều càng lỗ, và tiền gọi được chỉ kéo dài thời gian trước khi vấn đề lộ ra.',
          'Nếu kinh tế đơn vị dương và ổn định, bài toán còn lại chỉ là quy mô. Đó là lúc bỏ tiền vào có ý nghĩa.',
          'Đây là lý do nhà đầu tư thường hỏi về nó trước khi hỏi về tổng doanh thu.',
        ],
      },
      {
        h: 'Bốn con số tạo nên bức tranh',
        p: [
          'Doanh thu bình quân mỗi khách một tháng.',
          'Biên lợi nhuận gộp, để biết mỗi tháng khách thực sự đóng góp bao nhiêu sau chi phí phục vụ.',
          'Chi phí có được một khách hàng.',
          'Tỷ lệ rời bỏ, để biết họ ở lại bao lâu.',
          'Từ bốn con số này suy ra được giá trị vòng đời, tỷ lệ so với chi phí, và thời gian hoàn vốn.',
        ],
      },
      {
        h: 'Ở giai đoạn đầu thì làm sao',
        p: [
          'Phần lớn startup pre-seed chưa có đủ dữ liệu để đo. Điều đó bình thường và nhà đầu tư biết.',
          'Việc nên làm không phải đo, mà là soát giả định. Giá bạn định thu có hợp lý so với giá trị mang lại không. Chi phí phục vụ mỗi khách bạn ước tính đã tính đủ hạ tầng và hỗ trợ chưa. Tỷ lệ rời bỏ bạn giả định có quá lạc quan không.',
          'Trình bày như giả định kèm cơ sở, thay vì như số đo. Đó là cách duy nhất trung thực khi mới có vài tháng dữ liệu.',
        ],
      },
    ],
    faq: [
      {
        q: 'Chi phí nào tính vào biên lợi nhuận gộp?',
        a: 'Chi phí trực tiếp để phục vụ khách: hạ tầng máy chủ, phí thanh toán, hỗ trợ khách hàng, giá vốn hàng bán. Lương kỹ thuật xây sản phẩm chung thường không tính vào.',
      },
      {
        q: 'Kinh tế đơn vị âm thì có gọi được vốn không?',
        a: 'Có, nếu bạn giải thích được vì sao nó sẽ dương và khi nào. Nhiều mô hình cần quy mô mới có biên tốt. Điều nhà đầu tư ngại là bạn không biết mình đang âm.',
      },
      {
        q: 'Bao lâu nên tính lại một lần?',
        a: 'Hàng quý là hợp lý ở giai đoạn đầu. Tính hàng tháng thì con số nhiễu; tính hàng năm thì phát hiện vấn đề quá muộn.',
      },
    ],
  },

  'mo-hinh-tai-chinh': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Mô hình tài chính là bảng dự báo doanh thu, chi phí và dòng tiền theo từng tháng. Với startup giai đoạn đầu, khoảng thời gian hợp lý là mười tám tới hai mươi bốn tháng.',
          'Không ai tin dự báo ba năm ở vòng pre-seed. Cái nhà đầu tư xem là bạn có hiểu cấu trúc chi phí của chính mình không.',
        ],
      },
      {
        h: 'Dựng từ dưới lên, không phải từ mục tiêu xuống',
        p: [
          'Cách sai phổ biến: đặt mục tiêu "năm thứ hai doanh thu 50 tỷ" rồi chia ngược ra từng tháng. Bảng đó luôn đẹp và không ai tin.',
          'Cách đúng: nhập số khách mới mỗi tháng, đà tăng, tỷ lệ rời bỏ, giá bán. Doanh thu là kết quả.',
          'Nếu kết quả nhỏ hơn mong đợi thì đó là thông tin, không phải lỗi cần sửa bằng cách nâng giả định lên.',
        ],
      },
      {
        h: 'Những gì bảng nên có',
        p: [
          'Số khách hàng đầu kỳ, khách mới, khách rời, khách cuối kỳ. Bốn dòng này cho người đọc kiểm chứng được doanh thu.',
          'Chi phí nhân sự khai theo từng đợt tuyển có tháng bắt đầu riêng. Phần lớn tiền gọi được đi vào lương, và thời điểm tuyển quyết định dòng tiền.',
          'Dòng tiền cuối kỳ, để thấy rõ tháng nào là tháng thấp nhất.',
          'Vòng vốn dự kiến, đánh dấu tháng tiền về.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Chỉ có số tổng mà không có các dòng dẫn tới nó. Người đọc không nhân thử được thì họ không tin.',
          'Bỏ tỷ lệ rời bỏ ra khỏi mô hình. Bảng không có dòng khách rời là dấu hiệu bảng chưa được soát.',
          'Không cho lương người sáng lập vào. Sau khi nhận vốn thì đó là chi phí thật.',
          'Giả định đà tăng trưởng cao duy trì suốt kỳ. Trên ba mươi phần trăm mỗi tháng liên tục là mức rất hiếm, và người đọc sẽ hỏi kênh nào tạo ra đà đó.',
        ],
      },
    ],
    faq: [
      {
        q: 'Nên làm bằng Excel hay phần mềm chuyên dụng?',
        a: 'Excel là đủ và có lợi thế lớn: người nhận mở được ngay và bấm vào ô để xem công thức. Người Việt Nam đặc biệt thích kiểm chứng bằng cách đó.',
      },
      {
        q: 'Dự báo sai thì sao?',
        a: 'Gần như chắc chắn sẽ sai, và nhà đầu tư biết. Cái họ đánh giá là logic đằng sau, không phải độ chính xác của con số.',
      },
      {
        q: 'Có cần dự báo bảng cân đối kế toán không?',
        a: 'Ở vòng pre-seed thì thường không. Dòng tiền và lãi lỗ là đủ. Bảng cân đối trở nên quan trọng từ vòng sau.',
      },
    ],
  },

  'payback-period': {
    lienQuan: ['magic-number-saas', 'arpu-acv'],
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Thời gian hoàn vốn khách hàng là số tháng để lãi gộp từ một khách bù lại chi phí đã bỏ ra để có được họ.',
          'Khác với tỷ lệ giá trị vòng đời trên chi phí, vốn nhìn cả vòng đời. Con số này nhìn vào dòng tiền ngắn hạn.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Chi phí có được một khách là 3 triệu. Mỗi tháng khách đóng góp 1,5 triệu lãi gộp.',
          'Thời gian hoàn vốn = 3 ÷ 1,5 = 2 tháng.',
          'Nếu chi phí là 20 triệu thì thời gian hoàn vốn là hơn 13 tháng, mỗi khách mới làm cạn tiền mặt trong hơn một năm trước khi bắt đầu sinh lời.',
        ],
      },
      {
        h: 'Vì sao con số này quan trọng hơn ở giai đoạn đầu',
        p: [
          'Runway ngắn khiến dòng tiền quan trọng hơn lợi nhuận dài hạn. Tỷ lệ giá trị vòng đời trên chi phí 5 lần nghe rất tốt, nhưng nếu phải chờ hai năm mới hoàn vốn thì bạn hết tiền trước khi thấy khoản lãi đó.',
          'Thời gian hoàn vốn cũng quyết định tốc độ tăng trưởng khả thi. Hoàn vốn hai tháng nghĩa là tiền quay vòng nhanh, tái đầu tư được. Hoàn vốn mười tám tháng nghĩa là mỗi khách mới cần vốn nằm chờ rất lâu.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Dùng doanh thu thay vì lãi gộp. Kết quả trông đẹp hơn nhưng không phản ánh tiền thực sự còn lại.',
          'Không tính tới việc khách có thể rời đi trước khi hoàn vốn. Nếu thời gian hoàn vốn dài hơn vòng đời trung bình thì mô hình lỗ, dù các con số riêng lẻ trông ổn.',
          'Coi mốc mười hai tháng là chuẩn cứng. Mốc phù hợp phụ thuộc runway và khả năng tiếp cận vốn của bạn, không phải một con số chung.',
        ],
      },
    ],
    faq: [
      {
        q: 'Bao nhiêu tháng là chấp nhận được?',
        a: 'Với startup giai đoạn đầu, dưới mười hai tháng là vùng thoải mái. Trên mười tám tháng là rủi ro dòng tiền thật khi runway ngắn.',
      },
      {
        q: 'Rút ngắn thời gian hoàn vốn bằng cách nào?',
        a: 'Ba hướng: giảm chi phí có được khách, tăng giá, hoặc cải thiện biên lợi nhuận gộp. Cách thứ tư ít người nghĩ tới là thu tiền theo năm thay vì theo tháng.',
      },
      {
        q: 'Có nên ưu tiên con số này hơn tỷ lệ vòng đời trên chi phí không?',
        a: 'Ở giai đoạn runway ngắn thì có. Khi đã có vốn dài hạn thì tỷ lệ vòng đời quan trọng hơn. Cả hai nên nhìn cùng lúc.',
      },
    ],
  },

  'cliff-vesting': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Cliff là khoảng thời gian đầu của lịch vesting mà người nhận chưa sở hữu cổ phần nào. Đủ mốc cliff, họ nhận trọn phần đã tích luỹ trong khoảng đó, rồi từ đó nhận tiếp theo từng tháng.',
          'Mốc thông lệ là mười hai tháng.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Bạn được chia 50% công ty, vesting bốn năm, cliff mười hai tháng.',
          'Tháng thứ mười một: bạn sở hữu 0%.',
          'Tháng thứ mười hai: bạn nhận trọn một phần tư của 50%, tức 12,5%.',
          'Từ tháng mười ba trở đi: nhận thêm khoảng 1,04% mỗi tháng cho tới hết bốn năm.',
          'Rời đi ở tháng thứ mười: bạn không giữ gì cả. Rời ở tháng mười ba: giữ khoảng 13,5%.',
        ],
      },
      {
        h: 'Cliff sinh ra để làm gì',
        p: [
          'Để lọc người bỏ cuộc sớm. Một năm đầu là quãng khó nhất, và không hiếm trường hợp có người nhận ra đây không phải việc mình muốn làm sau vài tháng.',
          'Không có cliff, người rời sau ba tháng vẫn giữ vài phần trăm công ty vĩnh viễn, phần đó gọi là cổ phần chết và nó theo công ty suốt các vòng gọi vốn sau.',
          'Cliff bảo vệ chính người ở lại, không phải công cụ để ai kiểm soát ai.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Đặt cliff dưới mười hai tháng cho gọn tình cảm. Sáu tháng không đủ để biết một người có phù hợp không, mà đó chính là việc cliff sinh ra để làm.',
          'Không ghi rõ ngày bắt đầu tính. Ngày ký hợp đồng, ngày thành lập công ty và ngày người đó thực sự bắt đầu làm việc có thể cách nhau vài tháng.',
          'Quên rằng cliff áp dụng cho cả nhân sự được cấp cổ phần, không chỉ người sáng lập.',
        ],
      },
    ],
    faq: [
      {
        q: 'Người rời đi ngay trước mốc cliff thì sao?',
        a: 'Theo đúng thoả thuận thì họ không giữ gì. Trên thực tế một số nhóm thương lượng lại vì lý do riêng, nhưng đó là quyết định tự nguyện chứ không phải nghĩa vụ.',
      },
      {
        q: 'Có nên đặt cliff cho người đã làm việc từ trước khi lập công ty?',
        a: 'Nên, nhưng tính ngày bắt đầu ngược về thời điểm họ thực sự bắt đầu làm việc. Cách này công bằng hơn là bắt họ chờ thêm một năm nữa.',
      },
      {
        q: 'Cliff có áp dụng cho nhà đầu tư không?',
        a: 'Không. Nhà đầu tư mua cổ phần bằng tiền và sở hữu ngay. Vesting chỉ áp dụng cho cổ phần nhận vì công sức đóng góp.',
      },
    ],
  },

  'option-pool-shuffle': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Option pool shuffle là điều khoản đưa việc mở rộng quỹ cổ phiếu thưởng vào phần pre-money của vòng gọi vốn. Kết quả: chỉ người sáng lập và cổ đông hiện hữu gánh phần pha loãng đó, nhà đầu tư mới không mất gì.',
          'Đây là điều khoản âm thầm tốn của người gọi vốn lần đầu nhiều phần trăm nhất, và cũng là điều khoản ít người biết là có thể đàm phán.',
        ],
      },
      {
        h: 'Thấy rõ bằng số cụ thể',
        p: [
          'Hai người sáng lập giữ 1.000.000 cổ phần. Vòng pre-seed gọi 6 tỷ trên định giá pre-money 24 tỷ, kèm quỹ cổ phiếu thưởng 10% sau vòng.',
          'Lấy từ phần pre-money: nhà đầu tư mới nhận đúng 20%, quỹ chiếm 10%, nhóm sáng lập còn 70%.',
          'Lấy sau vòng: quỹ vẫn 10%, nhưng nhà đầu tư mới xuống dưới 20% và nhóm sáng lập giữ được nhiều hơn 70%.',
          'Chênh lệch vài điểm phần trăm nghe nhỏ, nhưng ở vòng đầu nó lớn hơn tác động của việc đàm phán thêm vài tỷ định giá.',
        ],
      },
      {
        h: 'Vì sao nhà đầu tư yêu cầu như vậy',
        p: [
          'Lập luận của họ hợp lý: quỹ cổ phiếu thưởng dùng để tuyển người phục vụ giai đoạn sắp tới, tức là chi phí thuộc về giai đoạn trước khi họ vào.',
          'Lập luận ngược lại cũng hợp lý: những người được tuyển bằng quỹ đó tạo ra giá trị cho tất cả cổ đông, kể cả nhà đầu tư mới.',
          'Không có bên nào sai. Đây là điều khoản thương lượng, và kết quả phụ thuộc vào vị thế của hai bên.',
        ],
      },
      {
        h: 'Ba cách xử lý',
        p: [
          'Đàm phán để quỹ tính sau vòng. Cách trực diện nhất, nhưng thường bị từ chối vì trái thông lệ.',
          'Đàm phán quy mô quỹ nhỏ hơn. Nếu kế hoạch tuyển mười tám tháng tới chỉ cần 7% thì đừng lập 15%. Phần dư là phần bạn đã pha loãng mà chưa đổi lấy gì.',
          'Chấp nhận nhưng tính vào định giá. Nếu quỹ lấy từ pre-money, hãy coi đó là một khoản giảm định giá thực tế và đàm phán con số định giá cao hơn tương ứng.',
        ],
      },
    ],
    faq: [
      {
        q: 'Có thể từ chối lập quỹ cổ phiếu thưởng không?',
        a: 'Rất khó với vòng có quỹ tham gia, vì họ coi đó là điều kiện để công ty tuyển được người. Thứ đàm phán được là quy mô và cách tính, không phải việc có lập hay không.',
      },
      {
        q: 'Quy mô bao nhiêu là hợp lý?',
        a: 'Mười tới mười lăm phần trăm ở vòng đầu là thông lệ. Con số nên bám theo kế hoạch tuyển cụ thể, bao nhiêu vị trí, mỗi vị trí dự kiến cấp bao nhiêu.',
      },
      {
        q: 'Làm sao biết mình đang bị áp cách tính nào?',
        a: 'Đọc kỹ term sheet, tìm cụm nói quỹ được tính trên vốn hoá pre-money hay post-money. Nếu không rõ, hỏi thẳng. Đây là câu hỏi hoàn toàn bình thường.',
      },
    ],
  },

  'co-phan-pho-thong': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Cổ phần phổ thông là loại cổ phần cơ bản, thường do người sáng lập và nhân sự nắm giữ. Nó có quyền biểu quyết nhưng không có ưu tiên đặc biệt nào khi công ty chia tài sản.',
          'Khi công ty bán đi, người giữ cổ phần phổ thông nhận tiền sau cùng.',
        ],
      },
      {
        h: 'Vì sao thứ tự nhận tiền lại quan trọng',
        p: [
          'Nhà đầu tư thường nhận cổ phần ưu đãi, kèm quyền ưu tiên thanh toán. Họ lấy phần của mình trước, phần còn lại mới chia cho cổ phần phổ thông.',
          'Ví dụ: quỹ đầu tư 6 tỷ với quyền ưu tiên một lần. Công ty sau đó bán được 20 tỷ. Quỹ lấy 6 tỷ trước, 14 tỷ còn lại chia theo tỷ lệ cho tất cả.',
          'Nếu công ty chỉ bán được 6 tỷ, quỹ lấy hết và cổ phần phổ thông không nhận gì, dù trên giấy tờ họ vẫn sở hữu phần lớn công ty.',
          'Đây là lý do tỷ lệ phần trăm không phải toàn bộ câu chuyện.',
        ],
      },
      {
        h: 'Điều đáng chú ý ở giai đoạn đầu',
        p: [
          'Ở vòng angel và pre-seed, nhiều thương vụ vẫn dùng cổ phần phổ thông cho cả nhà đầu tư, hoặc dùng SAFE nên chưa phát sinh phân loại.',
          'Từ vòng seed trở đi, cổ phần ưu đãi trở nên phổ biến. Đây là lúc điều lệ và hợp đồng đầu tư cần được soạn kỹ.',
          'Với người sáng lập, điều nên nhớ: bạn gần như luôn giữ cổ phần phổ thông, nên mọi điều khoản ưu tiên đều tác động tới bạn.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Chỉ đàm phán tỷ lệ phần trăm mà bỏ qua điều khoản ưu tiên thanh toán. Một thương vụ định giá cao kèm ưu tiên bất lợi có thể tệ hơn định giá thấp với điều khoản sạch.',
          'Không hiểu mình đang giữ loại nào. Đây là câu hỏi nên trả lời được ngay lập tức về chính công ty mình.',
          'Cấp cổ phần ưu đãi cho nhân sự. Thông lệ là nhân sự nhận cổ phần phổ thông; cấp ưu đãi tạo ra rắc rối không cần thiết.',
        ],
      },
    ],
    faq: [
      {
        q: 'Cổ phần phổ thông có kém hơn không?',
        a: 'Về quyền ưu tiên thì có. Nhưng khi công ty thành công lớn, hai loại thường được đối xử như nhau vì cổ phần ưu đãi chuyển thành phổ thông khi có lợi hơn cho người nắm giữ.',
      },
      {
        q: 'Có nên yêu cầu cổ phần ưu đãi cho người sáng lập không?',
        a: 'Rất hiếm và thường không được chấp nhận. Nỗ lực nên đặt vào việc giữ điều khoản ưu tiên của nhà đầu tư ở mức thông lệ, thay vì đòi ưu đãi cho mình.',
      },
      {
        q: 'Ở Việt Nam có phân loại cổ phần như vậy không?',
        a: 'Luật Doanh nghiệp có quy định về cổ phần ưu đãi với một số loại nhất định. Cách áp dụng cho thương vụ đầu tư cụ thể cần hỏi luật sư, vì nó khác với thông lệ quốc tế ở vài điểm.',
      },
    ],
  },

  'co-phan-uu-dai': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Cổ phần ưu đãi là loại cổ phần có thêm quyền so với cổ phần phổ thông. Trong thương vụ đầu tư, quyền quan trọng nhất thường là ưu tiên nhận tiền khi công ty bán đi.',
          'Nhà đầu tư nhận loại này, người sáng lập giữ cổ phần phổ thông.',
        ],
      },
      {
        h: 'Ba nhóm quyền hay gặp',
        p: [
          'Ưu tiên thanh toán. Nhận lại phần vốn của mình trước khi chia cho cổ phần phổ thông. Mức một lần không tham gia chia tiếp là thông lệ; các biến thể khác có thể lấy đi phần lớn giá trị trong một thương vụ bán vừa phải.',
          'Quyền phủ quyết với một số quyết định lớn: bán công ty, phát hành thêm cổ phần, thay đổi điều lệ, vay vượt hạn mức.',
          'Quyền chuyển đổi thành cổ phần phổ thông khi có lợi hơn, và quyền chống pha loãng khi vòng sau định giá thấp hơn.',
        ],
      },
      {
        h: 'Điều khoản đáng đàm phán nhất',
        p: [
          'Mức ưu tiên thanh toán. Một lần là thông lệ. Nếu term sheet ghi mức cao hơn, đó là điều khoản cần hỏi vì sao.',
          'Có tham gia chia tiếp hay không. Loại "không tham gia" nghĩa là nhà đầu tư chọn một trong hai: lấy phần vốn ưu tiên, hoặc chuyển sang phổ thông và chia theo tỷ lệ. Loại "có tham gia" cho họ lấy cả hai, bất lợi rõ rệt cho người sáng lập trong thương vụ bán quy mô vừa.',
          'Phạm vi quyền phủ quyết. Càng rộng thì công ty càng khó ra quyết định nhanh, đặc biệt khi có nhiều nhà đầu tư ở nhiều vòng.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Đổi định giá cao lấy điều khoản ưu tiên nặng. Con số định giá đưa lên báo, còn điều khoản mới quyết định bạn nhận được bao nhiêu thật.',
          'Không tính thử kịch bản bán ở mức trung bình. Phần lớn thương vụ không phải thành công rực rỡ, và đó là lúc điều khoản ưu tiên phát huy tác dụng mạnh nhất.',
          'Chấp nhận điều khoản mà không hỏi luật sư vì thấy nó "chuẩn". Có những mức được coi là chuẩn ở thị trường khác nhưng không phải ở đây.',
        ],
      },
    ],
    faq: [
      {
        q: 'Điều khoản ưu tiên chồng lên nhau qua nhiều vòng thế nào?',
        a: 'Mỗi vòng thường có ưu tiên riêng, và thứ tự nhận tiền phụ thuộc cách các vòng được xếp. Sau ba vòng, tổng phần ưu tiên có thể lớn hơn giá bán trong kịch bản trung bình. Đây là lúc người sáng lập không nhận được gì.',
      },
      {
        q: 'Có thương vụ nào không dùng cổ phần ưu đãi không?',
        a: 'Có, đặc biệt ở vòng angel và pre-seed nhỏ. Nhiều nhà đầu tư cá nhân nhận cổ phần phổ thông hoặc dùng SAFE để đơn giản hoá.',
      },
      {
        q: 'Nên nhờ ai rà điều khoản này?',
        a: 'Luật sư có kinh nghiệm với thương vụ đầu tư, không phải luật sư doanh nghiệp thông thường. Đây là lĩnh vực hẹp và khác biệt rất lớn.',
      },
    ],
  },

  'pha-loang-toan-phan': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Pha loãng toàn phần là cách tính tỷ lệ sở hữu có tính cả những cổ phần chưa được phát hành nhưng chắc chắn sẽ xuất hiện: quỹ cổ phiếu thưởng chưa cấp hết, các khoản SAFE đang chờ chuyển đổi, quyền mua cổ phần đã cấp.',
          'Đây là cách tính mà nhà đầu tư dùng, và thường cho ra con số thấp hơn cách tính đơn giản.',
        ],
      },
      {
        h: 'Vì sao hai cách tính cho ra hai con số',
        p: [
          'Công ty có 1.000.000 cổ phần đã phát hành, trong đó người sáng lập giữ 900.000. Tính theo cổ phần đã phát hành, họ giữ 90%.',
          'Nhưng còn quỹ cổ phiếu thưởng 150.000 cổ phần chưa cấp, và một khoản SAFE sẽ thành khoảng 100.000 cổ phần.',
          'Tính toàn phần: 900.000 chia cho 1.250.000, tức 72%.',
          'Chênh lệch mười tám điểm phần trăm không phải lỗi tính toán, đó là hai câu hỏi khác nhau.',
        ],
      },
      {
        h: 'Nên dùng cách nào khi nào',
        p: [
          'Khi nói chuyện với nhà đầu tư, luôn dùng cách toàn phần. Họ sẽ tự tính lại theo cách đó, và nếu con số bạn đưa ra cao hơn thì bạn mất uy tín ngay.',
          'Khi tính quyền biểu quyết, dùng cổ phần đã phát hành, vì cổ phần chưa phát hành không biểu quyết được.',
          'Điều quan trọng là nói rõ mình đang dùng cách nào. Đưa ra con số mà không nói cơ sở là nguồn gốc của rất nhiều hiểu nhầm.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Nói tỷ lệ theo cách có lợi cho mình mà không ghi chú. Người nghe có kinh nghiệm sẽ hỏi ngay, và câu trả lời lúng túng khiến họ nghi ngờ mọi con số khác.',
          'Quên các khoản SAFE khi tính. Đây là phần bị bỏ sót nhiều nhất, vì SAFE chưa xuất hiện trong sổ đăng ký cổ đông.',
          'Tính quỹ cổ phiếu thưởng theo phần đã cấp thay vì toàn bộ quỹ. Phần để dành vẫn sẽ được cấp, nên phải tính vào.',
        ],
      },
    ],
    faq: [
      {
        q: 'Trong term sheet thì tỷ lệ được tính theo cách nào?',
        a: 'Gần như luôn là toàn phần. Nếu văn bản không nói rõ, đây là điều cần hỏi trước khi ký.',
      },
      {
        q: 'Cách tính này có làm tỷ lệ của tôi trông tệ hơn không?',
        a: 'Có, nhưng nó phản ánh đúng thực tế sẽ xảy ra. Biết trước con số thật tốt hơn là bất ngờ khi thẩm định.',
      },
      {
        q: 'Cổ phần đã cấp cho nhân sự nhưng chưa vesting hết thì tính thế nào?',
        a: 'Trong cách tính toàn phần thì tính đủ, vì phần chưa vesting vẫn sẽ được nhận nếu người đó ở lại. Riêng khi tính quyền biểu quyết thì có thể khác, tuỳ điều lệ.',
      },
    ],
  },

  'quyen-mua-them': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Quyền mua thêm cho phép nhà đầu tư hiện hữu bỏ thêm tiền ở vòng sau để giữ nguyên tỷ lệ sở hữu của mình, thay vì bị pha loãng.',
          'Đây là điều khoản phổ biến và thường hợp lý, nhưng có tác động tới người sáng lập mà ít ai tính trước.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Nhà đầu tư vòng pre-seed giữ 20%. Vòng seed gọi thêm 20 tỷ, và nếu không làm gì thì tỷ lệ của họ giảm xuống còn 16%.',
          'Dùng quyền mua thêm, họ bỏ thêm tiền để mua đủ phần giữ lại 20%. Phần họ mua thêm đó lấy từ chỗ dành cho nhà đầu tư mới, hoặc nếu vòng đã chốt quy mô, lấy từ chỗ của người sáng lập.',
          'Điều này nghĩa là: mỗi vòng bạn không chỉ pha loãng vì tiền mới, mà còn vì người cũ giữ tỷ lệ.',
        ],
      },
      {
        h: 'Mặt tốt của điều khoản này',
        p: [
          'Nhà đầu tư cũ tiếp tục bỏ tiền là tín hiệu rất mạnh với nhà đầu tư mới. Người hiểu công ty nhất vẫn muốn tăng phần của mình.',
          'Ngược lại, nhà đầu tư cũ có quyền mà không dùng cũng là tín hiệu, và là tín hiệu nhà đầu tư mới sẽ hỏi tới.',
          'Vì vậy điều khoản này không chỉ là quyền, nó còn là thông tin.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Không tính quyền mua thêm khi lập kế hoạch pha loãng. Bạn tưởng vòng seed chỉ bán 20% cho người mới, thực tế tổng phần bán ra lớn hơn.',
          'Cấp quyền này cho mọi nhà đầu tư nhỏ. Khi có mười người cùng có quyền, việc điều phối vòng sau trở nên rất phiền. Thông lệ là chỉ cấp cho những người đầu tư trên một mức nhất định.',
          'Không đặt thời hạn thực hiện quyền. Cần có khoảng thời gian rõ ràng để họ quyết định, nếu không vòng gọi vốn bị treo.',
        ],
      },
    ],
    faq: [
      {
        q: 'Có thể từ chối cấp quyền này không?',
        a: 'Với nhà đầu tư nhỏ thì thường được. Với nhà đầu tư dẫn dắt thì rất khó, vì đó là một phần lý do họ tham gia sớm.',
      },
      {
        q: 'Quyền này kéo dài bao lâu?',
        a: 'Tuỳ hợp đồng. Có bản chỉ áp dụng cho vòng kế tiếp, có bản kéo dài tới khi công ty niêm yết. Đây là điểm đáng đàm phán.',
      },
      {
        q: 'Nhà đầu tư không dùng quyền thì sao?',
        a: 'Họ bị pha loãng bình thường. Nhưng việc không dùng quyền là thông tin mà nhà đầu tư mới sẽ chú ý, nên đôi khi tốt hơn là trao đổi trước với họ về lý do.',
      },
    ],
  },

  'vong-seed': {
    capNhat: '2026-10-29',
    lienQuan: ['vong-pre-seed', 'series-a', 'goi-von-la-gi', 'nha-dau-tu-thien-than', 'so-tien-goi-von', 'traction-la-gi'],
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Seed (seed round, vòng hạt giống) là vòng gọi vốn sau [[vong-pre-seed|pre-seed]], diễn ra khi đã có bằng chứng thị trường rõ ràng và thường đã có doanh thu đang tăng.',
          'Đây là vòng đầu tiên mà số liệu thực sự quan trọng, không chỉ là câu chuyện và đội ngũ.',
        ],
      },
      {
        h: 'Thứ tự các vòng gọi vốn: pre-seed, seed, Series A',
        p: [
          'Các vòng gọi vốn của startup thường đi theo thứ tự: vòng angel hoặc [[vong-pre-seed|pre-seed]], rồi seed, rồi [[series-a|Series A]], sau đó là Series B và các vòng tiếp theo. Mỗi vòng đòi hỏi mức bằng chứng cao hơn vòng trước.',
          'Pre-seed: đã có sản phẩm chạy được và vài khách dùng thử, nhưng chưa có doanh thu đáng kể. Nhà đầu tư chủ yếu đánh giá đội ngũ và vấn đề.',
          'Seed: đã có người trả tiền, doanh thu đang tăng, bắt đầu có số liệu giữ chân khách hàng. Nhà đầu tư bắt đầu hỏi chỉ số.',
          'Series A: vòng vốn thể chế đầu tiên, thường yêu cầu doanh thu ổn định và mô hình kinh doanh đã kiểm chứng.',
          'Ranh giới giữa các vòng không cố định, tên vòng do người gọi vốn tự đặt. Điều quyết định là bạn đang có bằng chứng gì. Bài [[/playbook/tu-pre-series-a-len-series-a-o-viet-nam|Từ pre-Series A lên Series A ở Việt Nam]] có số thương vụ và quy mô vòng ở thị trường Việt Nam.',
        ],
      },
      {
        h: 'Khác biệt lớn nhất so với pre-seed',
        p: [
          'Nhà đầu tư bắt đầu hỏi về chỉ số: doanh thu định kỳ, tốc độ tăng, tỷ lệ giữ chân khách hàng, chi phí có được khách hàng.',
          'Thẩm định kỹ hơn nhiều. Hồ sơ pháp lý, sổ sách kế toán, hợp đồng khách hàng đều được xem.',
          'Điều khoản phức tạp hơn. Cổ phần ưu đãi, quyền ưu tiên thanh toán, ghế hội đồng quản trị trở nên phổ biến.',
        ],
      },
      {
        h: 'Cột mốc thường cần đạt',
        p: [
          'Sản phẩm đã có người dùng trả tiền và họ ở lại, không chỉ dùng thử rồi bỏ.',
          'Có dấu hiệu về kênh tăng trưởng hoạt động được, biết cách có thêm khách hàng chứ không phải chờ họ tự tìm đến.',
          'Kinh tế đơn vị ít nhất là hiểu được, kể cả khi chưa dương. Bạn phải biết mỗi khách lời hay lỗ và vì sao.',
          'Đội ngũ đã bổ sung được những vị trí then chốt còn thiếu ở vòng trước.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Gọi seed khi mới chỉ có tăng trưởng người dùng miễn phí. Nhà đầu tư vòng này muốn thấy người trả tiền.',
          'Không chuẩn bị data room trước. Thẩm định chậm là lý do phổ biến khiến vòng gọi vốn kéo dài và mất động lực.',
          'Định giá dựa trên vòng trước cộng thêm một khoản. Định giá seed dựa trên cột mốc đã đạt, không phải trên thời gian đã trôi qua.',
        ],
      },
    ],
    faq: [
      {
        q: 'Cần bao nhiêu doanh thu mới gọi được seed?',
        a: 'Không có mốc cứng và khác nhau theo ngành. Điều quan trọng hơn con số tuyệt đối là tốc độ tăng và chất lượng giữ chân khách hàng.',
      },
      {
        q: 'Nhà đầu tư pre-seed có tham gia vòng seed không?',
        a: 'Nhiều người có, đặc biệt nếu họ có quyền mua thêm. Việc họ tham gia hay không là tín hiệu mạnh với nhà đầu tư mới.',
      },
      {
        q: 'Từ pre-seed tới seed thường cách bao lâu?',
        a: 'Thường mười hai tới mười tám tháng, đủ để đạt cột mốc mới. Đây cũng là lý do vòng pre-seed nên gọi đủ nuôi mười tám tháng.',
      },
    ],
  },

  'nha-dau-tu-thien-than': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Nhà đầu tư thiên thần là cá nhân dùng tiền của chính mình đầu tư vào startup giai đoạn rất sớm. Khác với quỹ, họ không phải báo cáo với ai và quyết định nhanh hơn nhiều.',
          'Quy mô mỗi khoản thường từ vài trăm triệu tới vài tỷ đồng.',
        ],
      },
      {
        h: 'Vì sao họ thường là nguồn vốn đầu tiên',
        p: [
          'Họ chấp nhận rủi ro cao hơn quỹ, vì đang chơi bằng tiền của mình và thường quyết định một phần bằng trực giác về con người.',
          'Quy trình đơn giản hơn: có thể chỉ vài buổi cà phê thay vì nhiều vòng thẩm định.',
          'Nhiều người trong số họ từng khởi nghiệp, nên giá trị họ mang lại không chỉ là tiền, kinh nghiệm và quan hệ thường đáng giá hơn.',
        ],
      },
      {
        h: 'Cách tiếp cận',
        p: [
          'Qua giới thiệu từ người họ đã tin, hiệu quả hơn hẳn thư lạnh. Người giới thiệu tốt nhất là founder khác trong danh mục của họ.',
          'Qua sự kiện và cộng đồng khởi nghiệp. Nhiều nhà đầu tư cá nhân ở Việt Nam không có website và không công bố khẩu vị, nên gặp trực tiếp là cách duy nhất.',
          'Qua mạng lưới thiên thần có tổ chức, nơi nhiều người cùng xem hồ sơ và có thể cùng tham gia một vòng.',
        ],
      },
      {
        h: 'Điều cần cẩn thận',
        p: [
          'Nhận quá nhiều khoản nhỏ từ nhiều người. Bảng cổ phần rối và mỗi quyết định sau này đều cần liên hệ nhiều bên. Cách phổ biến để tránh là gom qua một pháp nhân đại diện.',
          'Nhận tiền từ người kỳ vọng sai. Nhà đầu tư nghĩ mình đang cho vay và sẽ được trả lại sau một năm là nguồn gốc của rất nhiều mâu thuẫn.',
          'Bỏ qua giấy tờ vì quen biết. Càng thân càng nên ghi rõ, vì đó là thứ bảo vệ quan hệ khi có chuyện.',
        ],
      },
    ],
    faq: [
      {
        q: 'Tìm nhà đầu tư thiên thần ở Việt Nam ở đâu?',
        a: 'Phần lớn không công khai. Cách hiệu quả là qua vườn ươm, sự kiện khởi nghiệp, và giới thiệu từ founder khác. Đây là lý do tham gia cộng đồng có giá trị thực tế.',
      },
      {
        q: 'Họ thường lấy bao nhiêu phần trăm?',
        a: 'Tuỳ quy mô khoản đầu tư và định giá. Ở vòng rất sớm, một khoản vài trăm triệu có thể tương đương vài phần trăm công ty.',
      },
      {
        q: 'Có nên nhận tiền từ người thân không?',
        a: 'Được, nhưng phải làm giấy tờ đầy đủ và nói rõ rủi ro mất trắng. Quan hệ gia đình cộng với tiền không có văn bản là tình huống rất khó gỡ.',
      },
    ],
  },

  'quy-dau-tu-mao-hiem': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Quỹ đầu tư mạo hiểm là tổ chức huy động tiền từ nhà đầu tư khác rồi đầu tư vào startup. Họ không dùng tiền của mình, nên phải báo cáo và chịu trách nhiệm với người góp vốn.',
          'Điều đó giải thích phần lớn cách họ hành xử.',
        ],
      },
      {
        h: 'Mô hình kinh doanh của họ',
        p: [
          'Quỹ có vòng đời, thường mười năm. Họ cần thu hồi vốn trong khoảng đó, nên mọi khoản đầu tư phải có đường đi tới việc bán lại hoặc niêm yết.',
          'Phần lớn khoản đầu tư sẽ mất. Họ chấp nhận điều đó vì một vài khoản thành công lớn phải bù cho tất cả. Đây là lý do họ chỉ tìm doanh nghiệp có khả năng lớn rất nhanh.',
          'Một doanh nghiệp ổn định sinh lời đều đặn là doanh nghiệp tốt, nhưng không phù hợp với mô hình này. Biết điều đó sớm giúp bạn không mất thời gian.',
        ],
      },
      {
        h: 'Khác biệt so với nhà đầu tư cá nhân',
        p: [
          'Quy trình chặt chẽ hơn: nhiều vòng gặp, thẩm định kỹ, quyết định qua hội đồng đầu tư. Thời gian dài hơn đáng kể.',
          'Điều khoản phức tạp hơn, vì họ phải bảo vệ lợi ích người góp vốn cho quỹ.',
          'Đổi lại, họ mang theo mạng lưới, khả năng tham gia các vòng sau, và uy tín giúp bạn gọi vốn tiếp dễ hơn.',
        ],
      },
      {
        h: 'Cách chọn quỹ để tiếp cận',
        p: [
          'Đối chiếu khẩu vị của họ với hồ sơ của bạn: ngành, giai đoạn, địa bàn, quy mô séc. Lệch một trong bốn thứ này thì gần như chắc chắn bị từ chối.',
          'Xem danh mục đã đầu tư. Nó cho biết họ thực sự xuống tiền cho loại doanh nghiệp nào, thường chính xác hơn tuyên bố trên website.',
          'Kiểm tra họ có dẫn dắt vòng không. Nếu chỉ tham gia theo, bạn vẫn cần tìm người dẫn.',
        ],
      },
    ],
    faq: [
      {
        q: 'Việt Nam có bao nhiêu quỹ đang hoạt động?',
        a: 'Số quỹ thực sự đầu tư đều đặn ở giai đoạn sớm không nhiều, khoảng vài chục. Đây là thị trường nhỏ, nên tiếp cận có chọn lọc quan trọng hơn gửi hàng loạt.',
      },
      {
        q: 'Quỹ nước ngoài có đầu tư vào công ty Việt Nam không?',
        a: 'Có, nhưng thường yêu cầu cấu trúc pháp nhân phù hợp và quy mô lớn hơn. Ở vòng pre-seed, quỹ trong nước và khu vực là cửa thực tế hơn.',
      },
      {
        q: 'Bị một quỹ từ chối có ảnh hưởng tới quỹ khác không?',
        a: 'Thường không, vì mỗi quỹ có khẩu vị riêng. Nhưng nên hỏi lý do từ chối và điều chỉnh hồ sơ trước khi tiếp cận nơi tiếp theo.',
      },
    ],
  },

  'khau-vi-dau-tu': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Khẩu vị đầu tư (tiếng Anh: investment thesis) là bộ tiêu chí một quỹ dùng để quyết định xem xét hồ sơ nào. Thường gồm bốn thứ: ngành, giai đoạn, địa bàn, và quy mô séc.',
          'Hiểu đúng khẩu vị giúp bạn không mất hàng tuần gửi hồ sơ vào chỗ chắc chắn bị từ chối.',
        ],
      },
      {
        h: 'Bốn tiêu chí quyết định',
        p: [
          'Ngành. Nhiều quỹ chỉ đầu tư vào một số lĩnh vực nhất định vì đó là nơi họ có hiểu biết và mạng lưới.',
          'Giai đoạn. Quỹ Series A không xem hồ sơ pre-seed, dù ngành và mọi thứ khác đều khớp. Đây là tiêu chí loại trừ mạnh nhất.',
          'Địa bàn. Một số quỹ chỉ đầu tư vào doanh nghiệp đặt tại một khu vực cụ thể, đôi khi vì ràng buộc từ người góp vốn cho quỹ.',
          'Quy mô séc. Gọi 500 triệu từ quỹ có séc tối thiểu 20 tỷ là không khả thi, và ngược lại.',
        ],
      },
      {
        h: 'Tuyên bố và thực tế đôi khi khác nhau',
        p: [
          'Website nói "đầu tư giai đoạn sớm" nhưng danh mục toàn công ty đã có doanh thu vài chục tỷ. Danh mục đáng tin hơn tuyên bố.',
          'Ngược lại, có quỹ không công bố gì nhưng vẫn xem hồ sơ ngoài phạm vi nếu thấy hấp dẫn.',
          'Cách kiểm chứng tốt nhất: xem ba tới năm khoản đầu tư gần nhất của họ. Ngành gì, giai đoạn nào, quy mô bao nhiêu.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Gửi hồ sơ cho tất cả để tăng cơ hội. Thực tế nó giảm cơ hội, vì thư gửi hàng loạt dễ nhận ra và thường không được đọc.',
          'Chỉ đọc trang chủ. Thông tin hữu ích thường nằm ở mục danh mục đầu tư và mục hướng dẫn gửi hồ sơ.',
          'Bỏ qua điều kiện cứng. Quỹ chỉ đầu tư doanh nghiệp đã thành lập pháp nhân mà bạn chưa có thì mọi thứ khác không còn ý nghĩa.',
        ],
      },
    ],
    faq: [
      {
        q: 'Không khớp hoàn toàn thì có nên gửi không?',
        a: 'Lệch một tiêu chí mềm như mô hình kinh doanh thì vẫn đáng thử. Lệch điều kiện cứng như địa bàn hay giai đoạn thì gần như chắc chắn không có kết quả.',
      },
      {
        q: 'Làm sao biết quy mô séc của một quỹ?',
        a: 'Một số quỹ công bố trên website. Nếu không, suy từ các thương vụ đã công bố, hoặc hỏi thẳng trong buổi gặp đầu. Đây là câu hỏi hoàn toàn bình thường.',
      },
      {
        q: 'Khẩu vị có thay đổi không?',
        a: 'Có, thường khi quỹ huy động quỹ mới với định hướng khác. Vì vậy thông tin cũ hơn một năm nên được kiểm chứng lại.',
      },
    ],
  },

  'vuon-uom-khoi-nghiep': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Vườn ươm và chương trình tăng tốc là chương trình hỗ trợ startup giai đoạn sớm, thường kéo dài ba tới sáu tháng, kèm một khoản đầu tư nhỏ đổi lấy vài phần trăm cổ phần.',
          'Giá trị chính không nằm ở tiền mà ở cố vấn, mạng lưới và tính kỷ luật mà chương trình tạo ra.',
        ],
      },
      {
        h: 'Đổi lại được gì',
        p: [
          'Cố vấn có kinh nghiệm, thường là founder đã từng đi qua giai đoạn này.',
          'Mạng lưới nhà đầu tư. Nhiều chương trình kết thúc bằng buổi giới thiệu trước các quỹ, và đó thường là cách nhanh nhất để có những cuộc gặp đầu tiên.',
          'Kỷ luật. Chương trình có mốc thời gian và mục tiêu, điều mà nhóm tự làm rất khó duy trì.',
          'Uy tín ban đầu. Được chọn vào một chương trình có tiếng là tín hiệu tích cực với nhà đầu tư sau này.',
        ],
      },
      {
        h: 'Cái giá phải cân nhắc',
        p: [
          'Cổ phần bỏ ra thường vài phần trăm cho một khoản tiền không lớn. Tính theo định giá ngụ ý thì đây là mức khá đắt.',
          'Thời gian. Ba tới sáu tháng tập trung cho chương trình là ba tới sáu tháng không dành trọn cho sản phẩm và khách hàng.',
          'Không phải chương trình nào cũng có giá trị như nhau. Chương trình có mạng lưới thật khác hẳn chương trình chỉ có phòng làm việc và vài buổi chia sẻ.',
        ],
      },
      {
        h: 'Cách đánh giá một chương trình',
        p: [
          'Xem các doanh nghiệp đã tham gia. Bao nhiêu trong số đó gọi được vòng tiếp theo, và gọi được từ ai.',
          'Hỏi thẳng founder đã tham gia. Đây là nguồn thông tin đáng tin nhất và phần lớn họ sẵn sàng chia sẻ.',
          'Xem danh sách cố vấn có thật sự dành thời gian không, hay chỉ là tên trên website.',
        ],
      },
    ],
    faq: [
      {
        q: 'Vườn ươm và chương trình tăng tốc khác nhau thế nào?',
        a: 'Vườn ươm thường hỗ trợ giai đoạn sớm hơn và dài hơn, tập trung vào việc hình thành doanh nghiệp. Chương trình tăng tốc ngắn hơn, cường độ cao hơn, nhắm tới việc đẩy nhanh tới vòng gọi vốn. Ranh giới trên thực tế khá mờ.',
      },
      {
        q: 'Bỏ vài phần trăm có đáng không?',
        a: 'Tuỳ chương trình và tuỳ bạn đang thiếu gì. Nếu thiếu mạng lưới và kinh nghiệm thì rất đáng; nếu đã có sẵn cả hai thì cân nhắc kỹ hơn.',
      },
      {
        q: 'Tham gia rồi có gọi được vốn không?',
        a: 'Không đảm bảo. Chương trình mở cửa nhưng bạn vẫn phải tự thuyết phục nhà đầu tư. Tỷ lệ gọi được vốn sau chương trình là con số đáng hỏi trước khi tham gia.',
      },
    ],
  },

  'bootstrapping': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Bootstrapping là tự nuôi doanh nghiệp bằng doanh thu và vốn tự có, không gọi vốn bên ngoài. Bạn giữ toàn bộ quyền sở hữu và toàn bộ quyền quyết định.',
          'Đây là con đường phần lớn doanh nghiệp trên thế giới đi, không phải ngoại lệ.',
        ],
      },
      {
        h: 'Đánh đổi thực tế',
        p: [
          'Được: giữ toàn quyền, không có nghĩa vụ báo cáo, không bị áp lực tăng trưởng theo nhịp của người khác, và không phải dành ba tới sáu tháng cho việc gọi vốn.',
          'Mất: tăng trưởng chậm hơn, khó cạnh tranh khi đối thủ có vốn dồi dào, và không có mạng lưới mà nhà đầu tư mang lại.',
          'Với thị trường mà tốc độ quyết định thắng thua, bootstrapping là bất lợi lớn. Với thị trường mà quan hệ và chất lượng dịch vụ quyết định, nó có thể là lợi thế.',
        ],
      },
      {
        h: 'Khi nào đây là lựa chọn đúng',
        p: [
          'Khi mô hình có thể thu tiền sớm. Sản phẩm bán cho doanh nghiệp thường thu được tiền ngay từ khách hàng đầu tiên.',
          'Khi thị trường không đủ lớn cho vốn mạo hiểm nhưng đủ để nuôi một doanh nghiệp tốt.',
          'Khi bạn ưu tiên tự chủ hơn quy mô. Đây là lựa chọn về giá trị sống, không chỉ về kinh doanh.',
        ],
      },
      {
        h: 'Không phải quyết định một lần',
        p: [
          'Nhiều doanh nghiệp tự nuôi trong giai đoạn đầu rồi mới gọi vốn khi đã có doanh thu. Cách này cho định giá tốt hơn nhiều so với gọi vốn khi chưa có gì.',
          'Ngược lại cũng có doanh nghiệp gọi một vòng rồi dừng, tự nuôi từ đó.',
          'Điều đáng tránh là ở trạng thái lưng chừng: không đủ tập trung để tự nuôi, cũng không đủ chuẩn bị để gọi vốn.',
        ],
      },
    ],
    faq: [
      {
        q: 'Tự nuôi rồi gọi vốn sau có khó hơn không?',
        a: 'Thường dễ hơn, vì bạn đã có doanh thu và bằng chứng thị trường. Điều khó hơn là văn hoá: chuyển từ tư duy tiết kiệm sang tư duy đầu tư để tăng trưởng cần thời gian.',
      },
      {
        q: 'Có thể vừa tự nuôi vừa nhận một khoản nhỏ không?',
        a: 'Được, nhiều doanh nghiệp nhận một khoản từ nhà đầu tư thiên thần rồi vẫn vận hành theo tư duy tự nuôi. Điều quan trọng là kỳ vọng hai bên phải khớp nhau.',
      },
      {
        q: 'Nhà đầu tư có coi việc từng tự nuôi là điểm cộng không?',
        a: 'Thường là có. Đội ngũ đã tự tạo ra doanh thu chứng minh được khả năng bán hàng và kỷ luật chi tiêu, hai thứ khó đánh giá qua lời nói.',
      },
    ],
  },

  'dinh-gia-startup': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Định giá startup là việc ước lượng giá trị công ty để làm cơ sở tính tỷ lệ cổ phần bán ra. Nhưng ở vòng đầu, nó không phải một phép tính. Nó là kết quả đàm phán.',
          'Thứ thực sự đẩy định giá lên là có nhiều nhà đầu tư quan tâm cùng lúc, không phải công thức nào cả.',
        ],
      },
      {
        h: 'Vì sao công thức không giải quyết được',
        p: [
          'Các phương pháp định giá doanh nghiệp thông thường đều dựa vào dòng tiền hoặc lợi nhuận. Startup pre-seed thường không có cả hai.',
          'Bội số doanh thu cũng không dùng được khi doanh thu bằng không hoặc quá nhỏ, nhân một hệ số bất kỳ với số nhỏ vẫn ra số nhỏ.',
          'Nên trên thực tế, định giá vòng đầu hình thành từ ba thứ: mặt bằng thị trường cho cùng giai đoạn, mức độ hoàn thiện của hồ sơ, và mức độ cạnh tranh giữa các nhà đầu tư.',
        ],
      },
      {
        h: 'Cách tiếp cận thực tế',
        p: [
          'Bắt đầu từ mặt bằng. Tìm các vòng đã công bố trong cùng ngành và cùng giai đoạn ở Việt Nam. Đừng lấy số liệu Mỹ, mặt bằng khác nhau rất xa.',
          'Điều chỉnh theo hồ sơ. Đội ngũ mạnh hơn mặt bằng thì cao hơn; chưa có bằng chứng nhu cầu thì thấp hơn.',
          'Đưa ra một khoảng, không phải một con số. Nói "chúng tôi nghĩ ở khoảng 16 tới 27 tỷ" cho thấy bạn hiểu đây là đàm phán, còn đưa một con số chính xác tới hàng trăm triệu thì ngược lại.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Định giá theo số tiền cần gọi. "Tôi cần 5 tỷ và không muốn bán quá 20%, vậy định giá là 25 tỷ", logic ngược, và nhà đầu tư nhận ra ngay.',
          'Lấy định giá của một công ty nổi tiếng làm chuẩn. Họ ở giai đoạn khác, thị trường khác, và bạn không biết điều khoản đi kèm.',
          'Coi định giá cao là thắng lợi. Định giá quá cao ở vòng đầu khiến vòng sau rất khó. Đây là cái bẫy ngược mà nhiều người mới không thấy.',
        ],
      },
    ],
    faq: [
      {
        q: 'Ai đưa ra con số trước, tôi hay nhà đầu tư?',
        a: 'Thông lệ là nhà đầu tư dẫn dắt đưa ra, vì đó là một phần vai trò của họ. Nhưng bạn nên có khoảng của mình trong đầu để biết con số họ đưa ra có hợp lý không.',
      },
      {
        q: 'Định giá thấp có phải là dấu hiệu xấu?',
        a: 'Không nhất thiết. Định giá hợp lý kèm điều khoản sạch tốt hơn định giá cao kèm điều khoản nặng. Và nó tạo dư địa để vòng sau tăng lên.',
      },
      {
        q: 'Dùng SAFE thì có phải định giá không?',
        a: 'Không phải định giá ngay, chỉ cần thoả thuận mức cap. Đó chính là lý do SAFE phổ biến ở giai đoạn quá sớm để định giá có ý nghĩa.',
      },
    ],
  },

  'pre-money-post-money': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Định giá pre-money là giá trị công ty trước khi tiền đầu tư vào. Định giá post-money là con số đó cộng thêm số tiền gọi được.',
          'Chênh nhau đúng bằng số tiền đầu tư. Nghe đơn giản, nhưng nhầm lẫn giữa hai con số này là nguyên nhân của rất nhiều hiểu lầm trong đàm phán.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Định giá pre-money 24 tỷ, gọi 6 tỷ. Định giá post-money là 30 tỷ.',
          'Nhà đầu tư nhận 6 chia 30, tức 20% công ty. Tỷ lệ luôn tính trên con số post-money.',
          'Nếu ai đó nói "định giá 24 tỷ, tôi bỏ 6 tỷ lấy 25%" thì họ đang tính trên pre-money, sai. Trên pre-money, 6 chia 24 ra 25%, nhưng đó không phải cách tính đúng.',
        ],
      },
      {
        h: 'Vì sao phải hỏi rõ',
        p: [
          'Khi nhà đầu tư nói "chúng tôi định giá công ty 30 tỷ", câu đó có thể có hai nghĩa hoàn toàn khác nhau.',
          'Pre-money 30 tỷ, gọi 6 tỷ: bạn bán 16,7%.',
          'Post-money 30 tỷ, gọi 6 tỷ: bạn bán 20%.',
          'Chênh lệch hơn ba điểm phần trăm chỉ vì một chữ. Đây là câu hỏi bắt buộc phải hỏi rõ, và không ai thấy phiền khi bạn hỏi.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Không ghi rõ trong văn bản. Term sheet phải nói rõ con số là pre-money hay post-money.',
          'Quên rằng quỹ cổ phiếu thưởng ảnh hưởng tới phép tính. Nếu quỹ lấy từ phần pre-money, tỷ lệ thực tế của bạn thấp hơn con số đơn giản ở trên.',
          'Quên các khoản SAFE đang chờ. Chúng cũng chuyển thành cổ phần ở vòng này và làm thay đổi mọi tỷ lệ.',
        ],
      },
    ],
    faq: [
      {
        q: 'Thông lệ dùng con số nào khi nói chuyện?',
        a: 'Pre-money là con số hay được nhắc tới trong đàm phán, còn tỷ lệ sở hữu thì luôn tính trên post-money. Miễn là hai bên nói rõ mình đang dùng cái nào.',
      },
      {
        q: 'SAFE dùng cap pre-money hay post-money?',
        a: 'Bản chuẩn hiện nay dùng cap post-money, và ghi rõ trong tiêu đề văn bản. Bản cũ dùng pre-money. Hai loại tính pha loãng khác nhau.',
      },
      {
        q: 'Làm sao kiểm tra nhanh?',
        a: 'Lấy số tiền chia cho tỷ lệ nhà đầu tư nhận. Kết quả phải bằng định giá post-money. Nếu không khớp thì có gì đó chưa được nói ra.',
      },
    ],
  },

  'phuong-phap-scorecard': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Phương pháp chấm điểm là cách định giá lấy mặt bằng thị trường cho cùng giai đoạn làm gốc, rồi điều chỉnh lên xuống theo từng trục của hồ sơ.',
          'Nó phù hợp với vòng chưa có doanh thu, nơi mọi phương pháp dựa trên số liệu tài chính đều không dùng được.',
        ],
      },
      {
        h: 'Cách làm',
        p: [
          'Bước một: tìm mức định giá trung bình của các vòng cùng giai đoạn, cùng ngành, cùng thị trường. Đây là mức gốc.',
          'Bước hai: chấm hồ sơ của bạn trên vài trục so với mặt bằng đó, đội ngũ, bằng chứng nhu cầu, quy mô thị trường, vấn đề và sản phẩm.',
          'Bước ba: mỗi trục cho một hệ số, thường trong khoảng 0,6 tới 1,4. Ngang mặt bằng là 1,0.',
          'Bước bốn: nhân hệ số tổng hợp với mức gốc, rồi mở ra thành một khoảng.',
        ],
      },
      {
        h: 'Ví dụ bằng số',
        p: [
          'Mặt bằng cho pre-seed trong ngành của bạn là 20 tỷ.',
          'Đội ngũ mạnh hơn mặt bằng, hệ số 1,3. Bằng chứng nhu cầu yếu hơn, hệ số 0,8. Thị trường ngang bằng, 1,0. Sản phẩm tốt hơn, 1,2.',
          'Hệ số tổng hợp có trọng số ra khoảng 1,09. Mức giữa là 21,8 tỷ, khoảng tham chiếu khoảng 16 tới 27 tỷ.',
          'Con số này không phải để chốt. Nó để bạn biết mình đang ở đâu so với mặt bằng.',
        ],
      },
      {
        h: 'Giới hạn của phương pháp',
        p: [
          'Nó chỉ tốt bằng dữ liệu mặt bằng bạn có. Ở Việt Nam, dữ liệu định giá vòng sớm rất ít được công bố, nên mức gốc thường là ước lượng.',
          'Việc chấm điểm mang tính chủ quan. Ai cũng có xu hướng tự chấm cao hơn thực tế, nên nếu có thể, hãy nhờ người ngoài chấm giúp.',
          'Và cuối cùng, nó không thay được đàm phán. Có nhiều nhà đầu tư quan tâm cùng lúc vẫn là yếu tố mạnh hơn mọi hệ số.',
        ],
      },
    ],
    faq: [
      {
        q: 'Tìm mức gốc ở đâu?',
        a: 'Từ các vòng đã công bố trên báo chí khởi nghiệp và thông cáo của quỹ. Hỏi thẳng các founder khác trong ngành cũng là cách hiệu quả, và phần lớn sẵn sàng chia sẻ khoảng.',
      },
      {
        q: 'Có phương pháp nào khác cho vòng chưa doanh thu không?',
        a: 'Có vài phương pháp cộng điểm theo các yếu tố đã đạt được. Chúng đều cùng tinh thần: không tính từ dòng tiền mà từ mức độ giảm rủi ro.',
      },
      {
        q: 'Nhà đầu tư có dùng phương pháp này không?',
        a: 'Một số có, nhưng phần lớn định giá dựa trên kinh nghiệm và tỷ lệ họ muốn sở hữu. Giá trị của phương pháp với bạn là để không đưa ra con số vô lý.',
      },
    ],
  },

  'boi-so-doanh-thu': {
    lienQuan: ['chiet-khau-kho-chuyen-nhuong'],
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Bội số doanh thu là cách định giá lấy doanh thu năm nhân với một hệ số. Ví dụ doanh thu định kỳ hàng năm 10 tỷ, bội số 8 lần, định giá 80 tỷ.',
          'Phương pháp này phổ biến từ vòng seed trở đi, nhưng không dùng được ở pre-seed.',
        ],
      },
      {
        h: 'Vì sao không dùng được ở giai đoạn sớm',
        p: [
          'Doanh thu bằng không thì nhân bao nhiêu cũng ra không.',
          'Doanh thu quá nhỏ thì bội số trở nên vô nghĩa. Doanh thu 200 triệu một năm nhân 8 lần ra 1,6 tỷ. Con số không phản ánh gì về tiềm năng.',
          'Một số người xử lý bằng cách dùng doanh thu dự phóng năm sau. Nhưng đó là con số chưa xảy ra, và nhà đầu tư sẽ chiết khấu nó rất mạnh.',
        ],
      },
      {
        h: 'Bội số phụ thuộc vào cái gì',
        p: [
          'Tốc độ tăng trưởng, yếu tố quan trọng nhất. Doanh nghiệp tăng gấp ba mỗi năm có bội số cao hơn nhiều so với doanh nghiệp tăng ba mươi phần trăm.',
          'Tỷ lệ giữ chân khách hàng. Doanh thu ổn định đáng giá hơn doanh thu phải liên tục mua lại.',
          'Biên lợi nhuận gộp. Phần mềm có biên cao nên bội số cao; mô hình có biên thấp thì thấp hơn hẳn.',
          'Và bối cảnh thị trường vốn. Cùng một doanh nghiệp có thể được định giá rất khác nhau ở hai thời điểm.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Lấy bội số của công ty niêm yết ở Mỹ áp cho startup Việt Nam. Hai bối cảnh khác nhau hoàn toàn về thanh khoản, quy mô và rủi ro.',
          'Dùng doanh thu tổng thay vì doanh thu định kỳ. Doanh thu một lần từ dịch vụ triển khai không đáng bội số như doanh thu thuê bao.',
          'Trình bày định giá bằng bội số khi doanh thu còn quá nhỏ. Nó khiến người đọc nghĩ bạn đang cố làm cho con số trông lớn hơn.',
        ],
      },
    ],
    faq: [
      {
        q: 'Từ khi nào thì dùng được bội số?',
        a: 'Khi doanh thu định kỳ đủ lớn và ổn định để bội số có ý nghĩa, thường từ vòng seed trở đi. Trước đó, phương pháp chấm điểm phù hợp hơn.',
      },
      {
        q: 'Bội số bao nhiêu là hợp lý?',
        a: 'Thay đổi rất mạnh theo ngành, tốc độ tăng trưởng và thời điểm thị trường. Đây là con số nên tham chiếu từ các thương vụ gần nhất trong cùng ngành, không phải từ một mức chung.',
      },
      {
        q: 'Có nên dùng bội số lợi nhuận thay vì doanh thu không?',
        a: 'Với doanh nghiệp đã có lợi nhuận ổn định thì có, và đó là cách định giá doanh nghiệp truyền thống. Startup tăng trưởng thường chưa có lợi nhuận nên dùng doanh thu.',
      },
    ],
  },

  'dinh-gia-qua-cao': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Định giá quá cao là khi con số vượt xa mức tương xứng với cột mốc doanh nghiệp đã đạt. Nghe có vẻ là vấn đề dễ chịu, nhưng nó tạo ra rắc rối thật ở vòng sau.',
        ],
      },
      {
        h: 'Vì sao đây là vấn đề',
        p: [
          'Vòng sau cần định giá cao hơn vòng trước. Nếu vòng đầu đã ở mức cao mà mười tám tháng sau chưa đạt cột mốc tương xứng, bạn không có cách nào gọi vòng tiếp ở mức cao hơn.',
          'Lúc đó chỉ còn ba lựa chọn: gọi ở mức thấp hơn, cố kéo dài để đạt cột mốc, hoặc không gọi được nữa.',
          'Gọi ở mức thấp hơn là tình huống nhà đầu tư hiện hữu rất ngại, vì nó kích hoạt các điều khoản chống pha loãng và làm giảm giá trị khoản đầu tư của họ trên sổ sách.',
        ],
      },
      {
        h: 'Cái giá ít ai tính tới',
        p: [
          'Định giá cao đi kèm kỳ vọng cao. Nhà đầu tư trả giá cao vì tin vào một tốc độ tăng trưởng nhất định, và họ sẽ theo dõi sát.',
          'Nó cũng làm hẹp cửa bán công ty. Một thương vụ mua lại ở mức vừa phải có thể không đủ để trả phần ưu tiên cho nhà đầu tư, khiến người sáng lập không nhận được gì.',
          'Và nó thu hẹp danh sách nhà đầu tư vòng sau. Nhiều quỹ có ngưỡng định giá tối đa cho từng giai đoạn.',
        ],
      },
      {
        h: 'Cân bằng thế nào',
        p: [
          'Mục tiêu không phải định giá cao nhất có thể, mà là định giá đủ để không pha loãng quá mức, đồng thời còn dư địa cho vòng sau.',
          'Một cách kiểm tra: với định giá này, mười tám tháng nữa bạn cần đạt gì để gọi vòng tiếp ở mức cao hơn hai lần. Nếu câu trả lời nghe không khả thi, con số đang quá cao.',
          'Định giá hợp lý kèm điều khoản sạch gần như luôn tốt hơn định giá cao kèm điều khoản nặng.',
        ],
      },
    ],
    faq: [
      {
        q: 'Nhà đầu tư tự đề nghị mức cao thì có nên nhận không?',
        a: 'Nên cân nhắc chứ không tự động nhận. Hỏi họ kỳ vọng cột mốc gì ở vòng sau, và tự đánh giá xem có khả thi không.',
      },
      {
        q: 'Vòng giảm giá có tệ tới mức nào?',
        a: 'Nó gây khó về mặt tín hiệu và kích hoạt các điều khoản bảo vệ nhà đầu tư cũ, nhưng không phải dấu chấm hết. Nhiều doanh nghiệp đi qua vòng giảm giá rồi vẫn phát triển tốt.',
      },
      {
        q: 'Làm sao biết định giá của mình có hợp lý không?',
        a: 'So với mặt bằng của các vòng cùng giai đoạn trong cùng ngành, và kiểm tra tỷ lệ pha loãng có nằm trong khoảng thông lệ 10–25% không.',
      },
    ],
  },

  'so-tien-goi-von': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Số tiền nên gọi là số đủ nuôi doanh nghiệp tới cột mốc tiếp theo, cộng thêm thời gian để chạy vòng gọi vốn sau đó. Thông lệ là mười tám tháng.',
          'Không phải số tiền nhiều nhất có thể gọi được, cũng không phải số tối thiểu để sống sót.',
        ],
      },
      {
        h: 'Cách tính, và sai lầm phổ biến nhất',
        p: [
          'Cách nhiều người làm: lấy mức đốt tiền hiện tại nhân mười tám. Cách này luôn cho ra con số thiếu.',
          'Lý do: tiền gọi về chính là để tăng chi. Bạn tuyển người, đẩy bán hàng, nên mức đốt sau khi nhận vốn cao hơn hẳn mức hiện tại.',
          'Cách đúng: mô phỏng từng tháng với đà tăng chi phí, rồi cộng dồn. Với đà tăng bốn phần trăm mỗi tháng, con số thật có thể cao hơn phép nhân đơn giản tới bốn mươi phần trăm.',
          'Rồi trừ tiền mặt đang có, cộng dự phòng mười lăm tới hai mươi phần trăm, và làm tròn lên.',
        ],
      },
      {
        h: 'Kiểm tra lại bằng tỷ lệ pha loãng',
        p: [
          'Sau khi có con số, kiểm tra nó tương đương bao nhiêu phần trăm công ty ở mức định giá dự kiến.',
          'Trên hai mươi lăm phần trăm là quá nhiều cho vòng đầu, các vòng sau sẽ chật chội.',
          'Dưới mười phần trăm thì nhiều quỹ không tham gia, vì tỷ lệ quá nhỏ để có ý nghĩa với danh mục của họ.',
          'Nếu con số cần gọi rơi ra ngoài khoảng này, hãy xem lại kế hoạch chi tiêu hoặc kỳ vọng định giá.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Gọi quá ít để giữ tỷ lệ. Không đủ tiền đạt cột mốc thì vòng sau phải gọi ở mức không cao hơn bao nhiêu, và tổng pha loãng cuối cùng còn nhiều hơn.',
          'Gọi quá nhiều vì đang thuận lợi. Tiền dư tạo ra thói quen chi tiêu lỏng lẻo, và pha loãng đã xảy ra thì không lấy lại được.',
          'Không có dự phòng. Kế hoạch nào cũng trượt, và nhà đầu tư coi khoản dự phòng là dấu hiệu bạn hiểu rủi ro.',
        ],
      },
    ],
    faq: [
      {
        q: 'Vì sao lại là mười tám tháng?',
        a: 'Khoảng mười hai tháng để đạt cột mốc mới, cộng ba tới sáu tháng để chạy vòng gọi vốn tiếp theo. Dưới mười hai tháng thì bạn quay lại gọi vốn gần như ngay sau khi đóng vòng này.',
      },
      {
        q: 'Có nên nói một khoảng thay vì một con số?',
        a: 'Không nên. Khoảng rộng cho thấy bạn chưa tính kỹ. Đưa một con số cụ thể kèm giải thích nó nuôi được bao nhiêu tháng và tới cột mốc nào.',
      },
      {
        q: 'Nếu gọi được nhiều hơn dự định thì sao?',
        a: 'Cân nhắc kỹ. Nhận thêm nghĩa là pha loãng thêm, và chỉ đáng nếu số tiền đó mua được cột mốc lớn hơn chứ không chỉ kéo dài thời gian.',
      },
    ],
  },

  'su-dung-von': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Kế hoạch sử dụng vốn là bảng phân bổ số tiền gọi được theo từng hạng mục, kèm kết quả mỗi hạng mục dự kiến tạo ra.',
          'Đây là slide bị bỏ qua nhiều nhất trong pitch deck, và cũng là thứ nhà đầu tư cần để quyết định có nói tiếp hay không.',
        ],
      },
      {
        h: 'Cách chia thường gặp',
        p: [
          'Phát triển sản phẩm: lương đội kỹ thuật, hạ tầng, công cụ.',
          'Tuyển người: các vị trí then chốt còn thiếu, kèm thời điểm dự kiến tuyển.',
          'Bán hàng và marketing: chi phí có được khách hàng, xây kênh.',
          'Vận hành: văn phòng, pháp lý, kế toán.',
          'Dự phòng: mười lăm tới hai mươi phần trăm.',
          'Tỷ trọng thay đổi theo mô hình. Sản phẩm bán cho doanh nghiệp thường nặng phần bán hàng; sản phẩm kỹ thuật sâu nặng phần phát triển.',
        ],
      },
      {
        h: 'Điều nhà đầu tư thực sự đọc',
        p: [
          'Không phải tỷ lệ phần trăm, mà là mỗi khoản mua được cột mốc gì.',
          '"Bốn mươi phần trăm cho sản phẩm" không nói lên điều gì. "Bốn mươi phần trăm để tuyển hai kỹ sư và ra mắt tính năng tích hợp kế toán vào quý hai, thứ mà mười hai khách hàng hiện tại đều đã hỏi" thì khác hẳn.',
          'Gắn mỗi hạng mục với một kết quả đo được là cách biến bảng phân bổ thành lập luận.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Tổng không bằng một trăm phần trăm. Nhà đầu tư sẽ cộng thử, và một bảng không tròn là dấu hiệu chuẩn bị vội.',
          'Không có dự phòng. Bảng chia hết một trăm phần trăm cho các hạng mục cụ thể cho thấy chưa tính tới việc kế hoạch có thể trượt.',
          'Chia quá chi tiết. Mười hai hạng mục mỗi cái vài phần trăm khiến người đọc không thấy được ưu tiên. Bốn tới sáu hạng mục là vừa.',
        ],
      },
    ],
    faq: [
      {
        q: 'Có bị ràng buộc phải chi đúng như kế hoạch không?',
        a: 'Thường không ràng buộc pháp lý ở vòng sớm, nhưng chi lệch hẳn so với cam kết sẽ ảnh hưởng tới niềm tin. Nếu cần đổi hướng, hãy nói trước với nhà đầu tư.',
      },
      {
        q: 'Lương người sáng lập có nên đưa vào không?',
        a: 'Có, và nên nói rõ mức. Nhà đầu tư biết người sáng lập cần sống được để tập trung. Giấu khoản này khiến bảng trông thiếu thực tế.',
      },
      {
        q: 'Dự phòng bao nhiêu là hợp lý?',
        a: 'Mười lăm tới hai mươi phần trăm. Dưới mười phần trăm là không có biên an toàn; trên ba mươi phần trăm khiến người đọc nghĩ bạn chưa có kế hoạch cụ thể.',
      },
    ],
  },

  'cot-moc-goi-von': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Cột mốc giữa hai vòng là kết quả cụ thể bạn cần đạt để vòng gọi vốn sau có cơ sở định giá cao hơn.',
          'Toàn bộ kế hoạch sử dụng vốn nên hướng về cột mốc này, và số tiền gọi nên đủ để tới đó cộng thêm thời gian chạy vòng tiếp.',
        ],
      },
      {
        h: 'Cột mốc tốt trông thế nào',
        p: [
          'Đo được. "Cải thiện sản phẩm" không phải cột mốc; "ba mươi khách hàng trả tiền với tỷ lệ giữ chân trên chín mươi phần trăm sau sáu tháng" thì có.',
          'Giảm được một rủi ro cụ thể. Vòng đầu thường chứng minh có người cần; vòng sau chứng minh có cách tiếp cận họ với chi phí hợp lý.',
          'Nằm trong tầm với. Cột mốc quá tham vọng khiến bạn không đạt được và mất uy tín; quá dễ thì không đủ để nâng định giá.',
        ],
      },
      {
        h: 'Cột mốc theo từng vòng',
        p: [
          'Từ pre-seed lên seed: chứng minh có người trả tiền và họ ở lại. Thường là những khách hàng đầu tiên với tỷ lệ giữ chân tốt.',
          'Từ seed lên Series A: chứng minh có kênh tăng trưởng lặp lại được, và kinh tế đơn vị hợp lý. Không còn là "có người mua" mà là "biết cách có thêm người mua".',
          'Cột mốc cụ thể khác nhau rất nhiều theo ngành, nên cách tốt nhất là hỏi thẳng nhà đầu tư vòng sau họ cần thấy gì.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Không xác định cột mốc từ đầu. Tiêu hết tiền mà không có gì mới để kể là tình huống khiến vòng sau gần như không thể gọi.',
          'Đặt cột mốc theo thời gian thay vì theo kết quả. "Sau mười tám tháng chúng tôi sẽ gọi vòng seed" không phải cột mốc.',
          'Chọn chỉ số dễ tăng nhưng không nói lên điều gì. Số lượt tải hay số người đăng ký miễn phí ít có sức thuyết phục hơn nhiều so với số khách trả tiền ở lại.',
        ],
      },
    ],
    faq: [
      {
        q: 'Nên hỏi nhà đầu tư về cột mốc lúc nào?',
        a: 'Ngay khi đang gọi vòng hiện tại. Câu hỏi "sau vòng này, các anh cần thấy gì để tham gia vòng sau" rất hữu ích và cho thấy bạn nghĩ dài hạn.',
      },
      {
        q: 'Không đạt cột mốc thì sao?',
        a: 'Cần trung thực và giải thích đã học được gì. Nhà đầu tư đã quen với việc kế hoạch trượt; điều họ ngại là bạn không nhận ra hoặc không điều chỉnh.',
      },
      {
        q: 'Có nên đặt nhiều cột mốc cùng lúc không?',
        a: 'Một cột mốc chính và vài chỉ số hỗ trợ là đủ. Đặt năm mục tiêu ngang nhau thường dẫn tới không đạt cái nào trọn vẹn.',
      },
    ],
  },

  'data-room': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Data room là kho tài liệu công ty chuẩn bị sẵn cho nhà đầu tư xem trong quá trình thẩm định. Ở giai đoạn sớm, nó thường chỉ là một thư mục chia sẻ được tổ chức gọn gàng.',
          'Chuẩn bị trước giúp rút ngắn thẩm định từ vài tuần xuống vài ngày.',
        ],
      },
      {
        h: 'Nên có những gì',
        p: [
          'Pháp lý: giấy chứng nhận đăng ký doanh nghiệp, điều lệ, sổ đăng ký cổ đông, các thoả thuận vesting và chuyển giao sở hữu trí tuệ.',
          'Tài chính: báo cáo tài chính hoặc sổ sách, sao kê tài khoản công ty, mô hình tài chính, bảng cổ phần.',
          'Kinh doanh: hợp đồng khách hàng lớn, số liệu doanh thu và khách hàng theo tháng, các thư cam kết mua.',
          'Đội ngũ: hợp đồng lao động, danh sách nhân sự, cơ cấu tổ chức.',
          'Các khoản đầu tư trước: mọi hợp đồng SAFE hoặc trái phiếu chuyển đổi đang chờ.',
        ],
      },
      {
        h: 'Vì sao chuẩn bị sớm lại quan trọng',
        p: [
          'Thẩm định chậm là lý do phổ biến khiến vòng gọi vốn kéo dài và mất động lực. Nhà đầu tư nhiệt tình ở tuần thứ nhất có thể nguội đi ở tuần thứ tám.',
          'Việc dựng data room cũng buộc bạn phát hiện những thứ còn thiếu, hợp đồng chưa ký, sổ chưa cập nhật, vào lúc còn kịp xử lý.',
          'Với hồ sơ pháp lý gọn, thẩm định vòng pre-seed có thể xong trong một tuần.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Bắt đầu dựng khi nhà đầu tư đã hỏi. Lúc đó mỗi ngày chậm là một ngày động lực giảm.',
          'Đưa quá nhiều tài liệu không liên quan. Data room lộn xộn khiến người xem mất thời gian và tạo ấn tượng thiếu tổ chức.',
          'Giấu vấn đề. Nếu có điều gì chưa ổn, cổ phần chết, hợp đồng thiếu, sổ sách chưa chuẩn, nói trước bao giờ cũng tốt hơn để họ tự phát hiện.',
        ],
      },
    ],
    faq: [
      {
        q: 'Có cần dùng phần mềm chuyên dụng không?',
        a: 'Ở vòng sớm thì không. Một thư mục chia sẻ có phân quyền và cấu trúc rõ ràng là đủ. Phần mềm chuyên dụng có ích khi cần theo dõi ai xem gì, thường từ vòng seed trở đi.',
      },
      {
        q: 'Nên cho xem ở giai đoạn nào?',
        a: 'Sau khi đã có vài cuộc trao đổi và nhà đầu tư thể hiện quan tâm thật. Không cần gửi ngay từ email đầu tiên.',
      },
      {
        q: 'Tài liệu nhạy cảm thì sao?',
        a: 'Có thể chia thành nhiều lớp, mở dần theo mức độ nghiêm túc của cuộc trao đổi. Danh sách khách hàng chi tiết thường ở lớp sau cùng.',
      },
    ],
  },

  'due-diligence': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Thẩm định là quá trình nhà đầu tư kiểm tra pháp lý, tài chính và vận hành của doanh nghiệp trước khi xuống tiền. Nó diễn ra sau khi hai bên đã thống nhất điều khoản trên term sheet.',
          'Với vòng pre-seed, quá trình này thường mất hai tới bốn tuần nếu hồ sơ gọn.',
        ],
      },
      {
        h: 'Họ kiểm tra những gì',
        p: [
          'Pháp lý: công ty tồn tại hợp lệ, ai sở hữu bao nhiêu, sở hữu trí tuệ thuộc về công ty, không có tranh chấp đang treo.',
          'Tài chính: sổ sách khớp với những gì bạn đã nói, doanh thu là thật, chi phí được ghi nhận đầy đủ.',
          'Kinh doanh: gọi điện cho vài khách hàng để xác nhận họ thực sự dùng và thực sự trả tiền.',
          'Đội ngũ: đôi khi hỏi người từng làm việc với bạn, hoặc nhà đầu tư trước đó.',
        ],
      },
      {
        h: 'Điều khiến thẩm định đổ vỡ',
        p: [
          'Phát hiện thứ bạn chưa nói. Không phải bản thân vấn đề, mà là việc nó bị giấu. Điều đó đặt câu hỏi về mọi thứ khác bạn đã nói.',
          'Số liệu không khớp. Doanh thu trong deck khác doanh thu trong sổ, dù chỉ vì cách ghi nhận khác nhau, cũng cần giải thích ngay và rõ.',
          'Cổ phần chết hoặc sở hữu trí tuệ chưa chuyển giao. Hai thứ này rất khó sửa nhanh và có thể khiến thương vụ dừng lại.',
        ],
      },
      {
        h: 'Cách chuẩn bị',
        p: [
          'Dựng data room trước khi cần. Chuẩn bị sớm rút ngắn thời gian đáng kể.',
          'Rà lại chính mình trước. Nếu bạn là nhà đầu tư, bạn sẽ hỏi gì. Chuẩn bị câu trả lời cho những chỗ yếu.',
          'Nói trước các vấn đề đã biết. Chủ động nêu ra tạo niềm tin; bị phát hiện thì ngược lại.',
        ],
      },
    ],
    faq: [
      {
        q: 'Thẩm định mất bao lâu?',
        a: 'Hai tới bốn tuần cho vòng pre-seed nếu hồ sơ gọn, lâu hơn nếu thiếu tài liệu. Từ vòng seed trở đi thường kỹ hơn và mất nhiều thời gian hơn.',
      },
      {
        q: 'Có phải trả chi phí thẩm định không?',
        a: 'Tuỳ term sheet. Một số thương vụ quy định công ty chịu chi phí pháp lý của nhà đầu tư trong một hạn mức. Đây là điều khoản nên đàm phán mức trần.',
      },
      {
        q: 'Phát hiện vấn đề thì có mất thương vụ không?',
        a: 'Không nhất thiết. Phần lớn vấn đề sửa được, và nhà đầu tư quen với việc doanh nghiệp giai đoạn sớm chưa hoàn hảo. Cái khó cứu là việc thiếu trung thực.',
      },
    ],
  },

  'warm-intro': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Giới thiệu qua người quen là việc tiếp cận nhà đầu tư thông qua một người mà họ đã tin. Cách này hiệu quả hơn hẳn thư gửi lạnh.',
          'Lý do đơn giản: nhà đầu tư nhận rất nhiều hồ sơ, và lời giới thiệu từ người họ tin là bộ lọc đầu tiên.',
        ],
      },
      {
        h: 'Ai giới thiệu thì hiệu quả nhất',
        p: [
          'Founder trong danh mục đầu tư của chính quỹ đó. Đây là nguồn giới thiệu mạnh nhất, vì quỹ đã đặt tiền vào phán đoán của người này.',
          'Nhà đầu tư khác đã tham gia vòng của bạn. Lời giới thiệu kèm việc họ đã bỏ tiền là tín hiệu rất mạnh.',
          'Cố vấn hoặc người trong ngành có uy tín với quỹ đó.',
          'Người quen chung nhưng không biết gì về công việc của bạn thì gần như không có tác dụng, đôi khi còn phản tác dụng.',
        ],
      },
      {
        h: 'Cách xin giới thiệu đúng',
        p: [
          'Hỏi trước xem họ có sẵn lòng không, thay vì cung cấp thẳng thông tin để họ chuyển tiếp. Câu hỏi nên là "anh thấy hồ sơ này có phù hợp để giới thiệu tới X không", chứ không phải "anh giới thiệu giúp em".',
          'Gửi kèm một đoạn ngắn họ có thể chuyển tiếp nguyên văn: bạn làm gì, tại sao phù hợp với quỹ đó, và bạn đang gọi bao nhiêu. Việc này tiết kiệm thời gian cho họ và tăng khả năng được giúp.',
          'Chấp nhận nếu họ từ chối. Người giới thiệu đang đặt uy tín của mình vào, nên việc họ cân nhắc là hợp lý.',
        ],
      },
      {
        h: 'Nếu không có mạng lưới thì sao',
        p: [
          'Xây dần từ trước khi cần. Tham gia cộng đồng khởi nghiệp, sự kiện, chương trình tăng tốc, những chỗ founder khác và nhà đầu tư có mặt.',
          'Thư gửi lạnh vẫn có tác dụng nếu viết tốt: ngắn, cụ thể, và cho thấy bạn đã tìm hiểu về quỹ đó. Tỷ lệ trả lời thấp hơn nhưng không phải bằng không.',
          'Một số quỹ có kênh nộp hồ sơ công khai và thực sự đọc. Đó là lý do nên kiểm tra trang chính thức của họ.',
        ],
      },
    ],
    faq: [
      {
        q: 'Thư gửi lạnh có bao giờ hiệu quả không?',
        a: 'Có, nhưng cần rất cụ thể: vì sao là quỹ này, hồ sơ khớp khẩu vị của họ ở đâu, và một dòng về bằng chứng đã có. Thư chung chung gửi hàng loạt thì gần như không.',
      },
      {
        q: 'Có nên nhờ nhiều người cùng giới thiệu tới một quỹ không?',
        a: 'Không nên. Nhiều lời giới thiệu cùng lúc cho cùng một nơi trông thiếu tổ chức. Chọn người có quan hệ mạnh nhất.',
      },
      {
        q: 'Người giới thiệu có được gì không?',
        a: 'Thông thường không, và không nên đề nghị trả phí giới thiệu. Ở nhiều nơi việc này còn chạm vùng nhạy cảm pháp lý về môi giới đầu tư.',
      },
    ],
  },

  'thu-cam-ket-mua': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Thư cam kết mua là văn bản trong đó khách hàng tiềm năng xác nhận ý định mua sản phẩm của bạn, thường kèm điều kiện và quy mô dự kiến.',
          'Nó không ràng buộc pháp lý, nhưng là bằng chứng nhu cầu mạnh nhất mà một doanh nghiệp chưa có doanh thu có thể đưa ra.',
        ],
      },
      {
        h: 'Vì sao nhà đầu tư coi trọng',
        p: [
          'Ở vòng pre-seed, câu hỏi lớn nhất là có ai thực sự cần thứ này không. Khảo sát và phỏng vấn cho câu trả lời yếu, vì nói thích thì dễ.',
          'Một người sẵn sàng đặt tên và chữ ký vào một văn bản là mức cam kết cao hơn hẳn.',
          'Nó cũng cho thấy bạn có khả năng tiếp cận và thuyết phục khách hàng, kỹ năng khó đánh giá qua lời nói.',
        ],
      },
      {
        h: 'Thư tốt trông thế nào',
        p: [
          'Ghi rõ sản phẩm hoặc dịch vụ cụ thể, không phải mô tả chung chung.',
          'Có quy mô dự kiến: bao nhiêu người dùng, bao nhiêu tiền, trong bao lâu.',
          'Có điều kiện rõ ràng: sẽ mua khi sản phẩm đáp ứng những yêu cầu nào, vào thời điểm nào.',
          'Ký bởi người thực sự có thẩm quyền quyết định mua, không phải người liên hệ cấp thấp.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Xin thư quá chung chung, kiểu "chúng tôi quan tâm tới giải pháp này". Loại thư đó gần như không có giá trị.',
          'Đếm số lượng thay vì chất lượng. Ba thư cụ thể từ khách hàng thật đáng giá hơn hai mươi thư chung chung.',
          'Không chuyển đổi thư thành hợp đồng. Thư cam kết là bước đệm, không phải đích. Nhà đầu tư sẽ hỏi bao nhiêu thư đã thành đơn hàng thật.',
        ],
      },
    ],
    faq: [
      {
        q: 'Xin thư cam kết như thế nào?',
        a: 'Sau vài buổi trao đổi khi khách hàng đã thể hiện quan tâm, đề nghị thẳng: "Anh có thể viết cho em vài dòng xác nhận ý định này không, để em đưa vào hồ sơ gọi vốn". Phần lớn người sẵn sàng nếu quan tâm là thật.',
      },
      {
        q: 'Triển khai thử có thu phí có tốt hơn không?',
        a: 'Tốt hơn nhiều. Có người bấm nút trả tiền là ranh giới giữa "họ nói thích" và "họ thực sự cần". Thư cam kết là mức dưới của thang bằng chứng.',
      },
      {
        q: 'Có được nêu tên khách hàng trong deck không?',
        a: 'Chỉ khi đã xin phép. Nêu tên mà chưa hỏi có thể làm hỏng quan hệ, và nhà đầu tư đôi khi gọi kiểm chứng.',
      },
    ],
  },

  'trien-khai-thu': {
    capNhat: '2026-10-29',
    lienQuan: ['thu-cam-ket-mua', 'traction-la-gi', 'product-market-fit', 'mvp-la-gi'],
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Triển khai thử (pilot) là cho khách hàng dùng sản phẩm trong phạm vi và thời gian có kiểm soát, để cả hai bên đánh giá trước khi ký hợp đồng chính thức.',
          'Trong giới khởi nghiệp, người ta hay nói "chạy pilot" hoặc "pilot với khách hàng doanh nghiệp". Pilot có thu phí đáng giá hơn nhiều so với pilot miễn phí, dù số tiền nhỏ.',
        ],
      },
      {
        h: 'Vì sao thu phí lại quan trọng tới vậy',
        p: [
          'Miễn phí thì ai cũng đồng ý thử, và việc đồng ý không nói lên điều gì về nhu cầu thật.',
          'Khi phải chi tiền, dù chỉ vài triệu, người quyết định phải giải trình với ai đó. Điều này lọc ra những trường hợp chỉ tò mò.',
          'Bản có thu phí cũng tạo cam kết từ phía khách hàng: họ sẽ dành thời gian dùng thật, cho phản hồi thật, thay vì để đó rồi quên.',
          'Một pilot có thu phí kết thúc đạt tiêu chí, hoặc một [[thu-cam-ket-mua|thư cam kết mua (LOI)]] ký sau pilot, là dạng [[traction-la-gi|traction]] có sức nặng khi gọi vốn vòng đầu.',
        ],
      },
      {
        h: 'Thiết kế một triển khai thử tốt',
        p: [
          'Đặt tiêu chí thành công từ đầu, cùng thoả thuận với khách hàng. Kết thúc mà không có tiêu chí thì không ai biết nó thành công hay không.',
          'Giới hạn thời gian. Bản kéo dài vô thời hạn là bản không bao giờ chuyển thành hợp đồng.',
          'Xác định rõ ai là người quyết định mua sau đó. Triển khai thử thành công với một phòng ban nhưng người ký hợp đồng chưa từng nghe tới là tình huống rất hay gặp.',
          'Với tập đoàn, một cửa vào pilot là các chương trình đổi mới mở. Bài [[/playbook/thu-thach-doi-moi-mo-voi-tap-doan|Thử thách đổi mới mở với tập đoàn]] hướng dẫn cách nộp hồ sơ.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Cho thử quá nhiều nơi cùng lúc. Mỗi bản triển khai thử tốn công hỗ trợ, và làm hời hợt nhiều nơi kém hơn làm kỹ vài nơi.',
          'Tuỳ chỉnh quá nhiều cho một khách. Bạn kết thúc với một sản phẩm chỉ dùng được cho họ, thay vì một sản phẩm bán được cho nhiều người.',
          'Không có kế hoạch kết thúc. Cần biết trước sẽ làm gì khi bản thử kết thúc, chuyển sang hợp đồng, gia hạn, hay dừng.',
        ],
      },
    ],
    faq: [
      {
        q: 'Nên thu phí bao nhiêu?',
        a: 'Đủ để có ý nghĩa với người quyết định, thường là một phần của giá chính thức. Con số không quan trọng bằng việc có thu.',
      },
      {
        q: 'Khách hàng không chịu trả phí thử thì sao?',
        a: 'Đó cũng là thông tin. Có thể vấn đề chưa đủ đau, hoặc bạn chưa nói chuyện với đúng người có ngân sách.',
      },
      {
        q: 'Bao lâu là hợp lý?',
        a: 'Đủ để thấy kết quả nhưng đừng dài quá. Với phần mềm bán cho doanh nghiệp, một tới ba tháng là khoảng hay gặp.',
      },
    ],
  },

  'investor-update': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Thư cập nhật nhà đầu tư là bản tin định kỳ gửi cho những người đã đầu tư, thường hàng tháng hoặc hàng quý, báo cáo tình hình công ty.',
          'Nhiều người sáng lập bỏ qua việc này, và đó là sai lầm tốn kém khi tới vòng gọi vốn tiếp theo.',
        ],
      },
      {
        h: 'Vì sao đáng làm dù không ai yêu cầu',
        p: [
          'Nhà đầu tư hiện hữu là nguồn vốn dễ nhất cho vòng sau, và họ chỉ tham gia nếu vẫn theo dõi được câu chuyện.',
          'Họ cũng là nguồn giới thiệu tốt nhất tới nhà đầu tư mới, nhưng chỉ khi họ biết bạn đang làm gì để giới thiệu đúng.',
          'Và họ có thể giúp. Nhiều thư cập nhật kết thúc bằng một đề nghị cụ thể, và người nhận thường sẵn sàng hỗ trợ nếu được hỏi rõ.',
        ],
      },
      {
        h: 'Nội dung một thư tốt',
        p: [
          'Ba tới bốn chỉ số chính, giữ cố định qua các kỳ để người đọc thấy xu hướng: doanh thu, số khách hàng, tiền mặt còn lại, số tháng runway.',
          'Điều đã làm được trong kỳ, ngắn gọn.',
          'Điều đang khó khăn. Đây là phần khiến thư đáng đọc, và cũng là phần người sáng lập hay né tránh nhất.',
          'Một đề nghị cụ thể: cần giới thiệu tới ai, cần tuyển vị trí gì, cần lời khuyên về việc gì.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Chỉ gửi tin tốt. Nhà đầu tư không tin một câu chuyện toàn thuận lợi, và khi vấn đề lộ ra thì họ bất ngờ. Điều tệ hơn nhiều so với biết sớm.',
          'Ngừng gửi khi mọi thứ xấu đi. Đây chính là lúc quan trọng nhất phải gửi. Im lặng khiến người ta tưởng tượng ra điều tệ hơn thực tế.',
          'Đổi chỉ số theo từng kỳ để chọn con số đẹp. Người đọc nhận ra ngay và mất niềm tin.',
        ],
      },
    ],
    faq: [
      {
        q: 'Nên gửi hàng tháng hay hàng quý?',
        a: 'Hàng tháng ở giai đoạn sớm là hợp lý, vì mọi thứ thay đổi nhanh. Quan trọng là đều đặn, thư ngắn gửi đúng hẹn tốt hơn thư dài gửi thất thường.',
      },
      {
        q: 'Có nên gửi cho nhà đầu tư tiềm năng chưa đầu tư không?',
        a: 'Đây là chiến thuật rất hiệu quả. Người từ chối ở vòng này có thể tham gia vòng sau nếu họ thấy bạn thực hiện đúng những gì đã nói.',
      },
      {
        q: 'Nên dài bao nhiêu?',
        a: 'Đọc xong trong hai phút. Chỉ số ở trên, phần chữ ngắn gọn, đề nghị ở cuối. Chi tiết để dành cho ai hỏi thêm.',
      },
    ],
  },

  'bi-tu-choi-goi-von': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Bị từ chối là phần bình thường của việc gọi vốn. Tỷ lệ đồng ý trên số hồ sơ một quỹ nhận được thường rất thấp, nên phần lớn câu trả lời sẽ là không.',
          'Điều quan trọng không phải tránh bị từ chối, mà là học được gì từ mỗi lần.',
        ],
      },
      {
        h: 'Đọc lý do từ chối',
        p: [
          'Lý do thật thường không được nói thẳng. "Hơi sớm với chúng tôi" có thể nghĩa là chưa đủ bằng chứng, có thể nghĩa là không hợp khẩu vị, cũng có thể chỉ là cách từ chối lịch sự.',
          'Cách tìm ra lý do thật: hỏi một câu cụ thể thay vì câu chung. "Nếu sáu tháng nữa chúng tôi có ba mươi khách hàng trả tiền thì anh có xem lại không" cho câu trả lời hữu ích hơn nhiều so với "anh cho em xin góp ý".',
          'Nếu cùng một lý do xuất hiện ở ba nơi khác nhau, đó gần như chắc chắn là vấn đề thật cần xử lý.',
        ],
      },
      {
        h: 'Ba loại từ chối và cách phản ứng',
        p: [
          'Không hợp khẩu vị: ngành, giai đoạn, địa bàn hoặc quy mô séc lệch. Không phải lỗi của hồ sơ. Việc cần làm là chọn nơi tiếp cận kỹ hơn.',
          'Chưa đủ bằng chứng: họ thích nhưng muốn thấy thêm. Đây là loại từ chối tốt nhất, vì nó cho bạn mục tiêu cụ thể và một cánh cửa còn mở.',
          'Không tin vào bài toán: họ nghi ngờ thị trường, mô hình hoặc đội ngũ. Loại này khó nhất, và nếu lặp lại nhiều lần thì cần nhìn lại nghiêm túc.',
        ],
      },
      {
        h: 'Giữ cửa mở',
        p: [
          'Trả lời cảm ơn, ngắn gọn, không tranh luận. Tranh luận với lời từ chối gần như không bao giờ đổi được quyết định và luôn để lại ấn tượng xấu.',
          'Xin phép giữ liên lạc và gửi thư cập nhật định kỳ. Rất nhiều thương vụ diễn ra ở vòng sau với người đã từ chối vòng trước.',
          'Ghi lại lý do từ chối của từng nơi. Sau mười cuộc gặp, bảng đó cho thấy vấn đề chung rõ hơn bất kỳ suy đoán nào.',
        ],
      },
    ],
    faq: [
      {
        q: 'Bao nhiêu lần từ chối là bình thường?',
        a: 'Rất nhiều. Gặp hai ba chục nơi để đóng một vòng là chuyện thường. Điều đáng lo là không ai cho phản hồi cụ thể, nghĩa là hồ sơ chưa đủ rõ để họ có ý kiến.',
      },
      {
        q: 'Có nên quay lại sau khi bị từ chối không?',
        a: 'Nên, nếu đã đạt được điều họ nói còn thiếu. Quay lại với bằng chứng mới là cách tiếp cận rất mạnh, vì nó cho thấy bạn làm được điều đã nói.',
      },
      {
        q: 'Bị từ chối hết thì làm gì?',
        a: 'Dừng lại và xem lại thay vì tiếp tục gửi. Có thể hồ sơ chưa sẵn sàng, có thể danh sách tiếp cận sai, cũng có thể vốn mạo hiểm không phải nguồn phù hợp cho mô hình của bạn.',
      },
    ],
  },

  'liquidation-preference': {
    lienQuan: ['thac-phan-phoi-thanh-ly', 'pari-passu', 'co-tuc-tich-luy'],
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Quyền ưu tiên thanh toán cho phép nhà đầu tư nhận lại tiền trước khi chia cho cổ đông phổ thông, khi công ty được bán hoặc giải thể.',
          'Đây là điều khoản quan trọng thứ hai trong term sheet sau định giá, và trong nhiều trường hợp còn ảnh hưởng tới túi tiền của bạn nhiều hơn định giá.',
        ],
      },
      {
        h: 'Thấy rõ bằng số cụ thể',
        p: [
          'Quỹ đầu tư 6 tỷ, nhận 20% công ty, với quyền ưu tiên một lần không tham gia chia tiếp.',
          'Công ty bán được 60 tỷ: quỹ chọn nhận 20% tức 12 tỷ, vì con số đó lớn hơn 6 tỷ ưu tiên. Người sáng lập chia phần còn lại.',
          'Công ty bán được 20 tỷ: quỹ chọn lấy 6 tỷ ưu tiên, còn lại 14 tỷ chia cho cổ phần phổ thông.',
          'Công ty bán được 6 tỷ: quỹ lấy toàn bộ, người sáng lập không nhận gì, dù trên giấy tờ vẫn sở hữu 80% công ty.',
        ],
      },
      {
        h: 'Hai biến thể cần phân biệt',
        p: [
          'Không tham gia chia tiếp là thông lệ. Nhà đầu tư chọn một trong hai: lấy phần ưu tiên, hoặc chuyển sang cổ phần phổ thông và chia theo tỷ lệ. Chọn cái nào lớn hơn.',
          'Có tham gia chia tiếp thì họ lấy cả hai: nhận phần ưu tiên trước, rồi vẫn chia tiếp phần còn lại theo tỷ lệ. Bất lợi rõ rệt cho người sáng lập trong thương vụ bán quy mô vừa.',
          'Mức bội số cũng quan trọng. Một lần là thông lệ; các mức cao hơn xuất hiện khi nhà đầu tư muốn bù rủi ro, và đó là điều khoản cần hỏi vì sao.',
        ],
      },
      {
        h: 'Vì sao phải tính thử kịch bản trung bình',
        p: [
          'Phần lớn thương vụ không phải thành công rực rỡ. Chúng là những vụ bán ở mức vừa phải, và đó chính là lúc điều khoản này phát huy tác dụng mạnh nhất.',
          'Sau ba vòng, tổng phần ưu tiên có thể lớn hơn giá bán trong kịch bản trung bình. Khi đó người sáng lập không nhận được gì dù công ty không hề thất bại.',
          'Cách kiểm tra đơn giản: cộng tất cả phần ưu tiên qua các vòng, rồi hỏi mức bán nào thì bạn bắt đầu nhận được tiền.',
        ],
      },
    ],
    faq: [
      {
        q: 'Mức nào được coi là bình thường?',
        a: 'Một lần, không tham gia chia tiếp, là thông lệ ở thị trường phát triển. Nếu term sheet ghi khác, đó là điều khoản đáng đàm phán.',
      },
      {
        q: 'Ở vòng pre-seed có điều khoản này không?',
        a: 'Thường chưa, đặc biệt khi dùng SAFE hoặc nhà đầu tư nhận cổ phần phổ thông. Nó trở nên phổ biến từ vòng seed trở đi.',
      },
      {
        q: 'Đổi định giá cao lấy điều khoản nặng có đáng không?',
        a: 'Thường là không. Con số định giá đưa lên báo, còn điều khoản mới quyết định bạn nhận được bao nhiêu thật.',
      },
    ],
  },

  'quyen-phu-quyet': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Quyền phủ quyết cho phép nhà đầu tư chặn một số quyết định của công ty, dù họ chỉ nắm thiểu số cổ phần.',
          'Đây là cách họ bảo vệ khoản đầu tư mà không cần nắm quyền kiểm soát đa số.',
        ],
      },
      {
        h: 'Những quyết định thường bị ràng buộc',
        p: [
          'Bán công ty hoặc sáp nhập.',
          'Phát hành thêm cổ phần, tức mọi vòng gọi vốn tiếp theo.',
          'Thay đổi điều lệ, đặc biệt phần liên quan tới quyền của cổ đông.',
          'Vay vượt một hạn mức, hoặc thế chấp tài sản công ty.',
          'Thay đổi ngành nghề kinh doanh chính.',
          'Danh sách này là thông lệ và phần lớn hợp lý. Vấn đề nảy sinh khi nó dài hơn nhiều.',
        ],
      },
      {
        h: 'Khi nào điều khoản này thành vấn đề',
        p: [
          'Khi phạm vi quá rộng, tới mức những quyết định vận hành hàng ngày cũng cần xin ý kiến. Công ty giai đoạn sớm cần xoay chuyển nhanh, và mỗi lớp phê duyệt là một lớp chậm.',
          'Khi có nhiều nhà đầu tư ở nhiều vòng, mỗi bên đều có quyền phủ quyết riêng. Lúc đó một quyết định lớn cần sự đồng thuận của quá nhiều người, và một người phản đối là đủ để treo mọi thứ.',
          'Cách giảm thiểu phổ biến: gộp quyền phủ quyết theo nhóm, cần đa số nhà đầu tư đồng ý thay vì từng người riêng lẻ.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Chỉ đọc lướt vì thấy danh sách trông chuẩn mực. Cần đọc kỹ từng dòng và hình dung tình huống thực tế nó sẽ chặn.',
          'Không hỏi vì sao họ cần một quyền cụ thể. Câu hỏi này thường cho ra câu trả lời hữu ích, và đôi khi dẫn tới việc rút bớt.',
          'Quên rằng điều khoản này chồng lên qua các vòng. Vòng seed thêm quyền cho quỹ mới, nhưng quỹ pre-seed vẫn giữ quyền cũ.',
        ],
      },
    ],
    faq: [
      {
        q: 'Có thể từ chối hoàn toàn không?',
        a: 'Rất khó với vòng có quỹ tham gia. Thứ đàm phán được là phạm vi và cách thực hiện, không phải việc có hay không.',
      },
      {
        q: 'Quyền phủ quyết khác gì với ghế hội đồng quản trị?',
        a: 'Quyền phủ quyết là quyền chặn những quyết định cụ thể được liệt kê. Ghế hội đồng cho họ tiếng nói trong mọi quyết định thuộc thẩm quyền hội đồng. Hai thứ thường đi cùng nhau nhưng khác nhau.',
      },
      {
        q: 'Ở Việt Nam thực hiện thế nào?',
        a: 'Thông qua điều lệ và thoả thuận cổ đông, quy định tỷ lệ biểu quyết cần thiết cho từng loại quyết định. Cách soạn cụ thể cần luật sư có kinh nghiệm với thương vụ đầu tư.',
      },
    ],
  },

  'ghe-hoi-dong-quan-tri': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Ghế hội đồng quản trị là quyền cử người tham gia hội đồng, cơ quan ra quyết định lớn của công ty. Nhà đầu tư dẫn dắt thường yêu cầu một ghế từ vòng seed trở đi.',
          'Ở vòng pre-seed thì thường chưa, hoặc chỉ là quyền dự họp không biểu quyết.',
        ],
      },
      {
        h: 'Hội đồng làm gì',
        p: [
          'Quyết định những việc lớn: phê duyệt ngân sách, tuyển và sa thải giám đốc, thông qua vòng gọi vốn, quyết định bán công ty.',
          'Không tham gia vận hành hàng ngày. Nếu hội đồng bắt đầu quản lý chi tiết thì đó là dấu hiệu có gì đó không ổn.',
          'Với công ty giai đoạn sớm, hội đồng họp mỗi quý là nhịp phổ biến.',
        ],
      },
      {
        h: 'Cấu trúc hội đồng quan trọng hơn số ghế',
        p: [
          'Cấu trúc hay gặp ở vòng seed: hai ghế của người sáng lập, một ghế của nhà đầu tư dẫn dắt. Người sáng lập vẫn giữ đa số.',
          'Từ Series A, cấu trúc thường thành hai ghế sáng lập, hai ghế nhà đầu tư, và một ghế độc lập do hai bên cùng chọn. Ghế độc lập là người quyết định khi hai bên bất đồng, nên việc chọn ai rất quan trọng.',
          'Điều cần tránh là để nhà đầu tư nắm đa số ghế quá sớm. Khi đó họ có thể thay giám đốc, kể cả khi đó là người sáng lập.',
        ],
      },
      {
        h: 'Mặt tích cực ít người nhắc tới',
        p: [
          'Một thành viên hội đồng giỏi là nguồn lực thật: kinh nghiệm, mạng lưới, và một người buộc bạn phải chuẩn bị kỹ mỗi quý.',
          'Nhịp họp định kỳ cũng tạo kỷ luật báo cáo mà nhiều đội ngũ giai đoạn sớm thiếu.',
          'Vì vậy câu hỏi không phải "có nên cho ghế không" mà là "người ngồi vào ghế đó có mang lại gì không".',
        ],
      },
    ],
    faq: [
      {
        q: 'Vòng pre-seed có nên cho ghế không?',
        a: 'Thường không cần thiết. Nếu nhà đầu tư yêu cầu, có thể đề xuất quyền dự họp không biểu quyết như một phương án trung gian.',
      },
      {
        q: 'Người sáng lập có tự động có ghế không?',
        a: 'Không tự động, phải quy định trong điều lệ và thoả thuận cổ đông. Đây là chi tiết cần kiểm tra kỹ khi soạn văn bản.',
      },
      {
        q: 'Ghế độc lập chọn thế nào?',
        a: 'Do hai bên cùng thống nhất, thường là người có kinh nghiệm trong ngành và không có lợi ích ở bên nào. Việc chọn ai đáng dành thời gian vì đó là lá phiếu quyết định khi bế tắc.',
      },
    ],
  },

  'mfn-clause': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Điều khoản MFN cam kết rằng nếu sau này bạn ký với người khác điều khoản tốt hơn, thì người có MFN được hưởng điều khoản tốt hơn đó.',
          'Nó hay xuất hiện trong SAFE, đặc biệt với nhà đầu tư vào rất sớm khi chưa ai định giá được công ty.',
        ],
      },
      {
        h: 'Vì sao nó tồn tại',
        p: [
          'Người vào đầu tiên đang chấp nhận rủi ro cao nhất mà không biết những người sau sẽ được điều kiện gì. MFN bảo vệ họ khỏi tình huống người vào sau ba tháng lại được cap thấp hơn.',
          'Với người gọi vốn, nó giải quyết một vấn đề thật: bạn có thể nhận tiền ngay mà chưa phải chốt cap, vì người đầu tiên biết mình sẽ không bị thiệt.',
        ],
      },
      {
        h: 'Cái giá phải cân nhắc',
        p: [
          'MFN khiến bạn mất linh hoạt. Mỗi lần ký một điều khoản tốt hơn cho người mới, bạn tự động nâng điều khoản cho người cũ.',
          'Với nhiều bản MFN cùng lúc, hiệu ứng cộng dồn. Ký một bản cap thấp cho người thứ năm có thể kéo cả bốn người trước xuống cùng mức đó.',
          'Cách giảm thiểu: giới hạn MFN theo thời gian, hoặc chỉ áp dụng cho các khoản ký trong cùng một vòng.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Ký SAFE chỉ có MFN mà không có cap. Nhà đầu tư khi đó chuyển đổi đúng bằng điều khoản tốt nhất bạn ký sau đó, nghe có vẻ ổn, nhưng bạn mất quyền chốt trước một mức trần.',
          'Không theo dõi mình đã ký bao nhiêu bản MFN. Đây là loại điều khoản dễ quên vì nó không tạo ra nghĩa vụ ngay lập tức.',
          'Không đọc kỹ phạm vi. Có bản áp dụng cho mọi điều khoản, có bản chỉ áp dụng cho cap và discount.',
        ],
      },
    ],
    faq: [
      {
        q: 'Có nên chấp nhận MFN không?',
        a: 'Ở vòng rất sớm với khoản nhỏ thì thường hợp lý, vì nó giúp bạn nhận tiền nhanh. Điều cần làm là giới hạn phạm vi và thời gian áp dụng.',
      },
      {
        q: 'MFN có tự động kích hoạt không?',
        a: 'Tuỳ hợp đồng. Có bản tự động, có bản yêu cầu nhà đầu tư phải chọn. Cần đọc kỹ vì điều này ảnh hưởng tới nghĩa vụ thông báo của bạn.',
      },
      {
        q: 'Làm sao quản lý nhiều bản MFN?',
        a: 'Ghi vào bảng cổ phần cùng với các khoản SAFE khác, kèm ghi chú về điều khoản. Đây là thứ thẩm định sẽ hỏi tới.',
      },
    ],
  },

  'dong-vong-goi-von': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Đóng vòng là thời điểm ký xong giấy tờ và tiền thực sự về tài khoản công ty. Nhận term sheet chưa phải đóng vòng, còn thẩm định và soạn hợp đồng ở giữa.',
          'Khoảng cách từ term sheet tới lúc tiền về thường là bốn tới tám tuần.',
        ],
      },
      {
        h: 'Các bước từ term sheet tới tiền',
        p: [
          'Thẩm định: nhà đầu tư kiểm tra pháp lý, tài chính và kinh doanh. Hai tới bốn tuần nếu hồ sơ gọn.',
          'Soạn hợp đồng: luật sư hai bên soạn và rà hợp đồng đầu tư, thoả thuận cổ đông, và các văn bản kèm theo.',
          'Thủ tục nội bộ: nghị quyết cổ đông, sửa điều lệ nếu cần, cập nhật đăng ký kinh doanh.',
          'Chuyển tiền và ghi nhận cổ phần vào sổ đăng ký cổ đông.',
        ],
      },
      {
        h: 'Đóng một lần hay nhiều lần',
        p: [
          'Đóng một lần là tất cả nhà đầu tư ký và chuyển tiền cùng lúc. Gọn nhưng đòi hỏi mọi người sẵn sàng cùng thời điểm.',
          'Đóng nhiều lần cho phép nhận tiền từ người đã sẵn sàng, phần còn lại đóng sau trong một khoảng thời gian quy định. Cách này hay dùng ở vòng sớm và giúp bạn có tiền dùng ngay.',
          'Nếu đóng nhiều lần, cần thống nhất trước rằng mọi người cùng điều khoản, tránh tình huống người vào sau đàm phán lại.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Coi term sheet là chắc chắn và ngừng nói chuyện với nơi khác trước khi cần. Điều khoản độc quyền đàm phán chỉ ràng buộc sau khi ký, và thương vụ vẫn có thể đổ vỡ trong thẩm định.',
          'Không chuẩn bị trước phần thủ tục nội bộ. Việc sửa điều lệ và cập nhật đăng ký có thời hạn riêng và không rút ngắn được.',
          'Tiêu tiền trước khi tiền về. Cam kết miệng không phải tiền trong tài khoản.',
        ],
      },
    ],
    faq: [
      {
        q: 'Tỷ lệ term sheet đổ vỡ là bao nhiêu?',
        a: 'Không phổ biến nhưng vẫn xảy ra, thường do phát hiện vấn đề trong thẩm định hoặc do thay đổi ở phía nhà đầu tư. Vì vậy đừng ngừng chuẩn bị phương án khác cho tới khi tiền về.',
      },
      {
        q: 'Có thể rút ngắn thời gian không?',
        a: 'Chủ yếu bằng cách chuẩn bị data room trước và có luật sư sẵn sàng. Phần lớn thời gian chậm nằm ở việc chờ tài liệu.',
      },
      {
        q: 'Sau khi đóng vòng cần làm gì?',
        a: 'Cập nhật bảng cổ phần và sổ đăng ký cổ đông, hoàn tất thủ tục đăng ký nếu có, và bắt đầu gửi thư cập nhật định kỳ cho nhà đầu tư mới.',
      },
    ],
  },

  'chong-pha-loang': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Điều khoản chống pha loãng bảo vệ nhà đầu tư khi vòng sau có định giá thấp hơn vòng họ tham gia. Nó điều chỉnh giá quy đổi của họ xuống, khiến họ nhận thêm cổ phần mà không bỏ thêm tiền.',
          'Phần cổ phần thêm đó lấy từ cổ đông phổ thông, tức là từ bạn.',
        ],
      },
      {
        h: 'Hai cách tính',
        p: [
          'Trung bình có trọng số là cách thông lệ. Giá quy đổi được điều chỉnh xuống một phần, có tính tới quy mô vòng mới so với tổng cổ phần hiện có. Vòng giảm giá nhỏ thì điều chỉnh nhẹ.',
          'Điều chỉnh toàn phần là cách khắc nghiệt: giá quy đổi hạ thẳng xuống bằng giá vòng mới, bất kể quy mô. Cách này lấy đi rất nhiều từ người sáng lập và ít được coi là hợp lý.',
          'Nếu term sheet ghi cách thứ hai, đó là điều khoản cần đàm phán lại.',
        ],
      },
      {
        h: 'Vì sao nó tồn tại',
        p: [
          'Nhà đầu tư trả một mức giá dựa trên kỳ vọng công ty sẽ tăng giá trị. Nếu vòng sau định giá thấp hơn, họ đã trả quá cao, và điều khoản này bù lại phần chênh.',
          'Nó cũng tạo áp lực lên người sáng lập phải đạt cột mốc để vòng sau không giảm giá. Điều mà nhà đầu tư coi là hợp lý.',
          'Mặt trái: nó khiến việc gọi vòng giảm giá trở nên rất đắt, đôi khi đắt tới mức công ty chọn cạn tiền thay vì gọi vốn ở mức thấp hơn.',
        ],
      },
      {
        h: 'Cách giảm rủi ro',
        p: [
          'Đừng nhận định giá quá cao ở vòng đầu. Đây là cách phòng ngừa hiệu quả nhất, vì nó giảm khả năng vòng sau phải giảm giá.',
          'Đàm phán để dùng cách trung bình có trọng số, và tìm hiểu kỹ công thức cụ thể.',
          'Đề nghị điều khoản chỉ áp dụng trong một khoảng thời gian nhất định, thay vì mãi mãi.',
        ],
      },
    ],
    faq: [
      {
        q: 'Vòng pre-seed có điều khoản này không?',
        a: 'Thường chưa, đặc biệt khi dùng SAFE. Nó phổ biến từ vòng có cổ phần ưu đãi trở đi.',
      },
      {
        q: 'Điều khoản này có kích hoạt khi phát hành cổ phần cho nhân sự không?',
        a: 'Thông thường không, vì hợp đồng có danh sách ngoại lệ gồm quỹ cổ phiếu thưởng. Cần kiểm tra danh sách ngoại lệ có đầy đủ không.',
      },
      {
        q: 'Nếu vòng sau giảm giá thì mất bao nhiêu?',
        a: 'Tuỳ mức giảm và cách tính. Nên chạy thử bằng công cụ đọc term sheet với kịch bản vòng sau giảm giá để thấy con số cụ thể trước khi ký.',
      },
    ],
  },

  'vong-giam-gia': {
    lienQuan: ['vong-tang-gia'],
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Vòng giảm giá là vòng gọi vốn có định giá thấp hơn vòng trước đó. Nó xảy ra khi công ty chưa đạt cột mốc tương xứng với định giá cũ, hoặc khi thị trường vốn thay đổi.',
          'Không phải dấu chấm hết, nhưng gây khó về cả tín hiệu lẫn cấu trúc vốn.',
        ],
      },
      {
        h: 'Chuyện gì xảy ra',
        p: [
          'Điều khoản chống pha loãng của nhà đầu tư cũ kích hoạt. Họ nhận thêm cổ phần mà không bỏ thêm tiền, và phần đó lấy từ cổ đông phổ thông.',
          'Người sáng lập vì thế bị pha loãng gấp đôi: một lần vì tiền mới, một lần vì điều chỉnh cho nhà đầu tư cũ.',
          'Về tín hiệu, nhà đầu tư mới sẽ hỏi vì sao. Câu trả lời phải cụ thể và cho thấy bạn đã điều chỉnh.',
        ],
      },
      {
        h: 'Vì sao nó thường bắt nguồn từ vòng trước',
        p: [
          'Định giá quá cao ở vòng đầu là nguyên nhân phổ biến nhất. Khi mức đó vượt xa cột mốc thực tế, mười tám tháng sau không có cách nào gọi cao hơn.',
          'Đây là lý do định giá cao không phải thắng lợi. Nó chỉ dời vấn đề sang tương lai và làm nó lớn hơn.',
          'Nguyên nhân thứ hai là kế hoạch trượt mà không điều chỉnh chi tiêu kịp, tiêu theo kế hoạch lạc quan trong khi kết quả không tới.',
        ],
      },
      {
        h: 'Nếu buộc phải đi qua',
        p: [
          'Nói thẳng với nhà đầu tư hiện hữu trước khi đàm phán với người mới. Họ cần thời gian xử lý, và việc họ tham gia hay không là tín hiệu quan trọng.',
          'Chuẩn bị câu chuyện trung thực: điều gì đã không diễn ra như dự kiến, đã học được gì, và kế hoạch mới khác ở đâu.',
          'Cân nhắc vốn cầu nối như phương án thay thế nếu chỉ cần thêm thời gian để đạt cột mốc.',
          'Nhiều doanh nghiệp đi qua vòng giảm giá rồi vẫn phát triển tốt. Điều quyết định là cách xử lý, không phải bản thân sự kiện.',
        ],
      },
    ],
    faq: [
      {
        q: 'Có cách nào tránh hoàn toàn không?',
        a: 'Cách hiệu quả nhất là không nhận định giá quá cao ở vòng trước, và điều chỉnh chi tiêu sớm khi thấy kế hoạch trượt.',
      },
      {
        q: 'Nhà đầu tư cũ có ngăn được vòng giảm giá không?',
        a: 'Có thể, nếu họ có quyền phủ quyết với việc phát hành thêm cổ phần. Đây là lý do phải trao đổi với họ trước.',
      },
      {
        q: 'Vòng giảm giá ảnh hưởng tới nhân sự thế nào?',
        a: 'Cổ phần thưởng đã cấp trở nên kém giá trị hơn, và tin tức lan ra nội bộ rất nhanh. Nên có kế hoạch trao đổi với đội ngũ, thường kèm việc cấp bổ sung.',
      },
    ],
  },

  'series-a': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Series A là vòng vốn thể chế đầu tiên, thường diễn ra khi mô hình kinh doanh đã được kiểm chứng và cần vốn để mở rộng quy mô.',
          'Khác biệt lớn nhất so với seed: câu hỏi chuyển từ "có ai cần không" sang "có cách nào tăng trưởng lặp lại được không".',
        ],
      },
      {
        h: 'Nhà đầu tư nhìn gì',
        p: [
          'Kênh tăng trưởng hoạt động được. Không còn là "có khách hàng" mà là "biết cách có thêm khách hàng với chi phí dự đoán được".',
          'Kinh tế đơn vị hợp lý. Chi phí có được khách hàng, giá trị vòng đời, thời gian hoàn vốn, ba con số này phải đứng vững trước chất vấn.',
          'Doanh thu định kỳ đang tăng đều, và tỷ lệ giữ chân khách hàng tốt.',
          'Đội ngũ đã có đủ những vị trí then chốt, không còn phụ thuộc hoàn toàn vào người sáng lập.',
        ],
      },
      {
        h: 'Khác biệt về quy trình',
        p: [
          'Thẩm định kỹ hơn nhiều. Kiểm toán sổ sách, phỏng vấn khách hàng, đôi khi thuê bên thứ ba đánh giá kỹ thuật.',
          'Điều khoản phức tạp hơn: cổ phần ưu đãi, quyền ưu tiên thanh toán, ghế hội đồng quản trị, quyền phủ quyết rộng hơn.',
          'Thời gian dài hơn, thường ba tới sáu tháng từ cuộc gặp đầu tới lúc tiền về.',
        ],
      },
      {
        h: 'Chuẩn bị từ vòng trước',
        p: [
          'Cột mốc cho Series A nên được xác định ngay khi đang gọi vòng seed. Hỏi thẳng nhà đầu tư seed họ cần thấy gì.',
          'Hồ sơ pháp lý và sổ sách phải chuẩn từ sớm. Thẩm định Series A sẽ soi kỹ, và việc dọn dẹp muộn rất tốn thời gian.',
          'Bắt đầu xây quan hệ với quỹ Series A từ trước sáu tới mười hai tháng, qua thư cập nhật định kỳ.',
        ],
      },
    ],
    faq: [
      {
        q: 'Cần doanh thu bao nhiêu mới gọi được Series A?',
        a: 'Không có mốc cứng và khác nhau rất nhiều theo ngành và thị trường. Điều quan trọng hơn con số tuyệt đối là tốc độ tăng và khả năng lặp lại của kênh tăng trưởng.',
      },
      {
        q: 'Có bắt buộc phải qua seed trước không?',
        a: 'Không, nhưng hiếm khi bỏ qua. Khoảng cách về mức độ chứng minh giữa pre-seed và Series A thường quá lớn để nhảy thẳng.',
      },
      {
        q: 'Sau Series A người sáng lập còn bao nhiêu?',
        a: 'Thông lệ là trên năm mươi phần trăm. Dưới bốn mươi phần trăm ở giai đoạn này là cấu trúc khiến các vòng sau khó khăn.',
      },
    ],
  },

  'gross-burn-net-burn': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Đốt gộp là tổng tiền chi ra mỗi tháng. Đốt ròng là tổng chi trừ doanh thu, tức số tiền thực sự rời khỏi tài khoản.',
          'Khi nhà đầu tư hỏi "mỗi tháng đốt bao nhiêu", họ hỏi đốt ròng. Nhưng cả hai con số đều đáng theo dõi, vì mỗi cái trả lời một câu hỏi khác nhau.',
        ],
      },
      {
        h: 'Mỗi con số nói lên điều gì',
        p: [
          'Đốt ròng cho biết runway. Đây là con số quyết định bạn còn bao nhiêu thời gian.',
          'Đốt gộp cho biết cấu trúc chi phí và mức độ nhạy cảm. Doanh nghiệp chi 200 triệu thu về 150 triệu có đốt ròng 50 triệu, nghe an toàn. Nhưng chỉ cần mất một khách hàng lớn là đốt ròng nhảy lên gấp đôi.',
          'Doanh nghiệp chi 60 triệu không thu gì cũng có đốt ròng 60 triệu, nhưng ít mong manh hơn nhiều.',
        ],
      },
      {
        h: 'Vì sao nhà đầu tư hỏi cả hai',
        p: [
          'Đốt ròng thấp nhờ doanh thu là dấu hiệu tốt, nhưng chỉ khi doanh thu đó ổn định.',
          'Nếu doanh thu đến từ vài hợp đồng dịch vụ một lần, đốt ròng thấp là ảo. Tháng sau không có hợp đồng mới thì con số đổi hẳn.',
          'Vì vậy khi báo cáo, nên nêu cả hai và nói rõ doanh thu thuộc loại nào, định kỳ hay một lần.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Báo đốt ròng mà không nói doanh thu đến từ đâu. Người đọc có kinh nghiệm sẽ hỏi ngay.',
          'Tính runway theo đốt gộp. Con số ra thấp hơn thực tế và khiến bạn hoảng không cần thiết.',
          'Quên rằng sau khi nhận vốn, cả hai con số đều tăng. Đốt gộp tăng vì tuyển người; đốt ròng tăng theo nếu doanh thu chưa kịp bắt nhịp.',
        ],
      },
    ],
    faq: [
      {
        q: 'Nên báo cáo con số nào trong thư cập nhật nhà đầu tư?',
        a: 'Cả hai, cùng với tiền mặt còn lại và số tháng runway. Bốn con số này là bộ tối thiểu mà người đọc cần.',
      },
      {
        q: 'Doanh thu một lần có được trừ vào đốt gộp không?',
        a: 'Về mặt số học thì có, nhưng nên ghi chú rõ. Đốt ròng nhờ một hợp đồng dịch vụ lớn không phản ánh tình hình bình thường.',
      },
      {
        q: 'Đốt ròng âm nghĩa là gì?',
        a: 'Doanh thu vượt chi phí, tiền đang vào chứ không ra. Đây là trạng thái tốt, nhưng vẫn nên theo dõi đốt gộp để biết mình mong manh tới đâu.',
      },
    ],
  },

  'bien-loi-nhuan-gop': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Biên lợi nhuận gộp là phần trăm doanh thu còn lại sau khi trừ chi phí trực tiếp để phục vụ khách hàng.',
          'Công thức: biên lợi nhuận gộp = lợi nhuận gộp / doanh thu, trong đó lợi nhuận gộp = doanh thu trừ chi phí trực tiếp (giá vốn).',
          'Nó quyết định mỗi đồng doanh thu thực sự đóng góp bao nhiêu vào việc bù chi phí cố định và tạo lợi nhuận.',
        ],
      },
      {
        h: 'Ví dụ bằng số',
        p: [
          'Một startup phần mềm có doanh thu quý 300 triệu. Chi phí trực tiếp gồm máy chủ 45 triệu, phí cổng thanh toán 9 triệu và hỗ trợ khách hàng 36 triệu, cộng lại 90 triệu.',
          'Lợi nhuận gộp = 300 triệu trừ 90 triệu = 210 triệu. Biên lợi nhuận gộp = 210 / 300 = 70%.',
          'Nghĩa là mỗi 100 đồng doanh thu còn 70 đồng để trả lương đội ngũ, marketing, văn phòng và tạo lợi nhuận. Đây là bước đầu của bài toán [[kinh-te-don-vi|kinh tế đơn vị]]; thử với số của bạn ở công cụ [[/cong-cu/kiem-tra-gia-dinh-kinh-te-don-vi|Kiểm tra giả định kinh tế đơn vị]].',
        ],
      },
      {
        h: 'Chi phí nào được trừ',
        p: [
          'Trừ: hạ tầng máy chủ, phí cổng thanh toán, chi phí hỗ trợ khách hàng, giá vốn hàng bán, hoa hồng trả cho đối tác phân phối.',
          'Không trừ: lương đội kỹ thuật xây sản phẩm chung, lương quản lý, tiền thuê văn phòng, chi phí marketing.',
          'Ranh giới hay gây tranh cãi là lương người vừa hỗ trợ khách vừa làm việc khác. Cách xử lý phổ biến là chia theo tỷ lệ thời gian và ghi rõ cách chia.',
        ],
      },
      {
        h: 'Mức nào là bình thường',
        p: [
          'Phần mềm thuê bao thường có biên rất cao, vì phục vụ thêm một khách gần như không tốn thêm chi phí.',
          'Sàn giao dịch và mô hình có giá vốn hàng bán thì thấp hơn nhiều.',
          'Dưới hai mươi phần trăm nghĩa là mỗi khách mới đóng góp rất ít vào việc bù chi phí cố định, mô hình vẫn chạy được nhưng cần quy mô lớn hơn nhiều.',
          'Trên chín mươi lăm phần trăm là dấu hiệu nên kiểm tra lại xem đã trừ hết chi phí phục vụ chưa. Rất ít mô hình thật đạt mức đó.',
        ],
      },
      {
        h: 'Vì sao con số này ảnh hưởng tới mọi thứ khác',
        p: [
          'Giá trị vòng đời khách hàng tính bằng lãi gộp, không phải doanh thu. Biên thấp thì giá trị vòng đời thấp theo.',
          'Thời gian hoàn vốn cũng vậy: biên càng thấp thì càng lâu thu hồi chi phí có được khách.',
          'Và biên ảnh hưởng tới định giá. Cùng một mức doanh thu, mô hình biên cao được định giá cao hơn hẳn.',
        ],
      },
    ],
    faq: [
      {
        q: 'Biên thấp thì có gọi được vốn không?',
        a: 'Được, nhưng câu chuyện phải khác. Mô hình biên thấp cần chứng minh quy mô lớn hoặc lợi thế cạnh tranh khác, thay vì dựa vào biên.',
      },
      {
        q: 'Biên có cải thiện theo quy mô không?',
        a: 'Thường có, nhất là với phần mềm khi chi phí hạ tầng được chia đều cho nhiều khách hơn. Nếu bạn kỳ vọng điều này, hãy nói rõ cơ chế thay vì chỉ vẽ đường đi lên.',
      },
      {
        q: 'Nên tính theo tháng hay theo năm?',
        a: 'Theo quý là hợp lý ở giai đoạn sớm. Theo tháng thì nhiễu vì chi phí hạ tầng không đều.',
      },
    ],
  },

  'diem-hoa-von': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Điểm hoà vốn là thời điểm lãi gộp đủ bù toàn bộ chi phí, công ty không còn đốt tiền nữa.',
          'Với startup giai đoạn sớm, đây thường là mục tiêu xa. Nhưng biết nó nằm ở đâu là điều nhà đầu tư sẽ hỏi.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Chi phí cố định mỗi tháng 200 triệu: lương, văn phòng, hạ tầng chung.',
          'Mỗi khách trả 2 triệu, biên lợi nhuận gộp 75%, tức đóng góp 1,5 triệu mỗi tháng.',
          'Cần 200 chia 1,5, khoảng 134 khách hàng để hoà vốn.',
          'Con số này hữu ích hơn nhiều so với một mốc thời gian, vì nó chuyển mục tiêu thành thứ đội ngũ làm được mỗi ngày.',
        ],
      },
      {
        h: 'Điều cần cẩn thận',
        p: [
          'Chi phí cố định không đứng yên. Tuyển thêm người thì điểm hoà vốn lùi ra xa. Nhiều doanh nghiệp đuổi theo mãi không tới vì mỗi lần gần tới lại tăng chi.',
          'Đó không hẳn là sai. Ở giai đoạn tăng trưởng, việc chủ động lùi điểm hoà vốn để mở rộng nhanh hơn là lựa chọn hợp lý, miễn là có ý thức và có vốn.',
          'Điều nguy hiểm là lùi mà không nhận ra.',
        ],
      },
      {
        h: 'Hoà vốn có phải mục tiêu không',
        p: [
          'Với doanh nghiệp tự nuôi thì có, đó là điều kiện sống còn.',
          'Với doanh nghiệp gọi vốn mạo hiểm thì không nhất thiết. Nhà đầu tư thường muốn thấy tăng trưởng hơn là hoà vốn sớm, vì hoà vốn sớm đôi khi nghĩa là chưa đầu tư đủ vào tăng trưởng.',
          'Điều họ muốn biết là bạn có thể hoà vốn nếu cần hay không. Đó là phương án dự phòng khi không gọi được vòng tiếp theo.',
        ],
      },
    ],
    faq: [
      {
        q: 'Nên đặt mục tiêu hoà vốn trong bao lâu?',
        a: 'Không có mốc chung. Điều quan trọng hơn là biết cần bao nhiêu khách hàng, và con đường tới đó có khả thi với nguồn lực hiện có không.',
      },
      {
        q: 'Hoà vốn tiền mặt khác gì hoà vốn kế toán?',
        a: 'Hoà vốn tiền mặt là khi tiền vào bằng tiền ra, thứ quyết định runway. Hoà vốn kế toán tính cả các khoản chưa chi bằng tiền. Ở giai đoạn sớm, con số tiền mặt quan trọng hơn.',
      },
      {
        q: 'Có nên nêu điểm hoà vốn trong pitch deck không?',
        a: 'Nên, dưới dạng số khách hàng cần đạt chứ không phải mốc thời gian. Nó cho thấy bạn hiểu cấu trúc chi phí của mình.',
      },
    ],
  },

  'burn-multiple': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Burn multiple đo hiệu quả sử dụng vốn: lấy số tiền đốt ròng trong kỳ chia cho phần doanh thu định kỳ mới tạo ra trong kỳ đó.',
          'Nó trả lời câu hỏi: mỗi đồng đốt ra mua được bao nhiêu đồng doanh thu mới.',
        ],
      },
      {
        h: 'Tính bằng số cụ thể',
        p: [
          'Quý vừa rồi bạn đốt ròng 400 triệu. Doanh thu định kỳ hàng tháng tăng từ 50 triệu lên 90 triệu, tức tạo thêm 40 triệu.',
          'Burn multiple = 400 chia 40 = 10 lần.',
          'Con số càng thấp càng tốt. Dưới hai lần được coi là rất hiệu quả; trên năm lần là dấu hiệu tiền đang đi ra nhanh hơn nhiều so với kết quả mang lại.',
        ],
      },
      {
        h: 'Vì sao chỉ số này hữu ích',
        p: [
          'Tăng trưởng nhanh mà đốt rất nhiều không phải thành tích. Bất kỳ ai có đủ vốn đều mua được tăng trưởng; câu hỏi là mua với giá nào.',
          'Burn multiple gộp cả hai mặt vào một con số, nên nó khó bị làm đẹp bằng cách chọn chỉ số có lợi.',
          'Nó cũng dự báo được khả năng gọi vốn vòng sau. Doanh nghiệp có burn multiple thấp cần ít vốn hơn cho cùng mức tăng trưởng.',
        ],
      },
      {
        h: 'Giới hạn ở giai đoạn sớm',
        p: [
          'Chỉ số này cần doanh thu định kỳ đủ lớn để có nghĩa. Với doanh thu vài chục triệu, một khách hàng thêm hoặc bớt làm con số nhảy rất mạnh.',
          'Nó cũng không phù hợp với doanh nghiệp đang xây sản phẩm chưa bán. Đốt tiền để nghiên cứu không tạo doanh thu ngay, nhưng không có nghĩa là kém hiệu quả.',
          'Vì vậy đây là chỉ số của vòng seed trở đi, không phải pre-seed.',
        ],
      },
    ],
    faq: [
      {
        q: 'Nên tính theo quý hay theo năm?',
        a: 'Theo quý là phổ biến, đủ dài để giảm nhiễu nhưng vẫn kịp phát hiện xu hướng.',
      },
      {
        q: 'Burn multiple cao thì phải làm gì?',
        a: 'Xem lại kênh tăng trưởng nào đang tốn tiền mà mang lại ít, và cấu trúc chi phí cố định. Đôi khi vấn đề không ở marketing mà ở việc tuyển quá nhanh.',
      },
      {
        q: 'Có so sánh được giữa các ngành không?',
        a: 'Không nên. Mô hình có chu kỳ bán dài tự nhiên có burn multiple cao hơn. So với chính mình qua các quý có ý nghĩa hơn.',
      },
    ],
  },

  'cohort-la-gi': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Cohort là nhóm khách hàng bắt đầu sử dụng trong cùng một kỳ, thường là cùng tháng. Theo dõi riêng từng nhóm cho biết khách hàng ở lại bao lâu và chi tiêu thay đổi thế nào.',
          'Đây là cách duy nhất để đo tỷ lệ giữ chân một cách đáng tin.',
        ],
      },
      {
        h: 'Vì sao không thể đo bằng số tổng',
        p: [
          'Doanh nghiệp đang tăng trưởng nhanh luôn có nhiều khách mới. Khách mới chưa kịp rời đi, nên tỷ lệ rời bỏ tính trên tổng số trông thấp giả tạo.',
          'Ví dụ: tháng này có 100 khách cũ và 100 khách mới. Trong số khách cũ, 20 người rời đi. Tính trên tổng 200 thì tỷ lệ rời bỏ là 10%. Nhưng tỷ lệ thật của nhóm khách cũ là 20%.',
          'Nhìn theo cohort thì con số 20% hiện ra ngay, và đó mới là thứ dùng để dự báo.',
        ],
      },
      {
        h: 'Bảng cohort trông thế nào',
        p: [
          'Mỗi hàng là một nhóm khách bắt đầu trong một tháng. Mỗi cột là số tháng đã trôi qua kể từ khi họ bắt đầu.',
          'Ô giao nhau ghi phần trăm còn lại, hoặc doanh thu còn lại của nhóm đó.',
          'Đọc theo hàng cho biết một nhóm hao hụt thế nào theo thời gian. Đọc theo cột cho biết các nhóm gần đây có giữ chân tốt hơn nhóm cũ không, đó là dấu hiệu sản phẩm đang cải thiện.',
        ],
      },
      {
        h: 'Ở giai đoạn sớm thì làm sao',
        p: [
          'Cần ít nhất ba tới sáu kỳ mới thấy được xu hướng. Dưới ba kỳ thì bảng chưa nói lên điều gì.',
          'Số khách mỗi nhóm cũng cần đủ. Nhóm mười người thì mỗi người rời đi làm tỷ lệ nhảy mười điểm phần trăm.',
          'Nếu chưa đủ dữ liệu, cách trung thực là nói rõ điều đó thay vì đưa ra tỷ lệ giữ chân như một con số đã đo được.',
        ],
      },
    ],
    faq: [
      {
        q: 'Nên theo dõi theo số khách hay theo doanh thu?',
        a: 'Cả hai. Theo số khách cho biết ai ở lại; theo doanh thu cho biết họ chi nhiều hơn hay ít hơn. Doanh nghiệp có thể mất khách nhưng vẫn tăng doanh thu nếu khách ở lại nâng gói.',
      },
      {
        q: 'Bao nhiêu kỳ là đủ để tin?',
        a: 'Sáu kỳ trở lên bắt đầu có ý nghĩa. Mười hai kỳ thì đủ để nói về vòng đời khách hàng một cách tự tin.',
      },
      {
        q: 'Cần công cụ gì để làm bảng cohort?',
        a: 'Một bảng tính là đủ ở giai đoạn sớm. Điều cần là dữ liệu ghi lại đúng ngày mỗi khách bắt đầu và ngày họ ngừng.',
      },
    ],
  },

  'bottom-up-market-sizing': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Ước lượng thị trường từ dưới lên là dựng quy mô thị trường từ số khách hàng và giá trị mỗi khách, thay vì lấy con số tổng từ một báo cáo ngành.',
          'Đây là cách duy nhất nhà đầu tư giai đoạn sớm thực sự đọc.',
        ],
      },
      {
        h: 'Cách làm, từng bước',
        p: [
          'Bước một: xác định ai là khách hàng. Càng cụ thể càng tốt, không phải "doanh nghiệp nhỏ" mà "chuỗi bán lẻ từ năm cửa hàng trở lên tại khu vực thành thị".',
          'Bước hai: đếm có bao nhiêu đơn vị như vậy. Dùng số liệu thống kê công bố, hoặc tự đếm trong một khu vực rồi nhân lên.',
          'Bước ba: xác định mỗi khách trả bao nhiêu một năm, dựa trên giá bạn đang thu hoặc dự kiến thu.',
          'Bước bốn: nhân lên, rồi thu hẹp dần theo phần bạn thực sự tiếp cận được và phần bạn giành được.',
        ],
      },
      {
        h: 'Vì sao cách này thuyết phục hơn',
        p: [
          'Nó cho thấy bạn hiểu khách hàng của mình là ai. Con số từ báo cáo ngành không nói gì về điều đó.',
          'Nó kiểm chứng được. Người đọc có thể chất vấn từng giả định và bạn trả lời được. Điều không làm được với một con số bê nguyên từ tài liệu khác.',
          'Và nó thường cho ra con số nhỏ hơn nhưng đáng tin hơn. Một thị trường 2.000 tỷ có cơ sở tốt hơn một thị trường 10 tỷ đô không ai kiểm chứng được.',
        ],
      },
      {
        h: 'Sai lầm thường gặp',
        p: [
          'Dùng cách từ dưới lên để ra con số rồi lại lấy con số báo cáo ngành để đối chiếu và chọn cái lớn hơn. Người đọc nhận ra ngay.',
          'Không ghi nguồn cho từng giả định. Một con số không có nguồn là một con số bịa, dù nó nằm trong một phép tính đúng.',
          'Quên rằng giá bán có thể thay đổi. Nếu mô hình định giá còn đang thử nghiệm, hãy nói rõ và đưa ra khoảng.',
        ],
      },
    ],
    faq: [
      {
        q: 'Không tìm được số liệu thống kê thì sao?',
        a: 'Tự đếm trong phạm vi nhỏ rồi ngoại suy, và nói rõ cách làm. Khảo sát tự thực hiện với ba mươi khách hàng đáng tin hơn một con số không rõ nguồn gốc.',
      },
      {
        q: 'Nên dùng giá hiện tại hay giá dự kiến?',
        a: 'Giá hiện tại nếu đã bán, kèm ghi chú nếu bạn dự kiến tăng. Dùng giá dự kiến cao hơn nhiều so với giá đang bán là điểm người đọc sẽ chất vấn.',
      },
      {
        q: 'Có nên trình bày cả cách từ trên xuống không?',
        a: 'Có thể, như một cách đối chiếu. Nhưng cách từ dưới lên phải là cách chính, và hai con số nên gần nhau. Nếu chênh nhau nhiều lần thì có gì đó cần xem lại.',
      },
    ],
  },

  'deal-flow': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Deal flow là dòng hồ sơ đầu tư mà một quỹ tiếp nhận và sàng lọc. Hiểu cách nó vận hành giúp bạn biết hồ sơ của mình đang đi qua những bước nào.',
        ],
      },
      {
        h: 'Một hồ sơ đi qua những gì',
        p: [
          'Tiếp nhận: qua giới thiệu, kênh nộp công khai, hoặc quỹ chủ động tìm tới. Hồ sơ qua giới thiệu được ưu tiên đọc trước.',
          'Sàng lọc nhanh: một người trong đội đọc và quyết định có đáng gặp không. Bước này thường chỉ vài phút cho mỗi hồ sơ.',
          'Cuộc gặp đầu: ba mươi tới sáu mươi phút, chủ yếu để hiểu đội ngũ và bài toán.',
          'Các cuộc gặp sâu hơn, thẩm định sơ bộ, rồi trình hội đồng đầu tư.',
          'Term sheet, thẩm định đầy đủ, và đóng vòng.',
        ],
      },
      {
        h: 'Vì sao tỷ lệ đồng ý rất thấp',
        p: [
          'Một quỹ có thể nhận hàng trăm hồ sơ mỗi năm và đầu tư vài khoản. Phần lớn hồ sơ bị loại ở bước sàng lọc nhanh vì không hợp khẩu vị, không phải vì kém.',
          'Điều đó có nghĩa: bị từ chối sớm thường là vấn đề về sự phù hợp, không phải về chất lượng doanh nghiệp.',
          'Và nó giải thích vì sao tiếp cận có chọn lọc hiệu quả hơn gửi hàng loạt. Bạn đang cạnh tranh với hàng trăm hồ sơ khác để giành vài phút đọc.',
        ],
      },
      {
        h: 'Cách tận dụng hiểu biết này',
        p: [
          'Làm cho bước sàng lọc nhanh trở nên dễ. Email và deck phải trả lời ngay: làm gì, cho ai, bằng chứng gì, gọi bao nhiêu.',
          'Đảm bảo hồ sơ khớp khẩu vị trước khi gửi. Đây là bộ lọc mạnh nhất và bạn kiểm tra được trước.',
          'Ưu tiên giới thiệu qua người quen, vì nó đưa bạn vượt qua bước đầu tiên.',
        ],
      },
    ],
    faq: [
      {
        q: 'Gửi qua kênh công khai có được đọc không?',
        a: 'Nhiều quỹ thực sự đọc, nhất là quỹ giai đoạn sớm. Nhưng thời gian phản hồi lâu hơn và tỷ lệ thấp hơn so với qua giới thiệu.',
      },
      {
        q: 'Bao lâu thì nên theo dõi lại?',
        a: 'Một tới hai tuần sau khi gửi là hợp lý. Một lần nhắc lại lịch sự là bình thường; nhiều hơn thì phản tác dụng.',
      },
      {
        q: 'Quỹ có chủ động tìm doanh nghiệp không?',
        a: 'Có, và đó là lý do việc hiện diện trong cộng đồng có giá trị. Nhiều thương vụ bắt đầu từ việc quỹ nghe tên bạn trước khi bạn liên hệ.',
      },
    ],
  },

  'exit-la-gi': {
    body: [
      {
        h: 'Nói ngắn gọn',
        p: [
          'Exit là thời điểm nhà đầu tư thu hồi vốn, thường qua việc công ty được bán lại hoặc niêm yết trên sàn chứng khoán.',
          'Đây là cách duy nhất nhà đầu tư mạo hiểm thực sự có lãi, nên nó chi phối cách họ nhìn mọi khoản đầu tư.',
        ],
      },
      {
        h: 'Vì sao người sáng lập nên hiểu điều này',
        p: [
          'Quỹ có vòng đời, thường mười năm. Họ cần thu hồi vốn trong khoảng đó, nên mọi khoản đầu tư phải có đường đi tới exit.',
          'Điều này giải thích vì sao họ hỏi về quy mô thị trường và tốc độ tăng trưởng nhiều tới vậy. Một doanh nghiệp ổn định sinh lời đều đặn không tạo ra exit, nên không phù hợp với mô hình của họ.',
          'Biết điều đó sớm giúp bạn chọn đúng nguồn vốn, thay vì mất một năm gõ cửa những nơi không bao giờ phù hợp.',
        ],
      },
      {
        h: 'Các hình thức thường gặp',
        p: [
          'Bán lại cho một doanh nghiệp lớn hơn. Đây là hình thức phổ biến nhất, đặc biệt ở thị trường Việt Nam.',
          'Bán lại cho một quỹ khác, thường ở giai đoạn muộn hơn.',
          'Niêm yết trên sàn chứng khoán. Hiếm và đòi hỏi quy mô rất lớn.',
          'Người sáng lập mua lại phần của nhà đầu tư. Ít gặp nhưng có, thường khi doanh nghiệp tạo ra đủ dòng tiền.',
        ],
      },
      {
        h: 'Điều cần nhớ ở giai đoạn sớm',
        p: [
          'Không nên nói quá nhiều về exit trong pitch deck vòng pre-seed. Nó còn quá xa và dễ nghe như đang bán một câu chuyện.',
          'Nhưng nên biết điều khoản nào ảnh hưởng tới số tiền bạn nhận khi exit, đặc biệt là quyền ưu tiên thanh toán.',
          'Và nên hiểu rằng một thương vụ bán ở mức vừa phải có thể không mang lại gì cho người sáng lập, nếu cấu trúc vốn đã tích tụ quá nhiều phần ưu tiên.',
        ],
      },
    ],
    faq: [
      {
        q: 'Bao lâu thì thường có exit?',
        a: 'Thường bảy tới mười năm từ vòng đầu tiên, và nhiều trường hợp lâu hơn. Đây là chặng đường dài, nên việc chọn nhà đầu tư đi cùng quan trọng hơn nhiều người nghĩ.',
      },
      {
        q: 'Không muốn bán công ty thì sao?',
        a: 'Đó là lựa chọn hợp lý, nhưng nên nói rõ với nhà đầu tư trước khi nhận vốn. Kỳ vọng lệch nhau về điểm này là nguồn gốc của mâu thuẫn lớn về sau.',
      },
      {
        q: 'Người sáng lập có bán được cổ phần trước exit không?',
        a: 'Đôi khi có, ở các vòng sau khi nhà đầu tư mới đồng ý mua lại một phần. Nhưng thường bị hạn chế trong điều lệ và thoả thuận cổ đông.',
      },
    ],
  },
};

/* Bản viết lại dày hơn cho các trang đang có lượt hiển thị, và các thuật ngữ
   bổ sung. Tách file cho dễ đọc; gộp vào đây để mọi nơi chỉ đọc một nguồn. */
Object.assign(NOI_DUNG, VIET_LAI, NOI_DUNG_MOI);

/** Trang đã có nội dung thì coi như đã xuất bản. */
export function daViet(slug) {
  return Object.prototype.hasOwnProperty.call(NOI_DUNG, slug);
}

export function noiDungTheoSlug(slug) {
  return NOI_DUNG[slug] || null;
}
